const _excluded = ["window"],
  _excluded2 = ["window"],
  _excluded3 = ["window", "immediate"],
  _excluded4 = ["now"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { noop, makeDestructurable, camelize, toValue, isClient, isObject, tryOnScopeDispose, isIOS, tryOnMounted, notNullish, objectOmit, promiseTimeout, until, increaseWithUnit, objectEntries, createSingletonPromise, useTimeoutFn, pausableWatch, toRef, createEventHook, computedWithControl, timestamp, pausableFilter, watchIgnorable, debounceFilter, createFilterWrapper, bypassFilter, toRefs, useIntervalFn, containsProp, hasOwn, throttleFilter, useDebounceFn, useThrottleFn, clamp, syncRef, objectPick, tryOnUnmounted, watchWithFilter, tryOnBeforeUnmount, identity, isDef, isWorker } from '@vueuse/shared';
export * from '@vueuse/shared';
import { isRef, ref, shallowRef, watchEffect, computed, inject, isVue3, version, defineComponent, h, TransitionGroup, shallowReactive, Fragment, watch, getCurrentInstance, customRef, onUpdated, onMounted, isVue2, readonly, nextTick, reactive, markRaw, unref, getCurrentScope, set as _set, del, isReadonly, onBeforeUpdate } from 'vue-demi';
function computedAsync(evaluationCallback, initialState, optionsOrRef) {
  let options;
  if (isRef(optionsOrRef)) {
    options = {
      evaluating: optionsOrRef
    };
  } else {
    options = optionsOrRef || {};
  }
  const _options2 = options,
    _options2$lazy = _options2.lazy,
    lazy = _options2$lazy === void 0 ? false : _options2$lazy,
    _options2$evaluating = _options2.evaluating,
    evaluating = _options2$evaluating === void 0 ? void 0 : _options2$evaluating,
    _options2$shallow = _options2.shallow,
    shallow = _options2$shallow === void 0 ? true : _options2$shallow,
    _options2$onError = _options2.onError,
    onError = _options2$onError === void 0 ? noop : _options2$onError;
  const started = ref(!lazy);
  const current = shallow ? shallowRef(initialState) : ref(initialState);
  let counter = 0;
  watchEffect(async onInvalidate => {
    if (!started.value) return;
    counter++;
    const counterAtBeginning = counter;
    let hasFinished = false;
    if (evaluating) {
      Promise.resolve().then(() => {
        evaluating.value = true;
      });
    }
    try {
      const result = await evaluationCallback(cancelCallback => {
        onInvalidate(() => {
          if (evaluating) evaluating.value = false;
          if (!hasFinished) cancelCallback();
        });
      });
      if (counterAtBeginning === counter) current.value = result;
    } catch (e) {
      onError(e);
    } finally {
      if (evaluating && counterAtBeginning === counter) evaluating.value = false;
      hasFinished = true;
    }
  });
  if (lazy) {
    return computed(() => {
      started.value = true;
      return current.value;
    });
  } else {
    return current;
  }
}
function computedInject(key, options, defaultSource, treatDefaultAsFactory) {
  let source = inject(key);
  if (defaultSource) source = inject(key, defaultSource);
  if (treatDefaultAsFactory) source = inject(key, defaultSource, treatDefaultAsFactory);
  if (typeof options === "function") {
    return computed(ctx => options(source, ctx));
  } else {
    return computed({
      get: ctx => options.get(source, ctx),
      set: options.set
    });
  }
}
function createReusableTemplate() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!isVue3 && !version.startsWith("2.7.")) {
    if (process.env.NODE_ENV !== "production") throw new Error("[VueUse] createReusableTemplate only works in Vue 2.7 or above.");
    return;
  }
  const _options$inheritAttrs = options.inheritAttrs,
    inheritAttrs = _options$inheritAttrs === void 0 ? true : _options$inheritAttrs;
  const render = shallowRef();
  const define = /* #__PURE__ */defineComponent({
    setup(_, _ref) {
      let slots = _ref.slots;
      return () => {
        render.value = slots.default;
      };
    }
  });
  const reuse = /* #__PURE__ */defineComponent({
    inheritAttrs,
    setup(_, _ref2) {
      let attrs = _ref2.attrs,
        slots = _ref2.slots;
      return () => {
        var _a;
        if (!render.value && process.env.NODE_ENV !== "production") throw new Error("[VueUse] Failed to find the definition of reusable template");
        const vnode = (_a = render.value) == null ? void 0 : _a.call(render, _objectSpread(_objectSpread({}, keysToCamelKebabCase(attrs)), {}, {
          $slots: slots
        }));
        return inheritAttrs && (vnode == null ? void 0 : vnode.length) === 1 ? vnode[0] : vnode;
      };
    }
  });
  return makeDestructurable({
    define,
    reuse
  }, [define, reuse]);
}
function keysToCamelKebabCase(obj) {
  const newObj = {};
  for (const key in obj) newObj[camelize(key)] = obj[key];
  return newObj;
}
function createTemplatePromise() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!isVue3) {
    if (process.env.NODE_ENV !== "production") throw new Error("[VueUse] createTemplatePromise only works in Vue 3 or above.");
    return;
  }
  let index = 0;
  const instances = ref([]);
  function create() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const props = shallowReactive({
      key: index++,
      args,
      promise: void 0,
      resolve: () => {},
      reject: () => {},
      isResolving: false,
      options
    });
    instances.value.push(props);
    props.promise = new Promise((_resolve, _reject) => {
      props.resolve = v => {
        props.isResolving = true;
        return _resolve(v);
      };
      props.reject = _reject;
    }).finally(() => {
      props.promise = void 0;
      const index2 = instances.value.indexOf(props);
      if (index2 !== -1) instances.value.splice(index2, 1);
    });
    return props.promise;
  }
  function start() {
    if (options.singleton && instances.value.length > 0) return instances.value[0].promise;
    return create(...arguments);
  }
  const component = /* #__PURE__ */defineComponent((_, _ref3) => {
    let slots = _ref3.slots;
    const renderList = () => instances.value.map(props => {
      var _a;
      return h(Fragment, {
        key: props.key
      }, (_a = slots.default) == null ? void 0 : _a.call(slots, props));
    });
    if (options.transition) return () => h(TransitionGroup, options.transition, renderList);
    return renderList;
  });
  component.start = start;
  return component;
}
function createUnrefFn(fn) {
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return fn.apply(this, args.map(i => toValue(i)));
  };
}
function unrefElement(elRef) {
  var _a;
  const plain = toValue(elRef);
  return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
const defaultWindow = isClient ? window : void 0;
const defaultDocument = isClient ? window.document : void 0;
const defaultNavigator = isClient ? window.navigator : void 0;
const defaultLocation = isClient ? window.location : void 0;
function useEventListener() {
  let target;
  let events;
  let listeners;
  let options;
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  if (typeof args[0] === "string" || Array.isArray(args[0])) {
    events = args[0];
    listeners = args[1];
    options = args[2];
    target = defaultWindow;
  } else {
    target = args[0];
    events = args[1];
    listeners = args[2];
    options = args[3];
  }
  if (!target) return noop;
  if (!Array.isArray(events)) events = [events];
  if (!Array.isArray(listeners)) listeners = [listeners];
  const cleanups = [];
  const cleanup = () => {
    cleanups.forEach(fn => fn());
    cleanups.length = 0;
  };
  const register = (el, event, listener, options2) => {
    el.addEventListener(event, listener, options2);
    return () => el.removeEventListener(event, listener, options2);
  };
  const stopWatch = watch(() => [unrefElement(target), toValue(options)], _ref4 => {
    let _ref5 = _slicedToArray(_ref4, 2),
      el = _ref5[0],
      options2 = _ref5[1];
    cleanup();
    if (!el) return;
    const optionsClone = isObject(options2) ? _objectSpread({}, options2) : options2;
    cleanups.push(...events.flatMap(event => {
      return listeners.map(listener => register(el, event, listener, optionsClone));
    }));
  }, {
    immediate: true,
    flush: "post"
  });
  const stop = () => {
    stopWatch();
    cleanup();
  };
  tryOnScopeDispose(stop);
  return stop;
}
let _iOSWorkaround = false;
function onClickOutside(target, handler) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _options$window = options.window,
    window = _options$window === void 0 ? defaultWindow : _options$window,
    _options$ignore = options.ignore,
    ignore = _options$ignore === void 0 ? [] : _options$ignore,
    _options$capture = options.capture,
    capture = _options$capture === void 0 ? true : _options$capture,
    _options$detectIframe = options.detectIframe,
    detectIframe = _options$detectIframe === void 0 ? false : _options$detectIframe;
  if (!window) return noop;
  if (isIOS && !_iOSWorkaround) {
    _iOSWorkaround = true;
    Array.from(window.document.body.children).forEach(el => el.addEventListener("click", noop));
    window.document.documentElement.addEventListener("click", noop);
  }
  let shouldListen = true;
  const shouldIgnore = event => {
    return ignore.some(target2 => {
      if (typeof target2 === "string") {
        return Array.from(window.document.querySelectorAll(target2)).some(el => el === event.target || event.composedPath().includes(el));
      } else {
        const el = unrefElement(target2);
        return el && (event.target === el || event.composedPath().includes(el));
      }
    });
  };
  const listener = event => {
    const el = unrefElement(target);
    if (!el || el === event.target || event.composedPath().includes(el)) return;
    if (event.detail === 0) shouldListen = !shouldIgnore(event);
    if (!shouldListen) {
      shouldListen = true;
      return;
    }
    handler(event);
  };
  const cleanup = [useEventListener(window, "click", listener, {
    passive: true,
    capture
  }), useEventListener(window, "pointerdown", e => {
    const el = unrefElement(target);
    shouldListen = !shouldIgnore(e) && !!(el && !e.composedPath().includes(el));
  }, {
    passive: true
  }), detectIframe && useEventListener(window, "blur", event => {
    setTimeout(() => {
      var _a;
      const el = unrefElement(target);
      if (((_a = window.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window.document.activeElement))) {
        handler(event);
      }
    }, 0);
  })].filter(Boolean);
  const stop = () => cleanup.forEach(fn => fn());
  return stop;
}
function createKeyPredicate(keyFilter) {
  if (typeof keyFilter === "function") return keyFilter;else if (typeof keyFilter === "string") return event => event.key === keyFilter;else if (Array.isArray(keyFilter)) return event => keyFilter.includes(event.key);
  return () => true;
}
function onKeyStroke() {
  let key;
  let handler;
  let options = {};
  if (arguments.length === 3) {
    key = arguments.length <= 0 ? undefined : arguments[0];
    handler = arguments.length <= 1 ? undefined : arguments[1];
    options = arguments.length <= 2 ? undefined : arguments[2];
  } else if (arguments.length === 2) {
    if (typeof (arguments.length <= 1 ? undefined : arguments[1]) === "object") {
      key = true;
      handler = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
    } else {
      key = arguments.length <= 0 ? undefined : arguments[0];
      handler = arguments.length <= 1 ? undefined : arguments[1];
    }
  } else {
    key = true;
    handler = arguments.length <= 0 ? undefined : arguments[0];
  }
  const _options3 = options,
    _options3$target = _options3.target,
    target = _options3$target === void 0 ? defaultWindow : _options3$target,
    _options3$eventName = _options3.eventName,
    eventName = _options3$eventName === void 0 ? "keydown" : _options3$eventName,
    _options3$passive = _options3.passive,
    passive = _options3$passive === void 0 ? false : _options3$passive,
    _options3$dedupe = _options3.dedupe,
    dedupe = _options3$dedupe === void 0 ? false : _options3$dedupe;
  const predicate = createKeyPredicate(key);
  const listener = e => {
    if (e.repeat && toValue(dedupe)) return;
    if (predicate(e)) handler(e);
  };
  return useEventListener(target, eventName, listener, passive);
}
function onKeyDown(key, handler) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return onKeyStroke(key, handler, _objectSpread(_objectSpread({}, options), {}, {
    eventName: "keydown"
  }));
}
function onKeyPressed(key, handler) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return onKeyStroke(key, handler, _objectSpread(_objectSpread({}, options), {}, {
    eventName: "keypress"
  }));
}
function onKeyUp(key, handler) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return onKeyStroke(key, handler, _objectSpread(_objectSpread({}, options), {}, {
    eventName: "keyup"
  }));
}
const DEFAULT_DELAY = 500;
const DEFAULT_THRESHOLD = 10;
function onLongPress(target, handler, options) {
  var _a, _b;
  const elementRef = computed(() => unrefElement(target));
  let timeout;
  let posStart;
  let startTimestamp;
  let hasLongPressed = false;
  function clear() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = void 0;
    }
    posStart = void 0;
    startTimestamp = void 0;
    hasLongPressed = false;
  }
  function onRelease(ev) {
    var _a2, _b2, _c;
    const _startTimestamp = startTimestamp,
      _posStart = posStart,
      _hasLongPressed = hasLongPressed;
    clear();
    if (!(options == null ? void 0 : options.onMouseUp) || !_posStart || !_startTimestamp) return;
    if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
    if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
    if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
    const dx = ev.x - _posStart.x;
    const dy = ev.y - _posStart.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    options.onMouseUp(ev.timeStamp - _startTimestamp, distance, _hasLongPressed);
  }
  function onDown(ev) {
    var _a2, _b2, _c, _d;
    if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
    clear();
    if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
    if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
    posStart = {
      x: ev.x,
      y: ev.y
    };
    startTimestamp = ev.timeStamp;
    timeout = setTimeout(() => {
      hasLongPressed = true;
      handler(ev);
    }, (_d = options == null ? void 0 : options.delay) != null ? _d : DEFAULT_DELAY);
  }
  function onMove(ev) {
    var _a2, _b2, _c, _d;
    if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value) return;
    if (!posStart || (options == null ? void 0 : options.distanceThreshold) === false) return;
    if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent) ev.preventDefault();
    if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop) ev.stopPropagation();
    const dx = ev.x - posStart.x;
    const dy = ev.y - posStart.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    if (distance >= ((_d = options == null ? void 0 : options.distanceThreshold) != null ? _d : DEFAULT_THRESHOLD)) clear();
  }
  const listenerOptions = {
    capture: (_a = options == null ? void 0 : options.modifiers) == null ? void 0 : _a.capture,
    once: (_b = options == null ? void 0 : options.modifiers) == null ? void 0 : _b.once
  };
  const cleanup = [useEventListener(elementRef, "pointerdown", onDown, listenerOptions), useEventListener(elementRef, "pointermove", onMove, listenerOptions), useEventListener(elementRef, ["pointerup", "pointerleave"], onRelease, listenerOptions)];
  const stop = () => cleanup.forEach(fn => fn());
  return stop;
}
function isFocusedElementEditable() {
  const _document = document,
    activeElement = _document.activeElement,
    body = _document.body;
  if (!activeElement) return false;
  if (activeElement === body) return false;
  switch (activeElement.tagName) {
    case "INPUT":
    case "TEXTAREA":
      return true;
  }
  return activeElement.hasAttribute("contenteditable");
}
function isTypedCharValid(_ref6) {
  let keyCode = _ref6.keyCode,
    metaKey = _ref6.metaKey,
    ctrlKey = _ref6.ctrlKey,
    altKey = _ref6.altKey;
  if (metaKey || ctrlKey || altKey) return false;
  if (keyCode >= 48 && keyCode <= 57) return true;
  if (keyCode >= 65 && keyCode <= 90) return true;
  if (keyCode >= 97 && keyCode <= 122) return true;
  return false;
}
function onStartTyping(callback) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$document = options.document,
    document2 = _options$document === void 0 ? defaultDocument : _options$document;
  const keydown = event => {
    !isFocusedElementEditable() && isTypedCharValid(event) && callback(event);
  };
  if (document2) useEventListener(document2, "keydown", keydown, {
    passive: true
  });
}
function templateRef(key) {
  let initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const instance = getCurrentInstance();
  let _trigger = () => {};
  const element = customRef((track, trigger) => {
    _trigger = trigger;
    return {
      get() {
        var _a, _b;
        track();
        return (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$refs[key]) != null ? _b : initialValue;
      },
      set() {}
    };
  });
  tryOnMounted(_trigger);
  onUpdated(_trigger);
  return element;
}
function useMounted() {
  const isMounted = ref(false);
  const instance = getCurrentInstance();
  if (instance) {
    onMounted(() => {
      isMounted.value = true;
    }, isVue2 ? void 0 : instance);
  }
  return isMounted;
}
function useSupported(callback) {
  const isMounted = useMounted();
  return computed(() => {
    isMounted.value;
    return Boolean(callback());
  });
}
function useMutationObserver(target, callback) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _options$window2 = options.window,
    window = _options$window2 === void 0 ? defaultWindow : _options$window2,
    mutationOptions = _objectWithoutProperties(options, _excluded);
  let observer;
  const isSupported = useSupported(() => window && "MutationObserver" in window);
  const cleanup = () => {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  const targets = computed(() => {
    const value = toValue(target);
    const items = (Array.isArray(value) ? value : [value]).map(unrefElement).filter(notNullish);
    return new Set(items);
  });
  const stopWatch = watch(() => targets.value, targets2 => {
    cleanup();
    if (isSupported.value && targets2.size) {
      observer = new MutationObserver(callback);
      targets2.forEach(el => observer.observe(el, mutationOptions));
    }
  }, {
    immediate: true,
    flush: "post"
  });
  const takeRecords = () => {
    return observer == null ? void 0 : observer.takeRecords();
  };
  const stop = () => {
    cleanup();
    stopWatch();
  };
  tryOnScopeDispose(stop);
  return {
    isSupported,
    stop,
    takeRecords
  };
}
function useActiveElement() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  const _options$window3 = options.window,
    window = _options$window3 === void 0 ? defaultWindow : _options$window3,
    _options$deep = options.deep,
    deep = _options$deep === void 0 ? true : _options$deep,
    _options$triggerOnRem = options.triggerOnRemoval,
    triggerOnRemoval = _options$triggerOnRem === void 0 ? false : _options$triggerOnRem;
  const document = (_a = options.document) != null ? _a : window == null ? void 0 : window.document;
  const getDeepActiveElement = () => {
    var _a2;
    let element = document == null ? void 0 : document.activeElement;
    if (deep) {
      while (element == null ? void 0 : element.shadowRoot) element = (_a2 = element == null ? void 0 : element.shadowRoot) == null ? void 0 : _a2.activeElement;
    }
    return element;
  };
  const activeElement = ref();
  const trigger = () => {
    activeElement.value = getDeepActiveElement();
  };
  if (window) {
    useEventListener(window, "blur", event => {
      if (event.relatedTarget !== null) return;
      trigger();
    }, true);
    useEventListener(window, "focus", trigger, true);
  }
  if (triggerOnRemoval) {
    useMutationObserver(document, mutations => {
      mutations.filter(m => m.removedNodes.length).map(n => Array.from(n.removedNodes)).flat().forEach(node => {
        if (node === activeElement.value) trigger();
      });
    }, {
      childList: true,
      subtree: true
    });
  }
  trigger();
  return activeElement;
}
function useRafFn(fn) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$immediate = options.immediate,
    immediate = _options$immediate === void 0 ? true : _options$immediate,
    _options$fpsLimit = options.fpsLimit,
    fpsLimit = _options$fpsLimit === void 0 ? void 0 : _options$fpsLimit,
    _options$window4 = options.window,
    window = _options$window4 === void 0 ? defaultWindow : _options$window4;
  const isActive = ref(false);
  const intervalLimit = fpsLimit ? 1e3 / fpsLimit : null;
  let previousFrameTimestamp = 0;
  let rafId = null;
  function loop(timestamp) {
    if (!isActive.value || !window) return;
    if (!previousFrameTimestamp) previousFrameTimestamp = timestamp;
    const delta = timestamp - previousFrameTimestamp;
    if (intervalLimit && delta < intervalLimit) {
      rafId = window.requestAnimationFrame(loop);
      return;
    }
    previousFrameTimestamp = timestamp;
    fn({
      delta,
      timestamp
    });
    rafId = window.requestAnimationFrame(loop);
  }
  function resume() {
    if (!isActive.value && window) {
      isActive.value = true;
      previousFrameTimestamp = 0;
      rafId = window.requestAnimationFrame(loop);
    }
  }
  function pause() {
    isActive.value = false;
    if (rafId != null && window) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }
  }
  if (immediate) resume();
  tryOnScopeDispose(pause);
  return {
    isActive: readonly(isActive),
    pause,
    resume
  };
}
function useAnimate(target, keyframes, options) {
  let config;
  let animateOptions;
  if (isObject(options)) {
    config = options;
    animateOptions = objectOmit(options, ["window", "immediate", "commitStyles", "persist", "onReady", "onError"]);
  } else {
    config = {
      duration: options
    };
    animateOptions = options;
  }
  const _config = config,
    _config$window = _config.window,
    window = _config$window === void 0 ? defaultWindow : _config$window,
    _config$immediate = _config.immediate,
    immediate = _config$immediate === void 0 ? true : _config$immediate,
    commitStyles = _config.commitStyles,
    persist = _config.persist,
    _config$playbackRate = _config.playbackRate,
    _playbackRate = _config$playbackRate === void 0 ? 1 : _config$playbackRate,
    onReady = _config.onReady,
    _config$onError = _config.onError,
    onError = _config$onError === void 0 ? e => {
      console.error(e);
    } : _config$onError;
  const isSupported = useSupported(() => window && HTMLElement && "animate" in HTMLElement.prototype);
  const animate = shallowRef(void 0);
  const store = shallowReactive({
    startTime: null,
    currentTime: null,
    timeline: null,
    playbackRate: _playbackRate,
    pending: false,
    playState: immediate ? "idle" : "paused",
    replaceState: "active"
  });
  const pending = computed(() => store.pending);
  const playState = computed(() => store.playState);
  const replaceState = computed(() => store.replaceState);
  const startTime = computed({
    get() {
      return store.startTime;
    },
    set(value) {
      store.startTime = value;
      if (animate.value) animate.value.startTime = value;
    }
  });
  const currentTime = computed({
    get() {
      return store.currentTime;
    },
    set(value) {
      store.currentTime = value;
      if (animate.value) {
        animate.value.currentTime = value;
        syncResume();
      }
    }
  });
  const timeline = computed({
    get() {
      return store.timeline;
    },
    set(value) {
      store.timeline = value;
      if (animate.value) animate.value.timeline = value;
    }
  });
  const playbackRate = computed({
    get() {
      return store.playbackRate;
    },
    set(value) {
      store.playbackRate = value;
      if (animate.value) animate.value.playbackRate = value;
    }
  });
  const play = () => {
    if (animate.value) {
      try {
        animate.value.play();
        syncResume();
      } catch (e) {
        syncPause();
        onError(e);
      }
    } else {
      update();
    }
  };
  const pause = () => {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.pause();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  const reverse = () => {
    var _a;
    !animate.value && update();
    try {
      (_a = animate.value) == null ? void 0 : _a.reverse();
      syncResume();
    } catch (e) {
      syncPause();
      onError(e);
    }
  };
  const finish = () => {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.finish();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  const cancel = () => {
    var _a;
    try {
      (_a = animate.value) == null ? void 0 : _a.cancel();
      syncPause();
    } catch (e) {
      onError(e);
    }
  };
  watch(() => unrefElement(target), el => {
    el && update();
  });
  watch(() => keyframes, value => {
    !animate.value && update();
    if (!unrefElement(target) && animate.value) {
      animate.value.effect = new KeyframeEffect(unrefElement(target), toValue(value), animateOptions);
    }
  }, {
    deep: true
  });
  tryOnMounted(() => {
    nextTick(() => update(true));
  });
  tryOnScopeDispose(cancel);
  function update(init) {
    const el = unrefElement(target);
    if (!isSupported.value || !el) return;
    if (!animate.value) animate.value = el.animate(toValue(keyframes), animateOptions);
    if (persist) animate.value.persist();
    if (_playbackRate !== 1) animate.value.playbackRate = _playbackRate;
    if (init && !immediate) animate.value.pause();else syncResume();
    onReady == null ? void 0 : onReady(animate.value);
  }
  useEventListener(animate, ["cancel", "finish", "remove"], syncPause);
  useEventListener(animate, "finish", () => {
    var _a;
    if (commitStyles) (_a = animate.value) == null ? void 0 : _a.commitStyles();
  });
  const _useRafFn = useRafFn(() => {
      if (!animate.value) return;
      store.pending = animate.value.pending;
      store.playState = animate.value.playState;
      store.replaceState = animate.value.replaceState;
      store.startTime = animate.value.startTime;
      store.currentTime = animate.value.currentTime;
      store.timeline = animate.value.timeline;
      store.playbackRate = animate.value.playbackRate;
    }, {
      immediate: false
    }),
    resumeRef = _useRafFn.resume,
    pauseRef = _useRafFn.pause;
  function syncResume() {
    if (isSupported.value) resumeRef();
  }
  function syncPause() {
    if (isSupported.value && window) window.requestAnimationFrame(pauseRef);
  }
  return {
    isSupported,
    animate,
    // actions
    play,
    pause,
    reverse,
    finish,
    cancel,
    // state
    pending,
    playState,
    replaceState,
    startTime,
    currentTime,
    timeline,
    playbackRate
  };
}
function useAsyncQueue(tasks, options) {
  const _ref7 = options || {},
    _ref7$interrupt = _ref7.interrupt,
    interrupt = _ref7$interrupt === void 0 ? true : _ref7$interrupt,
    _ref7$onError = _ref7.onError,
    onError = _ref7$onError === void 0 ? noop : _ref7$onError,
    _ref7$onFinished = _ref7.onFinished,
    onFinished = _ref7$onFinished === void 0 ? noop : _ref7$onFinished,
    signal = _ref7.signal;
  const promiseState = {
    aborted: "aborted",
    fulfilled: "fulfilled",
    pending: "pending",
    rejected: "rejected"
  };
  const initialResult = Array.from(Array.from({
    length: tasks.length
  }), () => ({
    state: promiseState.pending,
    data: null
  }));
  const result = reactive(initialResult);
  const activeIndex = ref(-1);
  if (!tasks || tasks.length === 0) {
    onFinished();
    return {
      activeIndex,
      result
    };
  }
  function updateResult(state, res) {
    activeIndex.value++;
    result[activeIndex.value].data = res;
    result[activeIndex.value].state = state;
  }
  tasks.reduce((prev, curr) => {
    return prev.then(prevRes => {
      var _a;
      if (signal == null ? void 0 : signal.aborted) {
        updateResult(promiseState.aborted, new Error("aborted"));
        return;
      }
      if (((_a = result[activeIndex.value]) == null ? void 0 : _a.state) === promiseState.rejected && interrupt) {
        onFinished();
        return;
      }
      const done = curr(prevRes).then(currentRes => {
        updateResult(promiseState.fulfilled, currentRes);
        activeIndex.value === tasks.length - 1 && onFinished();
        return currentRes;
      });
      if (!signal) return done;
      return Promise.race([done, whenAborted(signal)]);
    }).catch(e => {
      if (signal == null ? void 0 : signal.aborted) {
        updateResult(promiseState.aborted, e);
        return e;
      }
      updateResult(promiseState.rejected, e);
      onError();
      return e;
    });
  }, Promise.resolve());
  return {
    activeIndex,
    result
  };
}
function whenAborted(signal) {
  return new Promise((resolve, reject) => {
    const error = new Error("aborted");
    if (signal.aborted) reject(error);else signal.addEventListener("abort", () => reject(error), {
      once: true
    });
  });
}
function useAsyncState(promise, initialState, options) {
  const _ref8 = options != null ? options : {},
    _ref8$immediate = _ref8.immediate,
    immediate = _ref8$immediate === void 0 ? true : _ref8$immediate,
    _ref8$delay = _ref8.delay,
    delay = _ref8$delay === void 0 ? 0 : _ref8$delay,
    _ref8$onError = _ref8.onError,
    onError = _ref8$onError === void 0 ? noop : _ref8$onError,
    _ref8$onSuccess = _ref8.onSuccess,
    onSuccess = _ref8$onSuccess === void 0 ? noop : _ref8$onSuccess,
    _ref8$resetOnExecute = _ref8.resetOnExecute,
    resetOnExecute = _ref8$resetOnExecute === void 0 ? true : _ref8$resetOnExecute,
    _ref8$shallow = _ref8.shallow,
    shallow = _ref8$shallow === void 0 ? true : _ref8$shallow,
    throwError = _ref8.throwError;
  const state = shallow ? shallowRef(initialState) : ref(initialState);
  const isReady = ref(false);
  const isLoading = ref(false);
  const error = shallowRef(void 0);
  async function execute() {
    let delay2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (resetOnExecute) state.value = initialState;
    error.value = void 0;
    isReady.value = false;
    isLoading.value = true;
    if (delay2 > 0) await promiseTimeout(delay2);
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }
    const _promise = typeof promise === "function" ? promise(...args) : promise;
    try {
      const data = await _promise;
      state.value = data;
      isReady.value = true;
      onSuccess(data);
    } catch (e) {
      error.value = e;
      onError(e);
      if (throwError) throw e;
    } finally {
      isLoading.value = false;
    }
    return state.value;
  }
  if (immediate) execute(delay);
  const shell = {
    state,
    isReady,
    isLoading,
    error,
    execute
  };
  function waitUntilIsLoaded() {
    return new Promise((resolve, reject) => {
      until(isLoading).toBe(false).then(() => resolve(shell)).catch(reject);
    });
  }
  return _objectSpread(_objectSpread({}, shell), {}, {
    then(onFulfilled, onRejected) {
      return waitUntilIsLoaded().then(onFulfilled, onRejected);
    }
  });
}
const defaults = {
  array: v => JSON.stringify(v),
  object: v => JSON.stringify(v),
  set: v => JSON.stringify(Array.from(v)),
  map: v => JSON.stringify(Object.fromEntries(v)),
  null: () => ""
};
function getDefaultSerialization(target) {
  if (!target) return defaults.null;
  if (target instanceof Map) return defaults.map;else if (target instanceof Set) return defaults.set;else if (Array.isArray(target)) return defaults.array;else return defaults.object;
}
function useBase64(target, options) {
  const base64 = ref("");
  const promise = ref();
  function execute() {
    if (!isClient) return;
    promise.value = new Promise((resolve, reject) => {
      try {
        const _target = toValue(target);
        if (_target == null) {
          resolve("");
        } else if (typeof _target === "string") {
          resolve(blobToBase64(new Blob([_target], {
            type: "text/plain"
          })));
        } else if (_target instanceof Blob) {
          resolve(blobToBase64(_target));
        } else if (_target instanceof ArrayBuffer) {
          resolve(window.btoa(String.fromCharCode(...new Uint8Array(_target))));
        } else if (_target instanceof HTMLCanvasElement) {
          resolve(_target.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
        } else if (_target instanceof HTMLImageElement) {
          const img = _target.cloneNode(false);
          img.crossOrigin = "Anonymous";
          imgLoaded(img).then(() => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
          }).catch(reject);
        } else if (typeof _target === "object") {
          const _serializeFn = (options == null ? void 0 : options.serializer) || getDefaultSerialization(_target);
          const serialized = _serializeFn(_target);
          return resolve(blobToBase64(new Blob([serialized], {
            type: "application/json"
          })));
        } else {
          reject(new Error("target is unsupported types"));
        }
      } catch (error) {
        reject(error);
      }
    });
    promise.value.then(res => base64.value = res);
    return promise.value;
  }
  if (isRef(target) || typeof target === "function") watch(target, execute, {
    immediate: true
  });else execute();
  return {
    base64,
    promise,
    execute
  };
}
function imgLoaded(img) {
  return new Promise((resolve, reject) => {
    if (!img.complete) {
      img.onload = () => {
        resolve();
      };
      img.onerror = reject;
    } else {
      resolve();
    }
  });
}
function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = e => {
      resolve(e.target.result);
    };
    fr.onerror = reject;
    fr.readAsDataURL(blob);
  });
}
function useBattery() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$navigator = options.navigator,
    navigator = _options$navigator === void 0 ? defaultNavigator : _options$navigator;
  const events = ["chargingchange", "chargingtimechange", "dischargingtimechange", "levelchange"];
  const isSupported = useSupported(() => navigator && "getBattery" in navigator && typeof navigator.getBattery === "function");
  const charging = ref(false);
  const chargingTime = ref(0);
  const dischargingTime = ref(0);
  const level = ref(1);
  let battery;
  function updateBatteryInfo() {
    charging.value = this.charging;
    chargingTime.value = this.chargingTime || 0;
    dischargingTime.value = this.dischargingTime || 0;
    level.value = this.level;
  }
  if (isSupported.value) {
    navigator.getBattery().then(_battery => {
      battery = _battery;
      updateBatteryInfo.call(battery);
      useEventListener(battery, events, updateBatteryInfo, {
        passive: true
      });
    });
  }
  return {
    isSupported,
    charging,
    chargingTime,
    dischargingTime,
    level
  };
}
function useBluetooth(options) {
  let _ref9 = options || {},
    _ref9$acceptAllDevice = _ref9.acceptAllDevices,
    acceptAllDevices = _ref9$acceptAllDevice === void 0 ? false : _ref9$acceptAllDevice;
  const _ref10 = options || {},
    _ref10$filters = _ref10.filters,
    filters = _ref10$filters === void 0 ? void 0 : _ref10$filters,
    _ref10$optionalServic = _ref10.optionalServices,
    optionalServices = _ref10$optionalServic === void 0 ? void 0 : _ref10$optionalServic,
    _ref10$navigator = _ref10.navigator,
    navigator = _ref10$navigator === void 0 ? defaultNavigator : _ref10$navigator;
  const isSupported = useSupported(() => navigator && "bluetooth" in navigator);
  const device = shallowRef(void 0);
  const error = shallowRef(null);
  watch(device, () => {
    connectToBluetoothGATTServer();
  });
  async function requestDevice() {
    if (!isSupported.value) return;
    error.value = null;
    if (filters && filters.length > 0) acceptAllDevices = false;
    try {
      device.value = await (navigator == null ? void 0 : navigator.bluetooth.requestDevice({
        acceptAllDevices,
        filters,
        optionalServices
      }));
    } catch (err) {
      error.value = err;
    }
  }
  const server = ref();
  const isConnected = computed(() => {
    var _a;
    return ((_a = server.value) == null ? void 0 : _a.connected) || false;
  });
  async function connectToBluetoothGATTServer() {
    error.value = null;
    if (device.value && device.value.gatt) {
      device.value.addEventListener("gattserverdisconnected", () => {});
      try {
        server.value = await device.value.gatt.connect();
      } catch (err) {
        error.value = err;
      }
    }
  }
  tryOnMounted(() => {
    var _a;
    if (device.value) (_a = device.value.gatt) == null ? void 0 : _a.connect();
  });
  tryOnScopeDispose(() => {
    var _a;
    if (device.value) (_a = device.value.gatt) == null ? void 0 : _a.disconnect();
  });
  return {
    isSupported,
    isConnected,
    // Device:
    device,
    requestDevice,
    // Server:
    server,
    // Errors:
    error
  };
}
function useMediaQuery(query) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$window5 = options.window,
    window = _options$window5 === void 0 ? defaultWindow : _options$window5;
  const isSupported = useSupported(() => window && "matchMedia" in window && typeof window.matchMedia === "function");
  let mediaQuery;
  const matches = ref(false);
  const handler = event => {
    matches.value = event.matches;
  };
  const cleanup = () => {
    if (!mediaQuery) return;
    if ("removeEventListener" in mediaQuery) mediaQuery.removeEventListener("change", handler);else mediaQuery.removeListener(handler);
  };
  const stopWatch = watchEffect(() => {
    if (!isSupported.value) return;
    cleanup();
    mediaQuery = window.matchMedia(toValue(query));
    if ("addEventListener" in mediaQuery) mediaQuery.addEventListener("change", handler);else mediaQuery.addListener(handler);
    matches.value = mediaQuery.matches;
  });
  tryOnScopeDispose(() => {
    stopWatch();
    cleanup();
    mediaQuery = void 0;
  });
  return matches;
}
const breakpointsTailwind = {
  "sm": 640,
  "md": 768,
  "lg": 1024,
  "xl": 1280,
  "2xl": 1536
};
const breakpointsBootstrapV5 = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
const breakpointsVuetifyV2 = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1264,
  xl: 1904
};
const breakpointsVuetifyV3 = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
  xxl: 2560
};
const breakpointsVuetify = breakpointsVuetifyV2;
const breakpointsAntDesign = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
};
const breakpointsQuasar = {
  xs: 0,
  sm: 600,
  md: 1024,
  lg: 1440,
  xl: 1920
};
const breakpointsSematic = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop4K: 2560
};
const breakpointsMasterCss = {
  "3xs": 360,
  "2xs": 480,
  "xs": 600,
  "sm": 768,
  "md": 1024,
  "lg": 1280,
  "xl": 1440,
  "2xl": 1600,
  "3xl": 1920,
  "4xl": 2560
};
const breakpointsPrimeFlex = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
function useBreakpoints(breakpoints) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  function getValue(k, delta) {
    let v = toValue(breakpoints[toValue(k)]);
    if (delta != null) v = increaseWithUnit(v, delta);
    if (typeof v === "number") v = "".concat(v, "px");
    return v;
  }
  const _options$window6 = options.window,
    window = _options$window6 === void 0 ? defaultWindow : _options$window6,
    _options$strategy = options.strategy,
    strategy = _options$strategy === void 0 ? "min-width" : _options$strategy;
  function match(query) {
    if (!window) return false;
    return window.matchMedia(query).matches;
  }
  const greaterOrEqual = k => {
    return useMediaQuery(() => "(min-width: ".concat(getValue(k), ")"), options);
  };
  const smallerOrEqual = k => {
    return useMediaQuery(() => "(max-width: ".concat(getValue(k), ")"), options);
  };
  const shortcutMethods = Object.keys(breakpoints).reduce((shortcuts, k) => {
    Object.defineProperty(shortcuts, k, {
      get: () => strategy === "min-width" ? greaterOrEqual(k) : smallerOrEqual(k),
      enumerable: true,
      configurable: true
    });
    return shortcuts;
  }, {});
  function current() {
    const points = Object.keys(breakpoints).map(i => [i, greaterOrEqual(i)]);
    return computed(() => points.filter(_ref11 => {
      let _ref12 = _slicedToArray(_ref11, 2),
        v = _ref12[1];
      return v.value;
    }).map(_ref13 => {
      let _ref14 = _slicedToArray(_ref13, 1),
        k = _ref14[0];
      return k;
    }));
  }
  return Object.assign(shortcutMethods, {
    greaterOrEqual,
    smallerOrEqual,
    greater(k) {
      return useMediaQuery(() => "(min-width: ".concat(getValue(k, 0.1), ")"), options);
    },
    smaller(k) {
      return useMediaQuery(() => "(max-width: ".concat(getValue(k, -0.1), ")"), options);
    },
    between(a, b) {
      return useMediaQuery(() => "(min-width: ".concat(getValue(a), ") and (max-width: ").concat(getValue(b, -0.1), ")"), options);
    },
    isGreater(k) {
      return match("(min-width: ".concat(getValue(k, 0.1), ")"));
    },
    isGreaterOrEqual(k) {
      return match("(min-width: ".concat(getValue(k), ")"));
    },
    isSmaller(k) {
      return match("(max-width: ".concat(getValue(k, -0.1), ")"));
    },
    isSmallerOrEqual(k) {
      return match("(max-width: ".concat(getValue(k), ")"));
    },
    isInBetween(a, b) {
      return match("(min-width: ".concat(getValue(a), ") and (max-width: ").concat(getValue(b, -0.1), ")"));
    },
    current,
    active() {
      const bps = current();
      return computed(() => bps.value.length === 0 ? "" : bps.value.at(-1));
    }
  });
}
function useBroadcastChannel(options) {
  const name = options.name,
    _options$window7 = options.window,
    window = _options$window7 === void 0 ? defaultWindow : _options$window7;
  const isSupported = useSupported(() => window && "BroadcastChannel" in window);
  const isClosed = ref(false);
  const channel = ref();
  const data = ref();
  const error = shallowRef(null);
  const post = data2 => {
    if (channel.value) channel.value.postMessage(data2);
  };
  const close = () => {
    if (channel.value) channel.value.close();
    isClosed.value = true;
  };
  if (isSupported.value) {
    tryOnMounted(() => {
      error.value = null;
      channel.value = new BroadcastChannel(name);
      channel.value.addEventListener("message", e => {
        data.value = e.data;
      }, {
        passive: true
      });
      channel.value.addEventListener("messageerror", e => {
        error.value = e;
      }, {
        passive: true
      });
      channel.value.addEventListener("close", () => {
        isClosed.value = true;
      });
    });
  }
  tryOnScopeDispose(() => {
    close();
  });
  return {
    isSupported,
    channel,
    data,
    post,
    close,
    error,
    isClosed
  };
}
const WRITABLE_PROPERTIES = ["hash", "host", "hostname", "href", "pathname", "port", "protocol", "search"];
function useBrowserLocation() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window8 = options.window,
    window = _options$window8 === void 0 ? defaultWindow : _options$window8;
  const refs = Object.fromEntries(WRITABLE_PROPERTIES.map(key => [key, ref()]));
  for (const _ref15 of objectEntries(refs)) {
    var _ref16 = _slicedToArray(_ref15, 2);
    const key = _ref16[0];
    const ref2 = _ref16[1];
    watch(ref2, value => {
      if (!(window == null ? void 0 : window.location) || window.location[key] === value) return;
      window.location[key] = value;
    });
  }
  const buildState = trigger => {
    var _a;
    const _ref17 = (window == null ? void 0 : window.history) || {},
      state2 = _ref17.state,
      length = _ref17.length;
    const _ref18 = (window == null ? void 0 : window.location) || {},
      origin = _ref18.origin;
    for (const key of WRITABLE_PROPERTIES) refs[key].value = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a[key];
    return reactive(_objectSpread({
      trigger,
      state: state2,
      length,
      origin
    }, refs));
  };
  const state = ref(buildState("load"));
  if (window) {
    useEventListener(window, "popstate", () => state.value = buildState("popstate"), {
      passive: true
    });
    useEventListener(window, "hashchange", () => state.value = buildState("hashchange"), {
      passive: true
    });
  }
  return state;
}
function useCached(refValue) {
  let comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (a, b) => a === b;
  let watchOptions = arguments.length > 2 ? arguments[2] : undefined;
  const cachedValue = ref(refValue.value);
  watch(() => refValue.value, value => {
    if (!comparator(value, cachedValue.value)) cachedValue.value = value;
  }, watchOptions);
  return cachedValue;
}
function usePermission(permissionDesc) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$controls = options.controls,
    controls = _options$controls === void 0 ? false : _options$controls,
    _options$navigator2 = options.navigator,
    navigator = _options$navigator2 === void 0 ? defaultNavigator : _options$navigator2;
  const isSupported = useSupported(() => navigator && "permissions" in navigator);
  let permissionStatus;
  const desc = typeof permissionDesc === "string" ? {
    name: permissionDesc
  } : permissionDesc;
  const state = ref();
  const onChange = () => {
    if (permissionStatus) state.value = permissionStatus.state;
  };
  const query = createSingletonPromise(async () => {
    if (!isSupported.value) return;
    if (!permissionStatus) {
      try {
        permissionStatus = await navigator.permissions.query(desc);
        useEventListener(permissionStatus, "change", onChange);
        onChange();
      } catch (e) {
        state.value = "prompt";
      }
    }
    return permissionStatus;
  });
  query();
  if (controls) {
    return {
      state,
      isSupported,
      query
    };
  } else {
    return state;
  }
}
function useClipboard() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$navigator3 = options.navigator,
    navigator = _options$navigator3 === void 0 ? defaultNavigator : _options$navigator3,
    _options$read = options.read,
    read = _options$read === void 0 ? false : _options$read,
    source = options.source,
    _options$copiedDuring = options.copiedDuring,
    copiedDuring = _options$copiedDuring === void 0 ? 1500 : _options$copiedDuring,
    _options$legacy = options.legacy,
    legacy = _options$legacy === void 0 ? false : _options$legacy;
  const isClipboardApiSupported = useSupported(() => navigator && "clipboard" in navigator);
  const permissionRead = usePermission("clipboard-read");
  const permissionWrite = usePermission("clipboard-write");
  const isSupported = computed(() => isClipboardApiSupported.value || legacy);
  const text = ref("");
  const copied = ref(false);
  const timeout = useTimeoutFn(() => copied.value = false, copiedDuring);
  function updateText() {
    if (isClipboardApiSupported.value && isAllowed(permissionRead.value)) {
      navigator.clipboard.readText().then(value => {
        text.value = value;
      });
    } else {
      text.value = legacyRead();
    }
  }
  if (isSupported.value && read) useEventListener(["copy", "cut"], updateText);
  async function copy() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toValue(source);
    if (isSupported.value && value != null) {
      if (isClipboardApiSupported.value && isAllowed(permissionWrite.value)) await navigator.clipboard.writeText(value);else legacyCopy(value);
      text.value = value;
      copied.value = true;
      timeout.start();
    }
  }
  function legacyCopy(value) {
    const ta = document.createElement("textarea");
    ta.value = value != null ? value : "";
    ta.style.position = "absolute";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
  function legacyRead() {
    var _a, _b, _c;
    return (_c = (_b = (_a = document == null ? void 0 : document.getSelection) == null ? void 0 : _a.call(document)) == null ? void 0 : _b.toString()) != null ? _c : "";
  }
  function isAllowed(status) {
    return status === "granted" || status === "prompt";
  }
  return {
    isSupported,
    text,
    copied,
    copy
  };
}
function useClipboardItems() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$navigator4 = options.navigator,
    navigator = _options$navigator4 === void 0 ? defaultNavigator : _options$navigator4,
    _options$read2 = options.read,
    read = _options$read2 === void 0 ? false : _options$read2,
    source = options.source,
    _options$copiedDuring2 = options.copiedDuring,
    copiedDuring = _options$copiedDuring2 === void 0 ? 1500 : _options$copiedDuring2;
  const isSupported = useSupported(() => navigator && "clipboard" in navigator);
  const content = ref([]);
  const copied = ref(false);
  const timeout = useTimeoutFn(() => copied.value = false, copiedDuring);
  function updateContent() {
    if (isSupported.value) {
      navigator.clipboard.read().then(items => {
        content.value = items;
      });
    }
  }
  if (isSupported.value && read) useEventListener(["copy", "cut"], updateContent);
  async function copy() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toValue(source);
    if (isSupported.value && value != null) {
      await navigator.clipboard.write(value);
      content.value = value;
      copied.value = true;
      timeout.start();
    }
  }
  return {
    isSupported,
    content,
    copied,
    copy
  };
}
function cloneFnJSON(source) {
  return JSON.parse(JSON.stringify(source));
}
function useCloned(source) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const cloned = ref({});
  const manual = options.manual,
    _options$clone = options.clone,
    clone = _options$clone === void 0 ? cloneFnJSON : _options$clone,
    _options$deep2 = options.deep,
    deep = _options$deep2 === void 0 ? true : _options$deep2,
    _options$immediate2 = options.immediate,
    immediate = _options$immediate2 === void 0 ? true : _options$immediate2;
  function sync() {
    cloned.value = clone(toValue(source));
  }
  if (!manual && (isRef(source) || typeof source === "function")) {
    watch(source, sync, _objectSpread(_objectSpread({}, options), {}, {
      deep,
      immediate
    }));
  } else {
    sync();
  }
  return {
    cloned,
    sync
  };
}
const _global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
const globalKey = "__vueuse_ssr_handlers__";
const handlers = /* @__PURE__ */getHandlers();
function getHandlers() {
  if (!(globalKey in _global)) _global[globalKey] = _global[globalKey] || {};
  return _global[globalKey];
}
function getSSRHandler(key, fallback) {
  return handlers[key] || fallback;
}
function setSSRHandler(key, fn) {
  handlers[key] = fn;
}
function guessSerializerType(rawInit) {
  return rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : typeof rawInit === "object" ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
}
const StorageSerializers = {
  boolean: {
    read: v => v === "true",
    write: v => String(v)
  },
  object: {
    read: v => JSON.parse(v),
    write: v => JSON.stringify(v)
  },
  number: {
    read: v => Number.parseFloat(v),
    write: v => String(v)
  },
  any: {
    read: v => v,
    write: v => String(v)
  },
  string: {
    read: v => v,
    write: v => String(v)
  },
  map: {
    read: v => new Map(JSON.parse(v)),
    write: v => JSON.stringify(Array.from(v.entries()))
  },
  set: {
    read: v => new Set(JSON.parse(v)),
    write: v => JSON.stringify(Array.from(v))
  },
  date: {
    read: v => new Date(v),
    write: v => v.toISOString()
  }
};
const customStorageEventName = "vueuse-storage";
function useStorage(key, defaults, storage) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a;
  const _options$flush = options.flush,
    flush = _options$flush === void 0 ? "pre" : _options$flush,
    _options$deep3 = options.deep,
    deep = _options$deep3 === void 0 ? true : _options$deep3,
    _options$listenToStor = options.listenToStorageChanges,
    listenToStorageChanges = _options$listenToStor === void 0 ? true : _options$listenToStor,
    _options$writeDefault = options.writeDefaults,
    writeDefaults = _options$writeDefault === void 0 ? true : _options$writeDefault,
    _options$mergeDefault = options.mergeDefaults,
    mergeDefaults = _options$mergeDefault === void 0 ? false : _options$mergeDefault,
    shallow = options.shallow,
    _options$window9 = options.window,
    window = _options$window9 === void 0 ? defaultWindow : _options$window9,
    eventFilter = options.eventFilter,
    _options$onError = options.onError,
    onError = _options$onError === void 0 ? e => {
      console.error(e);
    } : _options$onError,
    initOnMounted = options.initOnMounted;
  const data = (shallow ? shallowRef : ref)(typeof defaults === "function" ? defaults() : defaults);
  if (!storage) {
    try {
      storage = getSSRHandler("getDefaultStorage", () => {
        var _a2;
        return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
      })();
    } catch (e) {
      onError(e);
    }
  }
  if (!storage) return data;
  const rawInit = toValue(defaults);
  const type = guessSerializerType(rawInit);
  const serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];
  const _pausableWatch = pausableWatch(data, () => write(data.value), {
      flush,
      deep,
      eventFilter
    }),
    pauseWatch = _pausableWatch.pause,
    resumeWatch = _pausableWatch.resume;
  if (window && listenToStorageChanges) {
    tryOnMounted(() => {
      useEventListener(window, "storage", update);
      useEventListener(window, customStorageEventName, updateFromCustomEvent);
      if (initOnMounted) update();
    });
  }
  if (!initOnMounted) update();
  function dispatchWriteEvent(oldValue, newValue) {
    if (window) {
      window.dispatchEvent(new CustomEvent(customStorageEventName, {
        detail: {
          key,
          oldValue,
          newValue,
          storageArea: storage
        }
      }));
    }
  }
  function write(v) {
    try {
      const oldValue = storage.getItem(key);
      if (v == null) {
        dispatchWriteEvent(oldValue, null);
        storage.removeItem(key);
      } else {
        const serialized = serializer.write(v);
        if (oldValue !== serialized) {
          storage.setItem(key, serialized);
          dispatchWriteEvent(oldValue, serialized);
        }
      }
    } catch (e) {
      onError(e);
    }
  }
  function read(event) {
    const rawValue = event ? event.newValue : storage.getItem(key);
    if (rawValue == null) {
      if (writeDefaults && rawInit != null) storage.setItem(key, serializer.write(rawInit));
      return rawInit;
    } else if (!event && mergeDefaults) {
      const value = serializer.read(rawValue);
      if (typeof mergeDefaults === "function") return mergeDefaults(value, rawInit);else if (type === "object" && !Array.isArray(value)) return _objectSpread(_objectSpread({}, rawInit), value);
      return value;
    } else if (typeof rawValue !== "string") {
      return rawValue;
    } else {
      return serializer.read(rawValue);
    }
  }
  function update(event) {
    if (event && event.storageArea !== storage) return;
    if (event && event.key == null) {
      data.value = rawInit;
      return;
    }
    if (event && event.key !== key) return;
    pauseWatch();
    try {
      if ((event == null ? void 0 : event.newValue) !== serializer.write(data.value)) data.value = read(event);
    } catch (e) {
      onError(e);
    } finally {
      if (event) nextTick(resumeWatch);else resumeWatch();
    }
  }
  function updateFromCustomEvent(event) {
    update(event.detail);
  }
  return data;
}
function usePreferredDark(options) {
  return useMediaQuery("(prefers-color-scheme: dark)", options);
}
function useColorMode() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$selector = options.selector,
    selector = _options$selector === void 0 ? "html" : _options$selector,
    _options$attribute = options.attribute,
    attribute = _options$attribute === void 0 ? "class" : _options$attribute,
    _options$initialValue = options.initialValue,
    initialValue = _options$initialValue === void 0 ? "auto" : _options$initialValue,
    _options$window10 = options.window,
    window = _options$window10 === void 0 ? defaultWindow : _options$window10,
    storage = options.storage,
    _options$storageKey = options.storageKey,
    storageKey = _options$storageKey === void 0 ? "vueuse-color-scheme" : _options$storageKey,
    _options$listenToStor2 = options.listenToStorageChanges,
    listenToStorageChanges = _options$listenToStor2 === void 0 ? true : _options$listenToStor2,
    storageRef = options.storageRef,
    emitAuto = options.emitAuto,
    _options$disableTrans = options.disableTransition,
    disableTransition = _options$disableTrans === void 0 ? true : _options$disableTrans;
  const modes = _objectSpread({
    auto: "",
    light: "light",
    dark: "dark"
  }, options.modes || {});
  const preferredDark = usePreferredDark({
    window
  });
  const system = computed(() => preferredDark.value ? "dark" : "light");
  const store = storageRef || (storageKey == null ? toRef(initialValue) : useStorage(storageKey, initialValue, storage, {
    window,
    listenToStorageChanges
  }));
  const state = computed(() => store.value === "auto" ? system.value : store.value);
  const updateHTMLAttrs = getSSRHandler("updateHTMLAttrs", (selector2, attribute2, value) => {
    const el = typeof selector2 === "string" ? window == null ? void 0 : window.document.querySelector(selector2) : unrefElement(selector2);
    if (!el) return;
    let style;
    if (disableTransition) {
      style = window.document.createElement("style");
      const styleString = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
      style.appendChild(document.createTextNode(styleString));
      window.document.head.appendChild(style);
    }
    if (attribute2 === "class") {
      const current = value.split(/\s/g);
      Object.values(modes).flatMap(i => (i || "").split(/\s/g)).filter(Boolean).forEach(v => {
        if (current.includes(v)) el.classList.add(v);else el.classList.remove(v);
      });
    } else {
      el.setAttribute(attribute2, value);
    }
    if (disableTransition) {
      window.getComputedStyle(style).opacity;
      document.head.removeChild(style);
    }
  });
  function defaultOnChanged(mode) {
    var _a;
    updateHTMLAttrs(selector, attribute, (_a = modes[mode]) != null ? _a : mode);
  }
  function onChanged(mode) {
    if (options.onChanged) options.onChanged(mode, defaultOnChanged);else defaultOnChanged(mode);
  }
  watch(state, onChanged, {
    flush: "post",
    immediate: true
  });
  tryOnMounted(() => onChanged(state.value));
  const auto = computed({
    get() {
      return emitAuto ? store.value : state.value;
    },
    set(v) {
      store.value = v;
    }
  });
  try {
    return Object.assign(auto, {
      store,
      system,
      state
    });
  } catch (e) {
    return auto;
  }
}
function useConfirmDialog() {
  let revealed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ref(false);
  const confirmHook = createEventHook();
  const cancelHook = createEventHook();
  const revealHook = createEventHook();
  let _resolve = noop;
  const reveal = data => {
    revealHook.trigger(data);
    revealed.value = true;
    return new Promise(resolve => {
      _resolve = resolve;
    });
  };
  const confirm = data => {
    revealed.value = false;
    confirmHook.trigger(data);
    _resolve({
      data,
      isCanceled: false
    });
  };
  const cancel = data => {
    revealed.value = false;
    cancelHook.trigger(data);
    _resolve({
      data,
      isCanceled: true
    });
  };
  return {
    isRevealed: computed(() => revealed.value),
    reveal,
    confirm,
    cancel,
    onReveal: revealHook.on,
    onConfirm: confirmHook.on,
    onCancel: cancelHook.on
  };
}
function useCssVar(prop, target) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _options$window11 = options.window,
    window = _options$window11 === void 0 ? defaultWindow : _options$window11,
    _options$initialValue2 = options.initialValue,
    initialValue = _options$initialValue2 === void 0 ? "" : _options$initialValue2,
    _options$observe = options.observe,
    observe = _options$observe === void 0 ? false : _options$observe;
  const variable = ref(initialValue);
  const elRef = computed(() => {
    var _a;
    return unrefElement(target) || ((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
  });
  function updateCssVar() {
    var _a;
    const key = toValue(prop);
    const el = toValue(elRef);
    if (el && window) {
      const value = (_a = window.getComputedStyle(el).getPropertyValue(key)) == null ? void 0 : _a.trim();
      variable.value = value || initialValue;
    }
  }
  if (observe) {
    useMutationObserver(elRef, updateCssVar, {
      attributeFilter: ["style", "class"],
      window
    });
  }
  watch([elRef, () => toValue(prop)], updateCssVar, {
    immediate: true
  });
  watch(variable, val => {
    var _a;
    if ((_a = elRef.value) == null ? void 0 : _a.style) elRef.value.style.setProperty(toValue(prop), val);
  });
  return variable;
}
function useCurrentElement(rootComponent) {
  const vm = getCurrentInstance();
  const currentElement = computedWithControl(() => null, () => rootComponent ? unrefElement(rootComponent) : vm.proxy.$el);
  onUpdated(currentElement.trigger);
  onMounted(currentElement.trigger);
  return currentElement;
}
function useCycleList(list, options) {
  const state = shallowRef(getInitialValue());
  const listRef = toRef(list);
  const index = computed({
    get() {
      var _a;
      const targetList = listRef.value;
      let index2 = (options == null ? void 0 : options.getIndexOf) ? options.getIndexOf(state.value, targetList) : targetList.indexOf(state.value);
      if (index2 < 0) index2 = (_a = options == null ? void 0 : options.fallbackIndex) != null ? _a : 0;
      return index2;
    },
    set(v) {
      set(v);
    }
  });
  function set(i) {
    const targetList = listRef.value;
    const length = targetList.length;
    const index2 = (i % length + length) % length;
    const value = targetList[index2];
    state.value = value;
    return value;
  }
  function shift() {
    let delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return set(index.value + delta);
  }
  function next() {
    let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return shift(n);
  }
  function prev() {
    let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return shift(-n);
  }
  function getInitialValue() {
    var _a, _b;
    return (_b = toValue((_a = options == null ? void 0 : options.initialValue) != null ? _a : toValue(list)[0])) != null ? _b : void 0;
  }
  watch(listRef, () => set(index.value));
  return {
    state,
    index,
    next,
    prev,
    go: set
  };
}
function useDark() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$valueDark = options.valueDark,
    valueDark = _options$valueDark === void 0 ? "dark" : _options$valueDark,
    _options$valueLight = options.valueLight,
    valueLight = _options$valueLight === void 0 ? "" : _options$valueLight,
    _options$window12 = options.window,
    window = _options$window12 === void 0 ? defaultWindow : _options$window12;
  const mode = useColorMode(_objectSpread(_objectSpread({}, options), {}, {
    onChanged: (mode2, defaultHandler) => {
      var _a;
      if (options.onChanged) (_a = options.onChanged) == null ? void 0 : _a.call(options, mode2 === "dark", defaultHandler, mode2);else defaultHandler(mode2);
    },
    modes: {
      dark: valueDark,
      light: valueLight
    }
  }));
  const system = computed(() => {
    if (mode.system) {
      return mode.system.value;
    } else {
      const preferredDark = usePreferredDark({
        window
      });
      return preferredDark.value ? "dark" : "light";
    }
  });
  const isDark = computed({
    get() {
      return mode.value === "dark";
    },
    set(v) {
      const modeVal = v ? "dark" : "light";
      if (system.value === modeVal) mode.value = "auto";else mode.value = modeVal;
    }
  });
  return isDark;
}
function fnBypass(v) {
  return v;
}
function fnSetSource(source, value) {
  return source.value = value;
}
function defaultDump(clone) {
  return clone ? typeof clone === "function" ? clone : cloneFnJSON : fnBypass;
}
function defaultParse(clone) {
  return clone ? typeof clone === "function" ? clone : cloneFnJSON : fnBypass;
}
function useManualRefHistory(source) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$clone2 = options.clone,
    clone = _options$clone2 === void 0 ? false : _options$clone2,
    _options$dump = options.dump,
    dump = _options$dump === void 0 ? defaultDump(clone) : _options$dump,
    _options$parse = options.parse,
    parse = _options$parse === void 0 ? defaultParse(clone) : _options$parse,
    _options$setSource = options.setSource,
    setSource = _options$setSource === void 0 ? fnSetSource : _options$setSource;
  function _createHistoryRecord() {
    return markRaw({
      snapshot: dump(source.value),
      timestamp: timestamp()
    });
  }
  const last = ref(_createHistoryRecord());
  const undoStack = ref([]);
  const redoStack = ref([]);
  const _setSource = record => {
    setSource(source, parse(record.snapshot));
    last.value = record;
  };
  const commit = () => {
    undoStack.value.unshift(last.value);
    last.value = _createHistoryRecord();
    if (options.capacity && undoStack.value.length > options.capacity) undoStack.value.splice(options.capacity, Number.POSITIVE_INFINITY);
    if (redoStack.value.length) redoStack.value.splice(0, redoStack.value.length);
  };
  const clear = () => {
    undoStack.value.splice(0, undoStack.value.length);
    redoStack.value.splice(0, redoStack.value.length);
  };
  const undo = () => {
    const state = undoStack.value.shift();
    if (state) {
      redoStack.value.unshift(last.value);
      _setSource(state);
    }
  };
  const redo = () => {
    const state = redoStack.value.shift();
    if (state) {
      undoStack.value.unshift(last.value);
      _setSource(state);
    }
  };
  const reset = () => {
    _setSource(last.value);
  };
  const history = computed(() => [last.value, ...undoStack.value]);
  const canUndo = computed(() => undoStack.value.length > 0);
  const canRedo = computed(() => redoStack.value.length > 0);
  return {
    source,
    undoStack,
    redoStack,
    last,
    history,
    canUndo,
    canRedo,
    clear,
    commit,
    reset,
    undo,
    redo
  };
}
function useRefHistory(source) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$deep4 = options.deep,
    deep = _options$deep4 === void 0 ? false : _options$deep4,
    _options$flush2 = options.flush,
    flush = _options$flush2 === void 0 ? "pre" : _options$flush2,
    eventFilter = options.eventFilter;
  const _pausableFilter = pausableFilter(eventFilter),
    composedFilter = _pausableFilter.eventFilter,
    pause = _pausableFilter.pause,
    resumeTracking = _pausableFilter.resume,
    isTracking = _pausableFilter.isActive;
  const _watchIgnorable = watchIgnorable(source, commit, {
      deep,
      flush,
      eventFilter: composedFilter
    }),
    ignoreUpdates = _watchIgnorable.ignoreUpdates,
    ignorePrevAsyncUpdates = _watchIgnorable.ignorePrevAsyncUpdates,
    stop = _watchIgnorable.stop;
  function setSource(source2, value) {
    ignorePrevAsyncUpdates();
    ignoreUpdates(() => {
      source2.value = value;
    });
  }
  const manualHistory = useManualRefHistory(source, _objectSpread(_objectSpread({}, options), {}, {
    clone: options.clone || deep,
    setSource
  }));
  const clear = manualHistory.clear,
    manualCommit = manualHistory.commit;
  function commit() {
    ignorePrevAsyncUpdates();
    manualCommit();
  }
  function resume(commitNow) {
    resumeTracking();
    if (commitNow) commit();
  }
  function batch(fn) {
    let canceled = false;
    const cancel = () => canceled = true;
    ignoreUpdates(() => {
      fn(cancel);
    });
    if (!canceled) commit();
  }
  function dispose() {
    stop();
    clear();
  }
  return _objectSpread(_objectSpread({}, manualHistory), {}, {
    isTracking,
    pause,
    resume,
    commit,
    batch,
    dispose
  });
}
function useDebouncedRefHistory(source) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const filter = options.debounce ? debounceFilter(options.debounce) : void 0;
  const history = useRefHistory(source, _objectSpread(_objectSpread({}, options), {}, {
    eventFilter: filter
  }));
  return _objectSpread({}, history);
}
function useDeviceMotion() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window13 = options.window,
    window = _options$window13 === void 0 ? defaultWindow : _options$window13,
    _options$eventFilter = options.eventFilter,
    eventFilter = _options$eventFilter === void 0 ? bypassFilter : _options$eventFilter;
  const acceleration = ref({
    x: null,
    y: null,
    z: null
  });
  const rotationRate = ref({
    alpha: null,
    beta: null,
    gamma: null
  });
  const interval = ref(0);
  const accelerationIncludingGravity = ref({
    x: null,
    y: null,
    z: null
  });
  if (window) {
    const onDeviceMotion = createFilterWrapper(eventFilter, event => {
      acceleration.value = event.acceleration;
      accelerationIncludingGravity.value = event.accelerationIncludingGravity;
      rotationRate.value = event.rotationRate;
      interval.value = event.interval;
    });
    useEventListener(window, "devicemotion", onDeviceMotion);
  }
  return {
    acceleration,
    accelerationIncludingGravity,
    rotationRate,
    interval
  };
}
function useDeviceOrientation() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window14 = options.window,
    window = _options$window14 === void 0 ? defaultWindow : _options$window14;
  const isSupported = useSupported(() => window && "DeviceOrientationEvent" in window);
  const isAbsolute = ref(false);
  const alpha = ref(null);
  const beta = ref(null);
  const gamma = ref(null);
  if (window && isSupported.value) {
    useEventListener(window, "deviceorientation", event => {
      isAbsolute.value = event.absolute;
      alpha.value = event.alpha;
      beta.value = event.beta;
      gamma.value = event.gamma;
    });
  }
  return {
    isSupported,
    isAbsolute,
    alpha,
    beta,
    gamma
  };
}
function useDevicePixelRatio() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window15 = options.window,
    window = _options$window15 === void 0 ? defaultWindow : _options$window15;
  const pixelRatio = ref(1);
  if (window) {
    let observe2 = function observe2() {
        pixelRatio.value = window.devicePixelRatio;
        cleanup2();
        media = window.matchMedia("(resolution: ".concat(pixelRatio.value, "dppx)"));
        media.addEventListener("change", observe2, {
          once: true
        });
      },
      cleanup2 = function cleanup2() {
        media == null ? void 0 : media.removeEventListener("change", observe2);
      };
    let media;
    observe2();
    tryOnScopeDispose(cleanup2);
  }
  return {
    pixelRatio
  };
}
function useDevicesList() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$navigator5 = options.navigator,
    navigator = _options$navigator5 === void 0 ? defaultNavigator : _options$navigator5,
    _options$requestPermi = options.requestPermissions,
    requestPermissions = _options$requestPermi === void 0 ? false : _options$requestPermi,
    _options$constraints = options.constraints,
    constraints = _options$constraints === void 0 ? {
      audio: true,
      video: true
    } : _options$constraints,
    onUpdated = options.onUpdated;
  const devices = ref([]);
  const videoInputs = computed(() => devices.value.filter(i => i.kind === "videoinput"));
  const audioInputs = computed(() => devices.value.filter(i => i.kind === "audioinput"));
  const audioOutputs = computed(() => devices.value.filter(i => i.kind === "audiooutput"));
  const isSupported = useSupported(() => navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
  const permissionGranted = ref(false);
  let stream;
  async function update() {
    if (!isSupported.value) return;
    devices.value = await navigator.mediaDevices.enumerateDevices();
    onUpdated == null ? void 0 : onUpdated(devices.value);
    if (stream) {
      stream.getTracks().forEach(t => t.stop());
      stream = null;
    }
  }
  async function ensurePermissions() {
    if (!isSupported.value) return false;
    if (permissionGranted.value) return true;
    const _usePermission = usePermission("camera", {
        controls: true
      }),
      state = _usePermission.state,
      query = _usePermission.query;
    await query();
    if (state.value !== "granted") {
      stream = await navigator.mediaDevices.getUserMedia(constraints);
      update();
      permissionGranted.value = true;
    } else {
      permissionGranted.value = true;
    }
    return permissionGranted.value;
  }
  if (isSupported.value) {
    if (requestPermissions) ensurePermissions();
    useEventListener(navigator.mediaDevices, "devicechange", update);
    update();
  }
  return {
    devices,
    ensurePermissions,
    permissionGranted,
    videoInputs,
    audioInputs,
    audioOutputs,
    isSupported
  };
}
function useDisplayMedia() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a;
  const enabled = ref((_a = options.enabled) != null ? _a : false);
  const video = options.video;
  const audio = options.audio;
  const _options$navigator6 = options.navigator,
    navigator = _options$navigator6 === void 0 ? defaultNavigator : _options$navigator6;
  const isSupported = useSupported(() => {
    var _a2;
    return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getDisplayMedia;
  });
  const constraint = {
    audio,
    video
  };
  const stream = shallowRef();
  async function _start() {
    var _a2;
    if (!isSupported.value || stream.value) return;
    stream.value = await navigator.mediaDevices.getDisplayMedia(constraint);
    (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(t => t.addEventListener("ended", stop));
    return stream.value;
  }
  async function _stop() {
    var _a2;
    (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(t => t.stop());
    stream.value = void 0;
  }
  function stop() {
    _stop();
    enabled.value = false;
  }
  async function start() {
    await _start();
    if (stream.value) enabled.value = true;
    return stream.value;
  }
  watch(enabled, v => {
    if (v) _start();else _stop();
  }, {
    immediate: true
  });
  return {
    isSupported,
    stream,
    start,
    stop,
    enabled
  };
}
function useDocumentVisibility() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$document2 = options.document,
    document = _options$document2 === void 0 ? defaultDocument : _options$document2;
  if (!document) return ref("visible");
  const visibility = ref(document.visibilityState);
  useEventListener(document, "visibilitychange", () => {
    visibility.value = document.visibilityState;
  });
  return visibility;
}
function useDraggable(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b;
  const pointerTypes = options.pointerTypes,
    preventDefault = options.preventDefault,
    stopPropagation = options.stopPropagation,
    exact = options.exact,
    onMove = options.onMove,
    onEnd = options.onEnd,
    onStart = options.onStart,
    initialValue = options.initialValue,
    _options$axis = options.axis,
    axis = _options$axis === void 0 ? "both" : _options$axis,
    _options$draggingElem = options.draggingElement,
    draggingElement = _options$draggingElem === void 0 ? defaultWindow : _options$draggingElem,
    containerElement = options.containerElement,
    _options$handle = options.handle,
    draggingHandle = _options$handle === void 0 ? target : _options$handle;
  const position = ref((_a = toValue(initialValue)) != null ? _a : {
    x: 0,
    y: 0
  });
  const pressedDelta = ref();
  const filterEvent = e => {
    if (pointerTypes) return pointerTypes.includes(e.pointerType);
    return true;
  };
  const handleEvent = e => {
    if (toValue(preventDefault)) e.preventDefault();
    if (toValue(stopPropagation)) e.stopPropagation();
  };
  const start = e => {
    var _a2;
    if (e.button !== 0) return;
    if (toValue(options.disabled) || !filterEvent(e)) return;
    if (toValue(exact) && e.target !== toValue(target)) return;
    const container = toValue(containerElement);
    const containerRect = (_a2 = container == null ? void 0 : container.getBoundingClientRect) == null ? void 0 : _a2.call(container);
    const targetRect = toValue(target).getBoundingClientRect();
    const pos = {
      x: e.clientX - (container ? targetRect.left - containerRect.left + container.scrollLeft : targetRect.left),
      y: e.clientY - (container ? targetRect.top - containerRect.top + container.scrollTop : targetRect.top)
    };
    if ((onStart == null ? void 0 : onStart(pos, e)) === false) return;
    pressedDelta.value = pos;
    handleEvent(e);
  };
  const move = e => {
    if (toValue(options.disabled) || !filterEvent(e)) return;
    if (!pressedDelta.value) return;
    const container = toValue(containerElement);
    const targetRect = toValue(target).getBoundingClientRect();
    let _position$value = position.value,
      x = _position$value.x,
      y = _position$value.y;
    if (axis === "x" || axis === "both") {
      x = e.clientX - pressedDelta.value.x;
      if (container) x = Math.min(Math.max(0, x), container.scrollWidth - targetRect.width);
    }
    if (axis === "y" || axis === "both") {
      y = e.clientY - pressedDelta.value.y;
      if (container) y = Math.min(Math.max(0, y), container.scrollHeight - targetRect.height);
    }
    position.value = {
      x,
      y
    };
    onMove == null ? void 0 : onMove(position.value, e);
    handleEvent(e);
  };
  const end = e => {
    if (toValue(options.disabled) || !filterEvent(e)) return;
    if (!pressedDelta.value) return;
    pressedDelta.value = void 0;
    onEnd == null ? void 0 : onEnd(position.value, e);
    handleEvent(e);
  };
  if (isClient) {
    const config = {
      capture: (_b = options.capture) != null ? _b : true
    };
    useEventListener(draggingHandle, "pointerdown", start, config);
    useEventListener(draggingElement, "pointermove", move, config);
    useEventListener(draggingElement, "pointerup", end, config);
  }
  return _objectSpread(_objectSpread({}, toRefs(position)), {}, {
    position,
    isDragging: computed(() => !!pressedDelta.value),
    style: computed(() => "left:".concat(position.value.x, "px;top:").concat(position.value.y, "px;"))
  });
}
function useDropZone(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isOverDropZone = ref(false);
  const files = shallowRef(null);
  let counter = 0;
  let isDataTypeIncluded = true;
  if (isClient) {
    const _options = typeof options === "function" ? {
      onDrop: options
    } : options;
    const getFiles = event => {
      var _a, _b;
      const list = Array.from((_b = (_a = event.dataTransfer) == null ? void 0 : _a.files) != null ? _b : []);
      return files.value = list.length === 0 ? null : list;
    };
    useEventListener(target, "dragenter", event => {
      var _a, _b;
      const types = Array.from(((_a = event == null ? void 0 : event.dataTransfer) == null ? void 0 : _a.items) || []).map(i => i.kind === "file" ? i.type : null).filter(notNullish);
      if (_options.dataTypes && event.dataTransfer) {
        const dataTypes = unref(_options.dataTypes);
        isDataTypeIncluded = typeof dataTypes === "function" ? dataTypes(types) : dataTypes ? dataTypes.some(item => types.includes(item)) : true;
        if (!isDataTypeIncluded) return;
      }
      event.preventDefault();
      counter += 1;
      isOverDropZone.value = true;
      (_b = _options.onEnter) == null ? void 0 : _b.call(_options, getFiles(event), event);
    });
    useEventListener(target, "dragover", event => {
      var _a;
      if (!isDataTypeIncluded) return;
      event.preventDefault();
      (_a = _options.onOver) == null ? void 0 : _a.call(_options, getFiles(event), event);
    });
    useEventListener(target, "dragleave", event => {
      var _a;
      if (!isDataTypeIncluded) return;
      event.preventDefault();
      counter -= 1;
      if (counter === 0) isOverDropZone.value = false;
      (_a = _options.onLeave) == null ? void 0 : _a.call(_options, getFiles(event), event);
    });
    useEventListener(target, "drop", event => {
      var _a;
      event.preventDefault();
      counter = 0;
      isOverDropZone.value = false;
      (_a = _options.onDrop) == null ? void 0 : _a.call(_options, getFiles(event), event);
    });
  }
  return {
    files,
    isOverDropZone
  };
}
function useResizeObserver(target, callback) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _options$window16 = options.window,
    window = _options$window16 === void 0 ? defaultWindow : _options$window16,
    observerOptions = _objectWithoutProperties(options, _excluded2);
  let observer;
  const isSupported = useSupported(() => window && "ResizeObserver" in window);
  const cleanup = () => {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  const targets = computed(() => Array.isArray(target) ? target.map(el => unrefElement(el)) : [unrefElement(target)]);
  const stopWatch = watch(targets, els => {
    cleanup();
    if (isSupported.value && window) {
      observer = new ResizeObserver(callback);
      for (const _el of els) _el && observer.observe(_el, observerOptions);
    }
  }, {
    immediate: true,
    flush: "post"
  });
  const stop = () => {
    cleanup();
    stopWatch();
  };
  tryOnScopeDispose(stop);
  return {
    isSupported,
    stop
  };
}
function useElementBounding(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$reset = options.reset,
    reset = _options$reset === void 0 ? true : _options$reset,
    _options$windowResize = options.windowResize,
    windowResize = _options$windowResize === void 0 ? true : _options$windowResize,
    _options$windowScroll = options.windowScroll,
    windowScroll = _options$windowScroll === void 0 ? true : _options$windowScroll,
    _options$immediate3 = options.immediate,
    immediate = _options$immediate3 === void 0 ? true : _options$immediate3;
  const height = ref(0);
  const bottom = ref(0);
  const left = ref(0);
  const right = ref(0);
  const top = ref(0);
  const width = ref(0);
  const x = ref(0);
  const y = ref(0);
  function update() {
    const el = unrefElement(target);
    if (!el) {
      if (reset) {
        height.value = 0;
        bottom.value = 0;
        left.value = 0;
        right.value = 0;
        top.value = 0;
        width.value = 0;
        x.value = 0;
        y.value = 0;
      }
      return;
    }
    const rect = el.getBoundingClientRect();
    height.value = rect.height;
    bottom.value = rect.bottom;
    left.value = rect.left;
    right.value = rect.right;
    top.value = rect.top;
    width.value = rect.width;
    x.value = rect.x;
    y.value = rect.y;
  }
  useResizeObserver(target, update);
  watch(() => unrefElement(target), ele => !ele && update());
  useMutationObserver(target, update, {
    attributeFilter: ["style", "class"]
  });
  if (windowScroll) useEventListener("scroll", update, {
    capture: true,
    passive: true
  });
  if (windowResize) useEventListener("resize", update, {
    passive: true
  });
  tryOnMounted(() => {
    if (immediate) update();
  });
  return {
    height,
    bottom,
    left,
    right,
    top,
    width,
    x,
    y,
    update
  };
}
function useElementByPoint(options) {
  const x = options.x,
    y = options.y,
    _options$document3 = options.document,
    document = _options$document3 === void 0 ? defaultDocument : _options$document3,
    multiple = options.multiple,
    _options$interval = options.interval,
    interval = _options$interval === void 0 ? "requestAnimationFrame" : _options$interval,
    _options$immediate4 = options.immediate,
    immediate = _options$immediate4 === void 0 ? true : _options$immediate4;
  const isSupported = useSupported(() => {
    if (toValue(multiple)) return document && "elementsFromPoint" in document;
    return document && "elementFromPoint" in document;
  });
  const element = ref(null);
  const cb = () => {
    var _a, _b;
    element.value = toValue(multiple) ? (_a = document == null ? void 0 : document.elementsFromPoint(toValue(x), toValue(y))) != null ? _a : [] : (_b = document == null ? void 0 : document.elementFromPoint(toValue(x), toValue(y))) != null ? _b : null;
  };
  const controls = interval === "requestAnimationFrame" ? useRafFn(cb, {
    immediate
  }) : useIntervalFn(cb, interval, {
    immediate
  });
  return _objectSpread({
    isSupported,
    element
  }, controls);
}
function useElementHover(el) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$delayEnter = options.delayEnter,
    delayEnter = _options$delayEnter === void 0 ? 0 : _options$delayEnter,
    _options$delayLeave = options.delayLeave,
    delayLeave = _options$delayLeave === void 0 ? 0 : _options$delayLeave,
    _options$window17 = options.window,
    window = _options$window17 === void 0 ? defaultWindow : _options$window17;
  const isHovered = ref(false);
  let timer;
  const toggle = entering => {
    const delay = entering ? delayEnter : delayLeave;
    if (timer) {
      clearTimeout(timer);
      timer = void 0;
    }
    if (delay) timer = setTimeout(() => isHovered.value = entering, delay);else isHovered.value = entering;
  };
  if (!window) return isHovered;
  useEventListener(el, "mouseenter", () => toggle(true), {
    passive: true
  });
  useEventListener(el, "mouseleave", () => toggle(false), {
    passive: true
  });
  return isHovered;
}
function useElementSize(target) {
  let initialSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    width: 0,
    height: 0
  };
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _options$window18 = options.window,
    window = _options$window18 === void 0 ? defaultWindow : _options$window18,
    _options$box = options.box,
    box = _options$box === void 0 ? "content-box" : _options$box;
  const isSVG = computed(() => {
    var _a, _b;
    return (_b = (_a = unrefElement(target)) == null ? void 0 : _a.namespaceURI) == null ? void 0 : _b.includes("svg");
  });
  const width = ref(initialSize.width);
  const height = ref(initialSize.height);
  const _useResizeObserver = useResizeObserver(target, _ref19 => {
      let _ref20 = _slicedToArray(_ref19, 1),
        entry = _ref20[0];
      const boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
      if (window && isSVG.value) {
        const $elem = unrefElement(target);
        if ($elem) {
          const rect = $elem.getBoundingClientRect();
          width.value = rect.width;
          height.value = rect.height;
        }
      } else {
        if (boxSize) {
          const formatBoxSize = Array.isArray(boxSize) ? boxSize : [boxSize];
          width.value = formatBoxSize.reduce((acc, _ref21) => {
            let inlineSize = _ref21.inlineSize;
            return acc + inlineSize;
          }, 0);
          height.value = formatBoxSize.reduce((acc, _ref22) => {
            let blockSize = _ref22.blockSize;
            return acc + blockSize;
          }, 0);
        } else {
          width.value = entry.contentRect.width;
          height.value = entry.contentRect.height;
        }
      }
    }, options),
    stop1 = _useResizeObserver.stop;
  tryOnMounted(() => {
    const ele = unrefElement(target);
    if (ele) {
      width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
      height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
    }
  });
  const stop2 = watch(() => unrefElement(target), ele => {
    width.value = ele ? initialSize.width : 0;
    height.value = ele ? initialSize.height : 0;
  });
  function stop() {
    stop1();
    stop2();
  }
  return {
    width,
    height,
    stop
  };
}
function useIntersectionObserver(target, callback) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const root = options.root,
    _options$rootMargin = options.rootMargin,
    rootMargin = _options$rootMargin === void 0 ? "0px" : _options$rootMargin,
    _options$threshold = options.threshold,
    threshold = _options$threshold === void 0 ? 0.1 : _options$threshold,
    _options$window19 = options.window,
    window = _options$window19 === void 0 ? defaultWindow : _options$window19,
    _options$immediate5 = options.immediate,
    immediate = _options$immediate5 === void 0 ? true : _options$immediate5;
  const isSupported = useSupported(() => window && "IntersectionObserver" in window);
  const targets = computed(() => {
    const _target = toValue(target);
    return (Array.isArray(_target) ? _target : [_target]).map(unrefElement).filter(notNullish);
  });
  let cleanup = noop;
  const isActive = ref(immediate);
  const stopWatch = isSupported.value ? watch(() => [targets.value, unrefElement(root), isActive.value], _ref23 => {
    let _ref24 = _slicedToArray(_ref23, 2),
      targets2 = _ref24[0],
      root2 = _ref24[1];
    cleanup();
    if (!isActive.value) return;
    if (!targets2.length) return;
    const observer = new IntersectionObserver(callback, {
      root: unrefElement(root2),
      rootMargin,
      threshold
    });
    targets2.forEach(el => el && observer.observe(el));
    cleanup = () => {
      observer.disconnect();
      cleanup = noop;
    };
  }, {
    immediate,
    flush: "post"
  }) : noop;
  const stop = () => {
    cleanup();
    stopWatch();
    isActive.value = false;
  };
  tryOnScopeDispose(stop);
  return {
    isSupported,
    isActive,
    pause() {
      cleanup();
      isActive.value = false;
    },
    resume() {
      isActive.value = true;
    },
    stop
  };
}
function useElementVisibility(element) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$window20 = options.window,
    window = _options$window20 === void 0 ? defaultWindow : _options$window20,
    scrollTarget = options.scrollTarget,
    _options$threshold2 = options.threshold,
    threshold = _options$threshold2 === void 0 ? 0 : _options$threshold2;
  const elementIsVisible = ref(false);
  useIntersectionObserver(element, intersectionObserverEntries => {
    let isIntersecting = elementIsVisible.value;
    let latestTime = 0;
    for (const entry of intersectionObserverEntries) {
      if (entry.time >= latestTime) {
        latestTime = entry.time;
        isIntersecting = entry.isIntersecting;
      }
    }
    elementIsVisible.value = isIntersecting;
  }, {
    root: scrollTarget,
    window,
    threshold
  });
  return elementIsVisible;
}
const events = /* @__PURE__ */new Map();
function useEventBus(key) {
  const scope = getCurrentScope();
  function on(listener) {
    var _a;
    const listeners = events.get(key) || /* @__PURE__ */new Set();
    listeners.add(listener);
    events.set(key, listeners);
    const _off = () => off(listener);
    (_a = scope == null ? void 0 : scope.cleanups) == null ? void 0 : _a.push(_off);
    return _off;
  }
  function once(listener) {
    function _listener() {
      off(_listener);
      listener(...arguments);
    }
    return on(_listener);
  }
  function off(listener) {
    const listeners = events.get(key);
    if (!listeners) return;
    listeners.delete(listener);
    if (!listeners.size) reset();
  }
  function reset() {
    events.delete(key);
  }
  function emit(event, payload) {
    var _a;
    (_a = events.get(key)) == null ? void 0 : _a.forEach(v => v(event, payload));
  }
  return {
    on,
    once,
    off,
    emit,
    reset
  };
}
function resolveNestedOptions$1(options) {
  if (options === true) return {};
  return options;
}
function useEventSource(url) {
  let events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const event = ref(null);
  const data = ref(null);
  const status = ref("CONNECTING");
  const eventSource = ref(null);
  const error = shallowRef(null);
  const urlRef = toRef(url);
  const lastEventId = shallowRef(null);
  let explicitlyClosed = false;
  let retried = 0;
  const _options$withCredenti = options.withCredentials,
    withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti,
    _options$immediate6 = options.immediate,
    immediate = _options$immediate6 === void 0 ? true : _options$immediate6;
  const close = () => {
    if (isClient && eventSource.value) {
      eventSource.value.close();
      eventSource.value = null;
      status.value = "CLOSED";
      explicitlyClosed = true;
    }
  };
  const _init = () => {
    if (explicitlyClosed || typeof urlRef.value === "undefined") return;
    const es = new EventSource(urlRef.value, {
      withCredentials
    });
    status.value = "CONNECTING";
    eventSource.value = es;
    es.onopen = () => {
      status.value = "OPEN";
      error.value = null;
    };
    es.onerror = e => {
      status.value = "CLOSED";
      error.value = e;
      if (es.readyState === 2 && !explicitlyClosed && options.autoReconnect) {
        es.close();
        const _resolveNestedOptions = resolveNestedOptions$1(options.autoReconnect),
          _resolveNestedOptions2 = _resolveNestedOptions.retries,
          retries = _resolveNestedOptions2 === void 0 ? -1 : _resolveNestedOptions2,
          _resolveNestedOptions3 = _resolveNestedOptions.delay,
          delay = _resolveNestedOptions3 === void 0 ? 1e3 : _resolveNestedOptions3,
          onFailed = _resolveNestedOptions.onFailed;
        retried += 1;
        if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);else if (typeof retries === "function" && retries()) setTimeout(_init, delay);else onFailed == null ? void 0 : onFailed();
      }
    };
    es.onmessage = e => {
      event.value = null;
      data.value = e.data;
      lastEventId.value = e.lastEventId;
    };
    for (const event_name of events) {
      useEventListener(es, event_name, e => {
        event.value = event_name;
        data.value = e.data || null;
      });
    }
  };
  const open = () => {
    if (!isClient) return;
    close();
    explicitlyClosed = false;
    retried = 0;
    _init();
  };
  if (immediate) watch(urlRef, open, {
    immediate: true
  });
  tryOnScopeDispose(close);
  return {
    eventSource,
    event,
    data,
    status,
    error,
    open,
    close,
    lastEventId
  };
}
function useEyeDropper() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$initialValue3 = options.initialValue,
    initialValue = _options$initialValue3 === void 0 ? "" : _options$initialValue3;
  const isSupported = useSupported(() => typeof window !== "undefined" && "EyeDropper" in window);
  const sRGBHex = ref(initialValue);
  async function open(openOptions) {
    if (!isSupported.value) return;
    const eyeDropper = new window.EyeDropper();
    const result = await eyeDropper.open(openOptions);
    sRGBHex.value = result.sRGBHex;
    return result;
  }
  return {
    isSupported,
    sRGBHex,
    open
  };
}
function useFavicon() {
  let newIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$baseUrl = options.baseUrl,
    baseUrl = _options$baseUrl === void 0 ? "" : _options$baseUrl,
    _options$rel = options.rel,
    rel = _options$rel === void 0 ? "icon" : _options$rel,
    _options$document4 = options.document,
    document = _options$document4 === void 0 ? defaultDocument : _options$document4;
  const favicon = toRef(newIcon);
  const applyIcon = icon => {
    const elements = document == null ? void 0 : document.head.querySelectorAll("link[rel*=\"".concat(rel, "\"]"));
    if (!elements || elements.length === 0) {
      const link = document == null ? void 0 : document.createElement("link");
      if (link) {
        link.rel = rel;
        link.href = "".concat(baseUrl).concat(icon);
        link.type = "image/".concat(icon.split(".").pop());
        document == null ? void 0 : document.head.append(link);
      }
      return;
    }
    elements == null ? void 0 : elements.forEach(el => el.href = "".concat(baseUrl).concat(icon));
  };
  watch(favicon, (i, o) => {
    if (typeof i === "string" && i !== o) applyIcon(i);
  }, {
    immediate: true
  });
  return favicon;
}
const payloadMapping = {
  json: "application/json",
  text: "text/plain"
};
function isFetchOptions(obj) {
  return obj && containsProp(obj, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
}
const reAbsolute = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;
function isAbsoluteURL(url) {
  return reAbsolute.test(url);
}
function headersToObject(headers) {
  if (typeof Headers !== "undefined" && headers instanceof Headers) return Object.fromEntries(headers.entries());
  return headers;
}
function combineCallbacks(combination) {
  for (var _len5 = arguments.length, callbacks = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    callbacks[_key5 - 1] = arguments[_key5];
  }
  if (combination === "overwrite") {
    return async ctx => {
      const callback = callbacks[callbacks.length - 1];
      if (callback) return _objectSpread(_objectSpread({}, ctx), await callback(ctx));
      return ctx;
    };
  } else {
    return async ctx => {
      for (const callback of callbacks) {
        if (callback) ctx = _objectSpread(_objectSpread({}, ctx), await callback(ctx));
      }
      return ctx;
    };
  }
}
function createFetch() {
  let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _combination = config.combination || "chain";
  const _options = config.options || {};
  const _fetchOptions = config.fetchOptions || {};
  function useFactoryFetch(url) {
    const computedUrl = computed(() => {
      const baseUrl = toValue(config.baseUrl);
      const targetUrl = toValue(url);
      return baseUrl && !isAbsoluteURL(targetUrl) ? joinPaths(baseUrl, targetUrl) : targetUrl;
    });
    let options = _options;
    let fetchOptions = _fetchOptions;
    for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }
    if (args.length > 0) {
      if (isFetchOptions(args[0])) {
        options = _objectSpread(_objectSpread(_objectSpread({}, options), args[0]), {}, {
          beforeFetch: combineCallbacks(_combination, _options.beforeFetch, args[0].beforeFetch),
          afterFetch: combineCallbacks(_combination, _options.afterFetch, args[0].afterFetch),
          onFetchError: combineCallbacks(_combination, _options.onFetchError, args[0].onFetchError)
        });
      } else {
        fetchOptions = _objectSpread(_objectSpread(_objectSpread({}, fetchOptions), args[0]), {}, {
          headers: _objectSpread(_objectSpread({}, headersToObject(fetchOptions.headers) || {}), headersToObject(args[0].headers) || {})
        });
      }
    }
    if (args.length > 1 && isFetchOptions(args[1])) {
      options = _objectSpread(_objectSpread(_objectSpread({}, options), args[1]), {}, {
        beforeFetch: combineCallbacks(_combination, _options.beforeFetch, args[1].beforeFetch),
        afterFetch: combineCallbacks(_combination, _options.afterFetch, args[1].afterFetch),
        onFetchError: combineCallbacks(_combination, _options.onFetchError, args[1].onFetchError)
      });
    }
    return useFetch(computedUrl, fetchOptions, options);
  }
  return useFactoryFetch;
}
function useFetch(url) {
  var _a;
  const supportsAbort = typeof AbortController === "function";
  let fetchOptions = {};
  let options = {
    immediate: true,
    refetch: false,
    timeout: 0,
    updateDataOnError: false
  };
  const config = {
    method: "GET",
    type: "text",
    payload: void 0
  };
  if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 0) {
    if (isFetchOptions(arguments.length <= 1 ? undefined : arguments[1])) options = _objectSpread(_objectSpread({}, options), arguments.length <= 1 ? undefined : arguments[1]);else fetchOptions = arguments.length <= 1 ? undefined : arguments[1];
  }
  if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1) {
    if (isFetchOptions(arguments.length <= 2 ? undefined : arguments[2])) options = _objectSpread(_objectSpread({}, options), arguments.length <= 2 ? undefined : arguments[2]);
  }
  const _options4 = options,
    _options4$fetch = _options4.fetch,
    fetch = _options4$fetch === void 0 ? (_a = defaultWindow) == null ? void 0 : _a.fetch : _options4$fetch,
    initialData = _options4.initialData,
    timeout = _options4.timeout;
  const responseEvent = createEventHook();
  const errorEvent = createEventHook();
  const finallyEvent = createEventHook();
  const isFinished = ref(false);
  const isFetching = ref(false);
  const aborted = ref(false);
  const statusCode = ref(null);
  const response = shallowRef(null);
  const error = shallowRef(null);
  const data = shallowRef(initialData || null);
  const canAbort = computed(() => supportsAbort && isFetching.value);
  let controller;
  let timer;
  const abort = () => {
    if (supportsAbort) {
      controller == null ? void 0 : controller.abort();
      controller = new AbortController();
      controller.signal.onabort = () => aborted.value = true;
      fetchOptions = _objectSpread(_objectSpread({}, fetchOptions), {}, {
        signal: controller.signal
      });
    }
  };
  const loading = isLoading => {
    isFetching.value = isLoading;
    isFinished.value = !isLoading;
  };
  if (timeout) timer = useTimeoutFn(abort, timeout, {
    immediate: false
  });
  let executeCounter = 0;
  const execute = async function execute() {
    let throwOnFailed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _a2, _b;
    abort();
    loading(true);
    error.value = null;
    statusCode.value = null;
    aborted.value = false;
    executeCounter += 1;
    const currentExecuteCounter = executeCounter;
    const defaultFetchOptions = {
      method: config.method,
      headers: {}
    };
    if (config.payload) {
      const headers = headersToObject(defaultFetchOptions.headers);
      const payload = toValue(config.payload);
      if (!config.payloadType && payload && Object.getPrototypeOf(payload) === Object.prototype && !(payload instanceof FormData)) config.payloadType = "json";
      if (config.payloadType) headers["Content-Type"] = (_a2 = payloadMapping[config.payloadType]) != null ? _a2 : config.payloadType;
      defaultFetchOptions.body = config.payloadType === "json" ? JSON.stringify(payload) : payload;
    }
    let isCanceled = false;
    const context = {
      url: toValue(url),
      options: _objectSpread(_objectSpread({}, defaultFetchOptions), fetchOptions),
      cancel: () => {
        isCanceled = true;
      }
    };
    if (options.beforeFetch) Object.assign(context, await options.beforeFetch(context));
    if (isCanceled || !fetch) {
      loading(false);
      return Promise.resolve(null);
    }
    let responseData = null;
    if (timer) timer.start();
    return fetch(context.url, _objectSpread(_objectSpread(_objectSpread({}, defaultFetchOptions), context.options), {}, {
      headers: _objectSpread(_objectSpread({}, headersToObject(defaultFetchOptions.headers)), headersToObject((_b = context.options) == null ? void 0 : _b.headers))
    })).then(async fetchResponse => {
      response.value = fetchResponse;
      statusCode.value = fetchResponse.status;
      responseData = await fetchResponse.clone()[config.type]();
      if (!fetchResponse.ok) {
        data.value = initialData || null;
        throw new Error(fetchResponse.statusText);
      }
      if (options.afterFetch) {
        var _await$options$afterF = await options.afterFetch({
          data: responseData,
          response: fetchResponse
        });
        responseData = _await$options$afterF.data;
      }
      data.value = responseData;
      responseEvent.trigger(fetchResponse);
      return fetchResponse;
    }).catch(async fetchError => {
      let errorData = fetchError.message || fetchError.name;
      if (options.onFetchError) {
        var _await$options$onFetc = await options.onFetchError({
          data: responseData,
          error: fetchError,
          response: response.value
        });
        errorData = _await$options$onFetc.error;
        responseData = _await$options$onFetc.data;
      }
      error.value = errorData;
      if (options.updateDataOnError) data.value = responseData;
      errorEvent.trigger(fetchError);
      if (throwOnFailed) throw fetchError;
      return null;
    }).finally(() => {
      if (currentExecuteCounter === executeCounter) loading(false);
      if (timer) timer.stop();
      finallyEvent.trigger(null);
    });
  };
  const refetch = toRef(options.refetch);
  watch([refetch, toRef(url)], _ref25 => {
    let _ref26 = _slicedToArray(_ref25, 1),
      refetch2 = _ref26[0];
    return refetch2 && execute();
  }, {
    deep: true
  });
  const shell = {
    isFinished: readonly(isFinished),
    isFetching: readonly(isFetching),
    statusCode,
    response,
    error,
    data,
    canAbort,
    aborted,
    abort,
    execute,
    onFetchResponse: responseEvent.on,
    onFetchError: errorEvent.on,
    onFetchFinally: finallyEvent.on,
    // method
    get: setMethod("GET"),
    put: setMethod("PUT"),
    post: setMethod("POST"),
    delete: setMethod("DELETE"),
    patch: setMethod("PATCH"),
    head: setMethod("HEAD"),
    options: setMethod("OPTIONS"),
    // type
    json: setType("json"),
    text: setType("text"),
    blob: setType("blob"),
    arrayBuffer: setType("arrayBuffer"),
    formData: setType("formData")
  };
  function setMethod(method) {
    return (payload, payloadType) => {
      if (!isFetching.value) {
        config.method = method;
        config.payload = payload;
        config.payloadType = payloadType;
        if (isRef(config.payload)) {
          watch([refetch, toRef(config.payload)], _ref27 => {
            let _ref28 = _slicedToArray(_ref27, 1),
              refetch2 = _ref28[0];
            return refetch2 && execute();
          }, {
            deep: true
          });
        }
        return _objectSpread(_objectSpread({}, shell), {}, {
          then(onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
          }
        });
      }
      return void 0;
    };
  }
  function waitUntilFinished() {
    return new Promise((resolve, reject) => {
      until(isFinished).toBe(true).then(() => resolve(shell)).catch(error2 => reject(error2));
    });
  }
  function setType(type) {
    return () => {
      if (!isFetching.value) {
        config.type = type;
        return _objectSpread(_objectSpread({}, shell), {}, {
          then(onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
          }
        });
      }
      return void 0;
    };
  }
  if (options.immediate) Promise.resolve().then(() => execute());
  return _objectSpread(_objectSpread({}, shell), {}, {
    then(onFulfilled, onRejected) {
      return waitUntilFinished().then(onFulfilled, onRejected);
    }
  });
}
function joinPaths(start, end) {
  if (!start.endsWith("/") && !end.startsWith("/")) return "".concat(start, "/").concat(end);
  return "".concat(start).concat(end);
}
const DEFAULT_OPTIONS = {
  multiple: true,
  accept: "*",
  reset: false,
  directory: false
};
function useFileDialog() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$document5 = options.document,
    document = _options$document5 === void 0 ? defaultDocument : _options$document5;
  const files = ref(null);
  const _createEventHook = createEventHook(),
    onChange = _createEventHook.on,
    trigger = _createEventHook.trigger;
  let input;
  if (document) {
    input = document.createElement("input");
    input.type = "file";
    input.onchange = event => {
      const result = event.target;
      files.value = result.files;
      trigger(files.value);
    };
  }
  const reset = () => {
    files.value = null;
    if (input && input.value) {
      input.value = "";
      trigger(null);
    }
  };
  const open = localOptions => {
    if (!input) return;
    const _options = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options), localOptions);
    input.multiple = _options.multiple;
    input.accept = _options.accept;
    input.webkitdirectory = _options.directory;
    if (hasOwn(_options, "capture")) input.capture = _options.capture;
    if (_options.reset) reset();
    input.click();
  };
  return {
    files: readonly(files),
    open,
    reset,
    onChange
  };
}
function useFileSystemAccess() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window21 = options.window,
    _window = _options$window21 === void 0 ? defaultWindow : _options$window21,
    _options$dataType = options.dataType,
    dataType = _options$dataType === void 0 ? "Text" : _options$dataType;
  const window = _window;
  const isSupported = useSupported(() => window && "showSaveFilePicker" in window && "showOpenFilePicker" in window);
  const fileHandle = ref();
  const data = ref();
  const file = ref();
  const fileName = computed(() => {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.name) != null ? _b : "";
  });
  const fileMIME = computed(() => {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.type) != null ? _b : "";
  });
  const fileSize = computed(() => {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.size) != null ? _b : 0;
  });
  const fileLastModified = computed(() => {
    var _a, _b;
    return (_b = (_a = file.value) == null ? void 0 : _a.lastModified) != null ? _b : 0;
  });
  async function open() {
    let _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isSupported.value) return;
    const _await$window$showOpe = await window.showOpenFilePicker(_objectSpread(_objectSpread({}, toValue(options)), _options)),
      _await$window$showOpe2 = _slicedToArray(_await$window$showOpe, 1),
      handle = _await$window$showOpe2[0];
    fileHandle.value = handle;
    await updateData();
  }
  async function create() {
    let _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isSupported.value) return;
    fileHandle.value = await window.showSaveFilePicker(_objectSpread(_objectSpread({}, options), _options));
    data.value = void 0;
    await updateData();
  }
  async function save() {
    let _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isSupported.value) return;
    if (!fileHandle.value) return saveAs(_options);
    if (data.value) {
      const writableStream = await fileHandle.value.createWritable();
      await writableStream.write(data.value);
      await writableStream.close();
    }
    await updateFile();
  }
  async function saveAs() {
    let _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isSupported.value) return;
    fileHandle.value = await window.showSaveFilePicker(_objectSpread(_objectSpread({}, options), _options));
    if (data.value) {
      const writableStream = await fileHandle.value.createWritable();
      await writableStream.write(data.value);
      await writableStream.close();
    }
    await updateFile();
  }
  async function updateFile() {
    var _a;
    file.value = await ((_a = fileHandle.value) == null ? void 0 : _a.getFile());
  }
  async function updateData() {
    var _a, _b;
    await updateFile();
    const type = toValue(dataType);
    if (type === "Text") data.value = await ((_a = file.value) == null ? void 0 : _a.text());else if (type === "ArrayBuffer") data.value = await ((_b = file.value) == null ? void 0 : _b.arrayBuffer());else if (type === "Blob") data.value = file.value;
  }
  watch(() => toValue(dataType), updateData);
  return {
    isSupported,
    data,
    file,
    fileName,
    fileMIME,
    fileSize,
    fileLastModified,
    open,
    create,
    save,
    saveAs,
    updateData
  };
}
function useFocus(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$initialValue4 = options.initialValue,
    initialValue = _options$initialValue4 === void 0 ? false : _options$initialValue4,
    _options$focusVisible = options.focusVisible,
    focusVisible = _options$focusVisible === void 0 ? false : _options$focusVisible,
    _options$preventScrol = options.preventScroll,
    preventScroll = _options$preventScrol === void 0 ? false : _options$preventScrol;
  const innerFocused = ref(false);
  const targetElement = computed(() => unrefElement(target));
  useEventListener(targetElement, "focus", event => {
    var _a, _b;
    if (!focusVisible || ((_b = (_a = event.target).matches) == null ? void 0 : _b.call(_a, ":focus-visible"))) innerFocused.value = true;
  });
  useEventListener(targetElement, "blur", () => innerFocused.value = false);
  const focused = computed({
    get: () => innerFocused.value,
    set(value) {
      var _a, _b;
      if (!value && innerFocused.value) (_a = targetElement.value) == null ? void 0 : _a.blur();else if (value && !innerFocused.value) (_b = targetElement.value) == null ? void 0 : _b.focus({
        preventScroll
      });
    }
  });
  watch(targetElement, () => {
    focused.value = initialValue;
  }, {
    immediate: true,
    flush: "post"
  });
  return {
    focused
  };
}
function useFocusWithin(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const activeElement = useActiveElement(options);
  const targetElement = computed(() => unrefElement(target));
  const focused = computed(() => targetElement.value && activeElement.value ? targetElement.value.contains(activeElement.value) : false);
  return {
    focused
  };
}
function useFps(options) {
  var _a;
  const fps = ref(0);
  if (typeof performance === "undefined") return fps;
  const every = (_a = options == null ? void 0 : options.every) != null ? _a : 10;
  let last = performance.now();
  let ticks = 0;
  useRafFn(() => {
    ticks += 1;
    if (ticks >= every) {
      const now = performance.now();
      const diff = now - last;
      fps.value = Math.round(1e3 / (diff / ticks));
      last = now;
      ticks = 0;
    }
  });
  return fps;
}
const eventHandlers = ["fullscreenchange", "webkitfullscreenchange", "webkitendfullscreen", "mozfullscreenchange", "MSFullscreenChange"];
function useFullscreen(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$document6 = options.document,
    document = _options$document6 === void 0 ? defaultDocument : _options$document6,
    _options$autoExit = options.autoExit,
    autoExit = _options$autoExit === void 0 ? false : _options$autoExit;
  const targetRef = computed(() => {
    var _a;
    return (_a = unrefElement(target)) != null ? _a : document == null ? void 0 : document.querySelector("html");
  });
  const isFullscreen = ref(false);
  const requestMethod = computed(() => {
    return ["requestFullscreen", "webkitRequestFullscreen", "webkitEnterFullscreen", "webkitEnterFullScreen", "webkitRequestFullScreen", "mozRequestFullScreen", "msRequestFullscreen"].find(m => document && m in document || targetRef.value && m in targetRef.value);
  });
  const exitMethod = computed(() => {
    return ["exitFullscreen", "webkitExitFullscreen", "webkitExitFullScreen", "webkitCancelFullScreen", "mozCancelFullScreen", "msExitFullscreen"].find(m => document && m in document || targetRef.value && m in targetRef.value);
  });
  const fullscreenEnabled = computed(() => {
    return ["fullScreen", "webkitIsFullScreen", "webkitDisplayingFullscreen", "mozFullScreen", "msFullscreenElement"].find(m => document && m in document || targetRef.value && m in targetRef.value);
  });
  const fullscreenElementMethod = ["fullscreenElement", "webkitFullscreenElement", "mozFullScreenElement", "msFullscreenElement"].find(m => document && m in document);
  const isSupported = useSupported(() => targetRef.value && document && requestMethod.value !== void 0 && exitMethod.value !== void 0 && fullscreenEnabled.value !== void 0);
  const isCurrentElementFullScreen = () => {
    if (fullscreenElementMethod) return (document == null ? void 0 : document[fullscreenElementMethod]) === targetRef.value;
    return false;
  };
  const isElementFullScreen = () => {
    if (fullscreenEnabled.value) {
      if (document && document[fullscreenEnabled.value] != null) {
        return document[fullscreenEnabled.value];
      } else {
        const target2 = targetRef.value;
        if ((target2 == null ? void 0 : target2[fullscreenEnabled.value]) != null) {
          return Boolean(target2[fullscreenEnabled.value]);
        }
      }
    }
    return false;
  };
  async function exit() {
    if (!isSupported.value || !isFullscreen.value) return;
    if (exitMethod.value) {
      if ((document == null ? void 0 : document[exitMethod.value]) != null) {
        await document[exitMethod.value]();
      } else {
        const target2 = targetRef.value;
        if ((target2 == null ? void 0 : target2[exitMethod.value]) != null) await target2[exitMethod.value]();
      }
    }
    isFullscreen.value = false;
  }
  async function enter() {
    if (!isSupported.value || isFullscreen.value) return;
    if (isElementFullScreen()) await exit();
    const target2 = targetRef.value;
    if (requestMethod.value && (target2 == null ? void 0 : target2[requestMethod.value]) != null) {
      await target2[requestMethod.value]();
      isFullscreen.value = true;
    }
  }
  async function toggle() {
    await (isFullscreen.value ? exit() : enter());
  }
  const handlerCallback = () => {
    const isElementFullScreenValue = isElementFullScreen();
    if (!isElementFullScreenValue || isElementFullScreenValue && isCurrentElementFullScreen()) isFullscreen.value = isElementFullScreenValue;
  };
  useEventListener(document, eventHandlers, handlerCallback, false);
  useEventListener(() => unrefElement(targetRef), eventHandlers, handlerCallback, false);
  if (autoExit) tryOnScopeDispose(exit);
  return {
    isSupported,
    isFullscreen,
    enter,
    exit,
    toggle
  };
}
function mapGamepadToXbox360Controller(gamepad) {
  return computed(() => {
    if (gamepad.value) {
      return {
        buttons: {
          a: gamepad.value.buttons[0],
          b: gamepad.value.buttons[1],
          x: gamepad.value.buttons[2],
          y: gamepad.value.buttons[3]
        },
        bumper: {
          left: gamepad.value.buttons[4],
          right: gamepad.value.buttons[5]
        },
        triggers: {
          left: gamepad.value.buttons[6],
          right: gamepad.value.buttons[7]
        },
        stick: {
          left: {
            horizontal: gamepad.value.axes[0],
            vertical: gamepad.value.axes[1],
            button: gamepad.value.buttons[10]
          },
          right: {
            horizontal: gamepad.value.axes[2],
            vertical: gamepad.value.axes[3],
            button: gamepad.value.buttons[11]
          }
        },
        dpad: {
          up: gamepad.value.buttons[12],
          down: gamepad.value.buttons[13],
          left: gamepad.value.buttons[14],
          right: gamepad.value.buttons[15]
        },
        back: gamepad.value.buttons[8],
        start: gamepad.value.buttons[9]
      };
    }
    return null;
  });
}
function useGamepad() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$navigator7 = options.navigator,
    navigator = _options$navigator7 === void 0 ? defaultNavigator : _options$navigator7;
  const isSupported = useSupported(() => navigator && "getGamepads" in navigator);
  const gamepads = ref([]);
  const onConnectedHook = createEventHook();
  const onDisconnectedHook = createEventHook();
  const stateFromGamepad = gamepad => {
    const hapticActuators = [];
    const vibrationActuator = "vibrationActuator" in gamepad ? gamepad.vibrationActuator : null;
    if (vibrationActuator) hapticActuators.push(vibrationActuator);
    if (gamepad.hapticActuators) hapticActuators.push(...gamepad.hapticActuators);
    return {
      id: gamepad.id,
      index: gamepad.index,
      connected: gamepad.connected,
      mapping: gamepad.mapping,
      timestamp: gamepad.timestamp,
      vibrationActuator: gamepad.vibrationActuator,
      hapticActuators,
      axes: gamepad.axes.map(axes => axes),
      buttons: gamepad.buttons.map(button => ({
        pressed: button.pressed,
        touched: button.touched,
        value: button.value
      }))
    };
  };
  const updateGamepadState = () => {
    const _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
    for (const gamepad of _gamepads) {
      if (gamepad && gamepads.value[gamepad.index]) gamepads.value[gamepad.index] = stateFromGamepad(gamepad);
    }
  };
  const _useRafFn2 = useRafFn(updateGamepadState),
    isActive = _useRafFn2.isActive,
    pause = _useRafFn2.pause,
    resume = _useRafFn2.resume;
  const onGamepadConnected = gamepad => {
    if (!gamepads.value.some(_ref29 => {
      let index = _ref29.index;
      return index === gamepad.index;
    })) {
      gamepads.value.push(stateFromGamepad(gamepad));
      onConnectedHook.trigger(gamepad.index);
    }
    resume();
  };
  const onGamepadDisconnected = gamepad => {
    gamepads.value = gamepads.value.filter(x => x.index !== gamepad.index);
    onDisconnectedHook.trigger(gamepad.index);
  };
  useEventListener("gamepadconnected", e => onGamepadConnected(e.gamepad));
  useEventListener("gamepaddisconnected", e => onGamepadDisconnected(e.gamepad));
  tryOnMounted(() => {
    const _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
    for (const gamepad of _gamepads) {
      if (gamepad && gamepads.value[gamepad.index]) onGamepadConnected(gamepad);
    }
  });
  pause();
  return {
    isSupported,
    onConnected: onConnectedHook.on,
    onDisconnected: onDisconnectedHook.on,
    gamepads,
    pause,
    resume,
    isActive
  };
}
function useGeolocation() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$enableHighAc = options.enableHighAccuracy,
    enableHighAccuracy = _options$enableHighAc === void 0 ? true : _options$enableHighAc,
    _options$maximumAge = options.maximumAge,
    maximumAge = _options$maximumAge === void 0 ? 3e4 : _options$maximumAge,
    _options$timeout = options.timeout,
    timeout = _options$timeout === void 0 ? 27e3 : _options$timeout,
    _options$navigator8 = options.navigator,
    navigator = _options$navigator8 === void 0 ? defaultNavigator : _options$navigator8,
    _options$immediate7 = options.immediate,
    immediate = _options$immediate7 === void 0 ? true : _options$immediate7;
  const isSupported = useSupported(() => navigator && "geolocation" in navigator);
  const locatedAt = ref(null);
  const error = shallowRef(null);
  const coords = ref({
    accuracy: 0,
    latitude: Number.POSITIVE_INFINITY,
    longitude: Number.POSITIVE_INFINITY,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null
  });
  function updatePosition(position) {
    locatedAt.value = position.timestamp;
    coords.value = position.coords;
    error.value = null;
  }
  let watcher;
  function resume() {
    if (isSupported.value) {
      watcher = navigator.geolocation.watchPosition(updatePosition, err => error.value = err, {
        enableHighAccuracy,
        maximumAge,
        timeout
      });
    }
  }
  if (immediate) resume();
  function pause() {
    if (watcher && navigator) navigator.geolocation.clearWatch(watcher);
  }
  tryOnScopeDispose(() => {
    pause();
  });
  return {
    isSupported,
    coords,
    locatedAt,
    error,
    resume,
    pause
  };
}
const defaultEvents$1 = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"];
const oneMinute = 6e4;
function useIdle() {
  let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : oneMinute;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$initialState = options.initialState,
    initialState = _options$initialState === void 0 ? false : _options$initialState,
    _options$listenForVis = options.listenForVisibilityChange,
    listenForVisibilityChange = _options$listenForVis === void 0 ? true : _options$listenForVis,
    _options$events = options.events,
    events = _options$events === void 0 ? defaultEvents$1 : _options$events,
    _options$window22 = options.window,
    window = _options$window22 === void 0 ? defaultWindow : _options$window22,
    _options$eventFilter2 = options.eventFilter,
    eventFilter = _options$eventFilter2 === void 0 ? throttleFilter(50) : _options$eventFilter2;
  const idle = ref(initialState);
  const lastActive = ref(timestamp());
  let timer;
  const reset = () => {
    idle.value = false;
    clearTimeout(timer);
    timer = setTimeout(() => idle.value = true, timeout);
  };
  const onEvent = createFilterWrapper(eventFilter, () => {
    lastActive.value = timestamp();
    reset();
  });
  if (window) {
    const document = window.document;
    for (const event of events) useEventListener(window, event, onEvent, {
      passive: true
    });
    if (listenForVisibilityChange) {
      useEventListener(document, "visibilitychange", () => {
        if (!document.hidden) onEvent();
      });
    }
    reset();
  }
  return {
    idle,
    lastActive,
    reset
  };
}
async function loadImage(options) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const src = options.src,
      srcset = options.srcset,
      sizes = options.sizes,
      clazz = options.class,
      loading = options.loading,
      crossorigin = options.crossorigin,
      referrerPolicy = options.referrerPolicy;
    img.src = src;
    if (srcset) img.srcset = srcset;
    if (sizes) img.sizes = sizes;
    if (clazz) img.className = clazz;
    if (loading) img.loading = loading;
    if (crossorigin) img.crossOrigin = crossorigin;
    if (referrerPolicy) img.referrerPolicy = referrerPolicy;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
}
function useImage(options) {
  let asyncStateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const state = useAsyncState(() => loadImage(toValue(options)), void 0, _objectSpread({
    resetOnExecute: true
  }, asyncStateOptions));
  watch(() => toValue(options), () => state.execute(asyncStateOptions.delay), {
    deep: true
  });
  return state;
}
const ARRIVED_STATE_THRESHOLD_PIXELS = 1;
function useScroll(element) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$throttle = options.throttle,
    throttle = _options$throttle === void 0 ? 0 : _options$throttle,
    _options$idle = options.idle,
    idle = _options$idle === void 0 ? 200 : _options$idle,
    _options$onStop = options.onStop,
    onStop = _options$onStop === void 0 ? noop : _options$onStop,
    _options$onScroll = options.onScroll,
    onScroll = _options$onScroll === void 0 ? noop : _options$onScroll,
    _options$offset = options.offset,
    offset = _options$offset === void 0 ? {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    } : _options$offset,
    _options$eventListene = options.eventListenerOptions,
    eventListenerOptions = _options$eventListene === void 0 ? {
      capture: false,
      passive: true
    } : _options$eventListene,
    _options$behavior = options.behavior,
    behavior = _options$behavior === void 0 ? "auto" : _options$behavior,
    _options$window23 = options.window,
    window = _options$window23 === void 0 ? defaultWindow : _options$window23,
    _options$onError2 = options.onError,
    onError = _options$onError2 === void 0 ? e => {
      console.error(e);
    } : _options$onError2;
  const internalX = ref(0);
  const internalY = ref(0);
  const x = computed({
    get() {
      return internalX.value;
    },
    set(x2) {
      scrollTo(x2, void 0);
    }
  });
  const y = computed({
    get() {
      return internalY.value;
    },
    set(y2) {
      scrollTo(void 0, y2);
    }
  });
  function scrollTo(_x, _y) {
    var _a, _b, _c, _d;
    if (!window) return;
    const _element = toValue(element);
    if (!_element) return;
    (_c = _element instanceof Document ? window.document.body : _element) == null ? void 0 : _c.scrollTo({
      top: (_a = toValue(_y)) != null ? _a : y.value,
      left: (_b = toValue(_x)) != null ? _b : x.value,
      behavior: toValue(behavior)
    });
    const scrollContainer = ((_d = _element == null ? void 0 : _element.document) == null ? void 0 : _d.documentElement) || (_element == null ? void 0 : _element.documentElement) || _element;
    if (x != null) internalX.value = scrollContainer.scrollLeft;
    if (y != null) internalY.value = scrollContainer.scrollTop;
  }
  const isScrolling = ref(false);
  const arrivedState = reactive({
    left: true,
    right: false,
    top: true,
    bottom: false
  });
  const directions = reactive({
    left: false,
    right: false,
    top: false,
    bottom: false
  });
  const onScrollEnd = e => {
    if (!isScrolling.value) return;
    isScrolling.value = false;
    directions.left = false;
    directions.right = false;
    directions.top = false;
    directions.bottom = false;
    onStop(e);
  };
  const onScrollEndDebounced = useDebounceFn(onScrollEnd, throttle + idle);
  const setArrivedState = target => {
    var _a;
    if (!window) return;
    const el = ((_a = target == null ? void 0 : target.document) == null ? void 0 : _a.documentElement) || (target == null ? void 0 : target.documentElement) || unrefElement(target);
    const _getComputedStyle = getComputedStyle(el),
      display = _getComputedStyle.display,
      flexDirection = _getComputedStyle.flexDirection;
    const scrollLeft = el.scrollLeft;
    directions.left = scrollLeft < internalX.value;
    directions.right = scrollLeft > internalX.value;
    const left = Math.abs(scrollLeft) <= (offset.left || 0);
    const right = Math.abs(scrollLeft) + el.clientWidth >= el.scrollWidth - (offset.right || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
    if (display === "flex" && flexDirection === "row-reverse") {
      arrivedState.left = right;
      arrivedState.right = left;
    } else {
      arrivedState.left = left;
      arrivedState.right = right;
    }
    internalX.value = scrollLeft;
    let scrollTop = el.scrollTop;
    if (target === window.document && !scrollTop) scrollTop = window.document.body.scrollTop;
    directions.top = scrollTop < internalY.value;
    directions.bottom = scrollTop > internalY.value;
    const top = Math.abs(scrollTop) <= (offset.top || 0);
    const bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset.bottom || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
    if (display === "flex" && flexDirection === "column-reverse") {
      arrivedState.top = bottom;
      arrivedState.bottom = top;
    } else {
      arrivedState.top = top;
      arrivedState.bottom = bottom;
    }
    internalY.value = scrollTop;
  };
  const onScrollHandler = e => {
    var _a;
    if (!window) return;
    const eventTarget = (_a = e.target.documentElement) != null ? _a : e.target;
    setArrivedState(eventTarget);
    isScrolling.value = true;
    onScrollEndDebounced(e);
    onScroll(e);
  };
  useEventListener(element, "scroll", throttle ? useThrottleFn(onScrollHandler, throttle, true, false) : onScrollHandler, eventListenerOptions);
  tryOnMounted(() => {
    try {
      const _element = toValue(element);
      if (!_element) return;
      setArrivedState(_element);
    } catch (e) {
      onError(e);
    }
  });
  useEventListener(element, "scrollend", onScrollEnd, eventListenerOptions);
  return {
    x,
    y,
    isScrolling,
    arrivedState,
    directions,
    measure() {
      const _element = toValue(element);
      if (window && _element) setArrivedState(_element);
    }
  };
}
function resolveElement(el) {
  if (typeof Window !== "undefined" && el instanceof Window) return el.document.documentElement;
  if (typeof Document !== "undefined" && el instanceof Document) return el.documentElement;
  return el;
}
function useInfiniteScroll(element, onLoadMore) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a;
  const _options$direction = options.direction,
    direction = _options$direction === void 0 ? "bottom" : _options$direction,
    _options$interval2 = options.interval,
    interval = _options$interval2 === void 0 ? 100 : _options$interval2,
    _options$canLoadMore = options.canLoadMore,
    canLoadMore = _options$canLoadMore === void 0 ? () => true : _options$canLoadMore;
  const state = reactive(useScroll(element, _objectSpread(_objectSpread({}, options), {}, {
    offset: _objectSpread({
      [direction]: (_a = options.distance) != null ? _a : 0
    }, options.offset)
  })));
  const promise = ref();
  const isLoading = computed(() => !!promise.value);
  const observedElement = computed(() => {
    return resolveElement(toValue(element));
  });
  const isElementVisible = useElementVisibility(observedElement);
  function checkAndLoad() {
    state.measure();
    if (!observedElement.value || !isElementVisible.value || !canLoadMore(observedElement.value)) return;
    const _observedElement$valu = observedElement.value,
      scrollHeight = _observedElement$valu.scrollHeight,
      clientHeight = _observedElement$valu.clientHeight,
      scrollWidth = _observedElement$valu.scrollWidth,
      clientWidth = _observedElement$valu.clientWidth;
    const isNarrower = direction === "bottom" || direction === "top" ? scrollHeight <= clientHeight : scrollWidth <= clientWidth;
    if (state.arrivedState[direction] || isNarrower) {
      if (!promise.value) {
        promise.value = Promise.all([onLoadMore(state), new Promise(resolve => setTimeout(resolve, interval))]).finally(() => {
          promise.value = null;
          nextTick(() => checkAndLoad());
        });
      }
    }
  }
  watch(() => [state.arrivedState[direction], isElementVisible.value], checkAndLoad, {
    immediate: true
  });
  return {
    isLoading
  };
}
const defaultEvents = ["mousedown", "mouseup", "keydown", "keyup"];
function useKeyModifier(modifier) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$events2 = options.events,
    events = _options$events2 === void 0 ? defaultEvents : _options$events2,
    _options$document7 = options.document,
    document = _options$document7 === void 0 ? defaultDocument : _options$document7,
    _options$initial = options.initial,
    initial = _options$initial === void 0 ? null : _options$initial;
  const state = ref(initial);
  if (document) {
    events.forEach(listenerEvent => {
      useEventListener(document, listenerEvent, evt => {
        if (typeof evt.getModifierState === "function") state.value = evt.getModifierState(modifier);
      });
    });
  }
  return state;
}
function useLocalStorage(key, initialValue) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _options$window24 = options.window,
    window = _options$window24 === void 0 ? defaultWindow : _options$window24;
  return useStorage(key, initialValue, window == null ? void 0 : window.localStorage, options);
}
const DefaultMagicKeysAliasMap = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function useMagicKeys() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$reactive = options.reactive,
    useReactive = _options$reactive === void 0 ? false : _options$reactive,
    _options$target = options.target,
    target = _options$target === void 0 ? defaultWindow : _options$target,
    _options$aliasMap = options.aliasMap,
    aliasMap = _options$aliasMap === void 0 ? DefaultMagicKeysAliasMap : _options$aliasMap,
    _options$passive = options.passive,
    passive = _options$passive === void 0 ? true : _options$passive,
    _options$onEventFired = options.onEventFired,
    onEventFired = _options$onEventFired === void 0 ? noop : _options$onEventFired;
  const current = reactive( /* @__PURE__ */new Set());
  const obj = {
    toJSON() {
      return {};
    },
    current
  };
  const refs = useReactive ? reactive(obj) : obj;
  const metaDeps = /* @__PURE__ */new Set();
  const usedKeys = /* @__PURE__ */new Set();
  function setRefs(key, value) {
    if (key in refs) {
      if (useReactive) refs[key] = value;else refs[key].value = value;
    }
  }
  function reset() {
    current.clear();
    for (const key of usedKeys) setRefs(key, false);
  }
  function updateRefs(e, value) {
    var _a, _b;
    const key = (_a = e.key) == null ? void 0 : _a.toLowerCase();
    const code = (_b = e.code) == null ? void 0 : _b.toLowerCase();
    const values = [code, key].filter(Boolean);
    if (key) {
      if (value) current.add(key);else current.delete(key);
    }
    for (const key2 of values) {
      usedKeys.add(key2);
      setRefs(key2, value);
    }
    if (key === "meta" && !value) {
      metaDeps.forEach(key2 => {
        current.delete(key2);
        setRefs(key2, false);
      });
      metaDeps.clear();
    } else if (typeof e.getModifierState === "function" && e.getModifierState("Meta") && value) {
      [...current, ...values].forEach(key2 => metaDeps.add(key2));
    }
  }
  useEventListener(target, "keydown", e => {
    updateRefs(e, true);
    return onEventFired(e);
  }, {
    passive
  });
  useEventListener(target, "keyup", e => {
    updateRefs(e, false);
    return onEventFired(e);
  }, {
    passive
  });
  useEventListener("blur", reset, {
    passive: true
  });
  useEventListener("focus", reset, {
    passive: true
  });
  const proxy = new Proxy(refs, {
    get(target2, prop, rec) {
      if (typeof prop !== "string") return Reflect.get(target2, prop, rec);
      prop = prop.toLowerCase();
      if (prop in aliasMap) prop = aliasMap[prop];
      if (!(prop in refs)) {
        if (/[+_-]/.test(prop)) {
          const keys = prop.split(/[+_-]/g).map(i => i.trim());
          refs[prop] = computed(() => keys.every(key => toValue(proxy[key])));
        } else {
          refs[prop] = ref(false);
        }
      }
      const r = Reflect.get(target2, prop, rec);
      return useReactive ? toValue(r) : r;
    }
  });
  return proxy;
}
function usingElRef(source, cb) {
  if (toValue(source)) cb(toValue(source));
}
function timeRangeToArray(timeRanges) {
  let ranges = [];
  for (let i = 0; i < timeRanges.length; ++i) ranges = [...ranges, [timeRanges.start(i), timeRanges.end(i)]];
  return ranges;
}
function tracksToArray(tracks) {
  return Array.from(tracks).map((_ref30, id) => {
    let label = _ref30.label,
      kind = _ref30.kind,
      language = _ref30.language,
      mode = _ref30.mode,
      activeCues = _ref30.activeCues,
      cues = _ref30.cues,
      inBandMetadataTrackDispatchType = _ref30.inBandMetadataTrackDispatchType;
    return {
      id,
      label,
      kind,
      language,
      mode,
      activeCues,
      cues,
      inBandMetadataTrackDispatchType
    };
  });
}
const defaultOptions = {
  src: "",
  tracks: []
};
function useMediaControls(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  target = toRef(target);
  options = _objectSpread(_objectSpread({}, defaultOptions), options);
  const _options5 = options,
    _options5$document = _options5.document,
    document = _options5$document === void 0 ? defaultDocument : _options5$document;
  const currentTime = ref(0);
  const duration = ref(0);
  const seeking = ref(false);
  const volume = ref(1);
  const waiting = ref(false);
  const ended = ref(false);
  const playing = ref(false);
  const rate = ref(1);
  const stalled = ref(false);
  const buffered = ref([]);
  const tracks = ref([]);
  const selectedTrack = ref(-1);
  const isPictureInPicture = ref(false);
  const muted = ref(false);
  const supportsPictureInPicture = document && "pictureInPictureEnabled" in document;
  const sourceErrorEvent = createEventHook();
  const disableTrack = track => {
    usingElRef(target, el => {
      if (track) {
        const id = typeof track === "number" ? track : track.id;
        el.textTracks[id].mode = "disabled";
      } else {
        for (let i = 0; i < el.textTracks.length; ++i) el.textTracks[i].mode = "disabled";
      }
      selectedTrack.value = -1;
    });
  };
  const enableTrack = function enableTrack(track) {
    let disableTracks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    usingElRef(target, el => {
      const id = typeof track === "number" ? track : track.id;
      if (disableTracks) disableTrack();
      el.textTracks[id].mode = "showing";
      selectedTrack.value = id;
    });
  };
  const togglePictureInPicture = () => {
    return new Promise((resolve, reject) => {
      usingElRef(target, async el => {
        if (supportsPictureInPicture) {
          if (!isPictureInPicture.value) {
            el.requestPictureInPicture().then(resolve).catch(reject);
          } else {
            document.exitPictureInPicture().then(resolve).catch(reject);
          }
        }
      });
    });
  };
  watchEffect(() => {
    if (!document) return;
    const el = toValue(target);
    if (!el) return;
    const src = toValue(options.src);
    let sources = [];
    if (!src) return;
    if (typeof src === "string") sources = [{
      src
    }];else if (Array.isArray(src)) sources = src;else if (isObject(src)) sources = [src];
    el.querySelectorAll("source").forEach(e => {
      e.removeEventListener("error", sourceErrorEvent.trigger);
      e.remove();
    });
    sources.forEach(_ref31 => {
      let src2 = _ref31.src,
        type = _ref31.type;
      const source = document.createElement("source");
      source.setAttribute("src", src2);
      source.setAttribute("type", type || "");
      source.addEventListener("error", sourceErrorEvent.trigger);
      el.appendChild(source);
    });
    el.load();
  });
  tryOnScopeDispose(() => {
    const el = toValue(target);
    if (!el) return;
    el.querySelectorAll("source").forEach(e => e.removeEventListener("error", sourceErrorEvent.trigger));
  });
  watch([target, volume], () => {
    const el = toValue(target);
    if (!el) return;
    el.volume = volume.value;
  });
  watch([target, muted], () => {
    const el = toValue(target);
    if (!el) return;
    el.muted = muted.value;
  });
  watch([target, rate], () => {
    const el = toValue(target);
    if (!el) return;
    el.playbackRate = rate.value;
  });
  watchEffect(() => {
    if (!document) return;
    const textTracks = toValue(options.tracks);
    const el = toValue(target);
    if (!textTracks || !textTracks.length || !el) return;
    el.querySelectorAll("track").forEach(e => e.remove());
    textTracks.forEach((_ref32, i) => {
      let isDefault = _ref32.default,
        kind = _ref32.kind,
        label = _ref32.label,
        src = _ref32.src,
        srcLang = _ref32.srcLang;
      const track = document.createElement("track");
      track.default = isDefault || false;
      track.kind = kind;
      track.label = label;
      track.src = src;
      track.srclang = srcLang;
      if (track.default) selectedTrack.value = i;
      el.appendChild(track);
    });
  });
  const _watchIgnorable2 = watchIgnorable(currentTime, time => {
      const el = toValue(target);
      if (!el) return;
      el.currentTime = time;
    }),
    ignoreCurrentTimeUpdates = _watchIgnorable2.ignoreUpdates;
  const _watchIgnorable3 = watchIgnorable(playing, isPlaying => {
      const el = toValue(target);
      if (!el) return;
      isPlaying ? el.play() : el.pause();
    }),
    ignorePlayingUpdates = _watchIgnorable3.ignoreUpdates;
  useEventListener(target, "timeupdate", () => ignoreCurrentTimeUpdates(() => currentTime.value = toValue(target).currentTime));
  useEventListener(target, "durationchange", () => duration.value = toValue(target).duration);
  useEventListener(target, "progress", () => buffered.value = timeRangeToArray(toValue(target).buffered));
  useEventListener(target, "seeking", () => seeking.value = true);
  useEventListener(target, "seeked", () => seeking.value = false);
  useEventListener(target, ["waiting", "loadstart"], () => {
    waiting.value = true;
    ignorePlayingUpdates(() => playing.value = false);
  });
  useEventListener(target, "loadeddata", () => waiting.value = false);
  useEventListener(target, "playing", () => {
    waiting.value = false;
    ended.value = false;
    ignorePlayingUpdates(() => playing.value = true);
  });
  useEventListener(target, "ratechange", () => rate.value = toValue(target).playbackRate);
  useEventListener(target, "stalled", () => stalled.value = true);
  useEventListener(target, "ended", () => ended.value = true);
  useEventListener(target, "pause", () => ignorePlayingUpdates(() => playing.value = false));
  useEventListener(target, "play", () => ignorePlayingUpdates(() => playing.value = true));
  useEventListener(target, "enterpictureinpicture", () => isPictureInPicture.value = true);
  useEventListener(target, "leavepictureinpicture", () => isPictureInPicture.value = false);
  useEventListener(target, "volumechange", () => {
    const el = toValue(target);
    if (!el) return;
    volume.value = el.volume;
    muted.value = el.muted;
  });
  const listeners = [];
  const stop = watch([target], () => {
    const el = toValue(target);
    if (!el) return;
    stop();
    listeners[0] = useEventListener(el.textTracks, "addtrack", () => tracks.value = tracksToArray(el.textTracks));
    listeners[1] = useEventListener(el.textTracks, "removetrack", () => tracks.value = tracksToArray(el.textTracks));
    listeners[2] = useEventListener(el.textTracks, "change", () => tracks.value = tracksToArray(el.textTracks));
  });
  tryOnScopeDispose(() => listeners.forEach(listener => listener()));
  return {
    currentTime,
    duration,
    waiting,
    seeking,
    ended,
    stalled,
    buffered,
    playing,
    rate,
    // Volume
    volume,
    muted,
    // Tracks
    tracks,
    selectedTrack,
    enableTrack,
    disableTrack,
    // Picture in Picture
    supportsPictureInPicture,
    togglePictureInPicture,
    isPictureInPicture,
    // Events
    onSourceError: sourceErrorEvent.on
  };
}
function getMapVue2Compat() {
  const data = shallowReactive({});
  return {
    get: key => data[key],
    set: (key, value) => _set(data, key, value),
    has: key => hasOwn(data, key),
    delete: key => del(data, key),
    clear: () => {
      Object.keys(data).forEach(key => {
        del(data, key);
      });
    }
  };
}
function useMemoize(resolver, options) {
  const initCache = () => {
    if (options == null ? void 0 : options.cache) return shallowReactive(options.cache);
    if (isVue2) return getMapVue2Compat();
    return shallowReactive( /* @__PURE__ */new Map());
  };
  const cache = initCache();
  const generateKey = function generateKey() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    return (options == null ? void 0 : options.getKey) ? options.getKey(...args) : JSON.stringify(args);
  };
  const _loadData = function _loadData(key) {
    for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
      args[_key8 - 1] = arguments[_key8];
    }
    cache.set(key, resolver(...args));
    return cache.get(key);
  };
  const loadData = function loadData() {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }
    return _loadData(generateKey(...args), ...args);
  };
  const deleteData = function deleteData() {
    cache.delete(generateKey(...arguments));
  };
  const clearData = () => {
    cache.clear();
  };
  const memoized = function memoized() {
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }
    const key = generateKey(...args);
    if (cache.has(key)) return cache.get(key);
    return _loadData(key, ...args);
  };
  memoized.load = loadData;
  memoized.delete = deleteData;
  memoized.clear = clearData;
  memoized.generateKey = generateKey;
  memoized.cache = cache;
  return memoized;
}
function useMemory() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const memory = ref();
  const isSupported = useSupported(() => typeof performance !== "undefined" && "memory" in performance);
  if (isSupported.value) {
    const _options$interval3 = options.interval,
      interval = _options$interval3 === void 0 ? 1e3 : _options$interval3;
    useIntervalFn(() => {
      memory.value = performance.memory;
    }, interval, {
      immediate: options.immediate,
      immediateCallback: options.immediateCallback
    });
  }
  return {
    isSupported,
    memory
  };
}
const UseMouseBuiltinExtractors = {
  page: event => [event.pageX, event.pageY],
  client: event => [event.clientX, event.clientY],
  screen: event => [event.screenX, event.screenY],
  movement: event => event instanceof Touch ? null : [event.movementX, event.movementY]
};
function useMouse() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$type = options.type,
    type = _options$type === void 0 ? "page" : _options$type,
    _options$touch = options.touch,
    touch = _options$touch === void 0 ? true : _options$touch,
    _options$resetOnTouch = options.resetOnTouchEnds,
    resetOnTouchEnds = _options$resetOnTouch === void 0 ? false : _options$resetOnTouch,
    _options$initialValue5 = options.initialValue,
    initialValue = _options$initialValue5 === void 0 ? {
      x: 0,
      y: 0
    } : _options$initialValue5,
    _options$window25 = options.window,
    window = _options$window25 === void 0 ? defaultWindow : _options$window25,
    _options$target2 = options.target,
    target = _options$target2 === void 0 ? window : _options$target2,
    _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    eventFilter = options.eventFilter;
  let _prevMouseEvent = null;
  const x = ref(initialValue.x);
  const y = ref(initialValue.y);
  const sourceType = ref(null);
  const extractor = typeof type === "function" ? type : UseMouseBuiltinExtractors[type];
  const mouseHandler = event => {
    const result = extractor(event);
    _prevMouseEvent = event;
    if (result) {
      var _result = _slicedToArray(result, 2);
      x.value = _result[0];
      y.value = _result[1];
      sourceType.value = "mouse";
    }
  };
  const touchHandler = event => {
    if (event.touches.length > 0) {
      const result = extractor(event.touches[0]);
      if (result) {
        var _result2 = _slicedToArray(result, 2);
        x.value = _result2[0];
        y.value = _result2[1];
        sourceType.value = "touch";
      }
    }
  };
  const scrollHandler = () => {
    if (!_prevMouseEvent || !window) return;
    const pos = extractor(_prevMouseEvent);
    if (_prevMouseEvent instanceof MouseEvent && pos) {
      x.value = pos[0] + window.scrollX;
      y.value = pos[1] + window.scrollY;
    }
  };
  const reset = () => {
    x.value = initialValue.x;
    y.value = initialValue.y;
  };
  const mouseHandlerWrapper = eventFilter ? event => eventFilter(() => mouseHandler(event), {}) : event => mouseHandler(event);
  const touchHandlerWrapper = eventFilter ? event => eventFilter(() => touchHandler(event), {}) : event => touchHandler(event);
  const scrollHandlerWrapper = eventFilter ? () => eventFilter(() => scrollHandler(), {}) : () => scrollHandler();
  if (target) {
    const listenerOptions = {
      passive: true
    };
    useEventListener(target, ["mousemove", "dragover"], mouseHandlerWrapper, listenerOptions);
    if (touch && type !== "movement") {
      useEventListener(target, ["touchstart", "touchmove"], touchHandlerWrapper, listenerOptions);
      if (resetOnTouchEnds) useEventListener(target, "touchend", reset, listenerOptions);
    }
    if (scroll && type === "page") useEventListener(window, "scroll", scrollHandlerWrapper, {
      passive: true
    });
  }
  return {
    x,
    y,
    sourceType
  };
}
function useMouseInElement(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$handleOutsid = options.handleOutside,
    handleOutside = _options$handleOutsid === void 0 ? true : _options$handleOutsid,
    _options$window26 = options.window,
    window = _options$window26 === void 0 ? defaultWindow : _options$window26;
  const type = options.type || "page";
  const _useMouse = useMouse(options),
    x = _useMouse.x,
    y = _useMouse.y,
    sourceType = _useMouse.sourceType;
  const targetRef = ref(target != null ? target : window == null ? void 0 : window.document.body);
  const elementX = ref(0);
  const elementY = ref(0);
  const elementPositionX = ref(0);
  const elementPositionY = ref(0);
  const elementHeight = ref(0);
  const elementWidth = ref(0);
  const isOutside = ref(true);
  let stop = () => {};
  if (window) {
    stop = watch([targetRef, x, y], () => {
      const el = unrefElement(targetRef);
      if (!el) return;
      const _el$getBoundingClient = el.getBoundingClientRect(),
        left = _el$getBoundingClient.left,
        top = _el$getBoundingClient.top,
        width = _el$getBoundingClient.width,
        height = _el$getBoundingClient.height;
      elementPositionX.value = left + (type === "page" ? window.pageXOffset : 0);
      elementPositionY.value = top + (type === "page" ? window.pageYOffset : 0);
      elementHeight.value = height;
      elementWidth.value = width;
      const elX = x.value - elementPositionX.value;
      const elY = y.value - elementPositionY.value;
      isOutside.value = width === 0 || height === 0 || elX < 0 || elY < 0 || elX > width || elY > height;
      if (handleOutside || !isOutside.value) {
        elementX.value = elX;
        elementY.value = elY;
      }
    }, {
      immediate: true
    });
    useEventListener(document, "mouseleave", () => {
      isOutside.value = true;
    });
  }
  return {
    x,
    y,
    sourceType,
    elementX,
    elementY,
    elementPositionX,
    elementPositionY,
    elementHeight,
    elementWidth,
    isOutside,
    stop
  };
}
function useMousePressed() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$touch2 = options.touch,
    touch = _options$touch2 === void 0 ? true : _options$touch2,
    _options$drag = options.drag,
    drag = _options$drag === void 0 ? true : _options$drag,
    _options$capture2 = options.capture,
    capture = _options$capture2 === void 0 ? false : _options$capture2,
    _options$initialValue6 = options.initialValue,
    initialValue = _options$initialValue6 === void 0 ? false : _options$initialValue6,
    _options$window27 = options.window,
    window = _options$window27 === void 0 ? defaultWindow : _options$window27;
  const pressed = ref(initialValue);
  const sourceType = ref(null);
  if (!window) {
    return {
      pressed,
      sourceType
    };
  }
  const onPressed = srcType => () => {
    pressed.value = true;
    sourceType.value = srcType;
  };
  const onReleased = () => {
    pressed.value = false;
    sourceType.value = null;
  };
  const target = computed(() => unrefElement(options.target) || window);
  useEventListener(target, "mousedown", onPressed("mouse"), {
    passive: true,
    capture
  });
  useEventListener(window, "mouseleave", onReleased, {
    passive: true,
    capture
  });
  useEventListener(window, "mouseup", onReleased, {
    passive: true,
    capture
  });
  if (drag) {
    useEventListener(target, "dragstart", onPressed("mouse"), {
      passive: true,
      capture
    });
    useEventListener(window, "drop", onReleased, {
      passive: true,
      capture
    });
    useEventListener(window, "dragend", onReleased, {
      passive: true,
      capture
    });
  }
  if (touch) {
    useEventListener(target, "touchstart", onPressed("touch"), {
      passive: true,
      capture
    });
    useEventListener(window, "touchend", onReleased, {
      passive: true,
      capture
    });
    useEventListener(window, "touchcancel", onReleased, {
      passive: true,
      capture
    });
  }
  return {
    pressed,
    sourceType
  };
}
function useNavigatorLanguage() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window28 = options.window,
    window = _options$window28 === void 0 ? defaultWindow : _options$window28;
  const navigator = window == null ? void 0 : window.navigator;
  const isSupported = useSupported(() => navigator && "language" in navigator);
  const language = ref(navigator == null ? void 0 : navigator.language);
  useEventListener(window, "languagechange", () => {
    if (navigator) language.value = navigator.language;
  });
  return {
    isSupported,
    language
  };
}
function useNetwork() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window29 = options.window,
    window = _options$window29 === void 0 ? defaultWindow : _options$window29;
  const navigator = window == null ? void 0 : window.navigator;
  const isSupported = useSupported(() => navigator && "connection" in navigator);
  const isOnline = ref(true);
  const saveData = ref(false);
  const offlineAt = ref(void 0);
  const onlineAt = ref(void 0);
  const downlink = ref(void 0);
  const downlinkMax = ref(void 0);
  const rtt = ref(void 0);
  const effectiveType = ref(void 0);
  const type = ref("unknown");
  const connection = isSupported.value && navigator.connection;
  function updateNetworkInformation() {
    if (!navigator) return;
    isOnline.value = navigator.onLine;
    offlineAt.value = isOnline.value ? void 0 : Date.now();
    onlineAt.value = isOnline.value ? Date.now() : void 0;
    if (connection) {
      downlink.value = connection.downlink;
      downlinkMax.value = connection.downlinkMax;
      effectiveType.value = connection.effectiveType;
      rtt.value = connection.rtt;
      saveData.value = connection.saveData;
      type.value = connection.type;
    }
  }
  if (window) {
    useEventListener(window, "offline", () => {
      isOnline.value = false;
      offlineAt.value = Date.now();
    });
    useEventListener(window, "online", () => {
      isOnline.value = true;
      onlineAt.value = Date.now();
    });
  }
  if (connection) useEventListener(connection, "change", updateNetworkInformation, false);
  updateNetworkInformation();
  return {
    isSupported,
    isOnline,
    saveData,
    offlineAt,
    onlineAt,
    downlink,
    downlinkMax,
    effectiveType,
    rtt,
    type
  };
}
function useNow() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$controls2 = options.controls,
    exposeControls = _options$controls2 === void 0 ? false : _options$controls2,
    _options$interval4 = options.interval,
    interval = _options$interval4 === void 0 ? "requestAnimationFrame" : _options$interval4;
  const now = ref( /* @__PURE__ */new Date());
  const update = () => now.value = /* @__PURE__ */new Date();
  const controls = interval === "requestAnimationFrame" ? useRafFn(update, {
    immediate: true
  }) : useIntervalFn(update, interval, {
    immediate: true
  });
  if (exposeControls) {
    return _objectSpread({
      now
    }, controls);
  } else {
    return now;
  }
}
function useObjectUrl(object) {
  const url = ref();
  const release = () => {
    if (url.value) URL.revokeObjectURL(url.value);
    url.value = void 0;
  };
  watch(() => toValue(object), newObject => {
    release();
    if (newObject) url.value = URL.createObjectURL(newObject);
  }, {
    immediate: true
  });
  tryOnScopeDispose(release);
  return readonly(url);
}
function useClamp(value, min, max) {
  if (typeof value === "function" || isReadonly(value)) return computed(() => clamp(toValue(value), toValue(min), toValue(max)));
  const _value = ref(value);
  return computed({
    get() {
      return _value.value = clamp(_value.value, toValue(min), toValue(max));
    },
    set(value2) {
      _value.value = clamp(value2, toValue(min), toValue(max));
    }
  });
}
function useOffsetPagination(options) {
  const _options$total = options.total,
    total = _options$total === void 0 ? Number.POSITIVE_INFINITY : _options$total,
    _options$pageSize = options.pageSize,
    pageSize = _options$pageSize === void 0 ? 10 : _options$pageSize,
    _options$page = options.page,
    page = _options$page === void 0 ? 1 : _options$page,
    _options$onPageChange = options.onPageChange,
    onPageChange = _options$onPageChange === void 0 ? noop : _options$onPageChange,
    _options$onPageSizeCh = options.onPageSizeChange,
    onPageSizeChange = _options$onPageSizeCh === void 0 ? noop : _options$onPageSizeCh,
    _options$onPageCountC = options.onPageCountChange,
    onPageCountChange = _options$onPageCountC === void 0 ? noop : _options$onPageCountC;
  const currentPageSize = useClamp(pageSize, 1, Number.POSITIVE_INFINITY);
  const pageCount = computed(() => Math.max(1, Math.ceil(toValue(total) / toValue(currentPageSize))));
  const currentPage = useClamp(page, 1, pageCount);
  const isFirstPage = computed(() => currentPage.value === 1);
  const isLastPage = computed(() => currentPage.value === pageCount.value);
  if (isRef(page)) {
    syncRef(page, currentPage, {
      direction: isReadonly(page) ? "ltr" : "both"
    });
  }
  if (isRef(pageSize)) {
    syncRef(pageSize, currentPageSize, {
      direction: isReadonly(pageSize) ? "ltr" : "both"
    });
  }
  function prev() {
    currentPage.value--;
  }
  function next() {
    currentPage.value++;
  }
  const returnValue = {
    currentPage,
    currentPageSize,
    pageCount,
    isFirstPage,
    isLastPage,
    prev,
    next
  };
  watch(currentPage, () => {
    onPageChange(reactive(returnValue));
  });
  watch(currentPageSize, () => {
    onPageSizeChange(reactive(returnValue));
  });
  watch(pageCount, () => {
    onPageCountChange(reactive(returnValue));
  });
  return returnValue;
}
function useOnline() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _useNetwork = useNetwork(options),
    isOnline = _useNetwork.isOnline;
  return isOnline;
}
function usePageLeave() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window30 = options.window,
    window = _options$window30 === void 0 ? defaultWindow : _options$window30;
  const isLeft = ref(false);
  const handler = event => {
    if (!window) return;
    event = event || window.event;
    const from = event.relatedTarget || event.toElement;
    isLeft.value = !from;
  };
  if (window) {
    useEventListener(window, "mouseout", handler, {
      passive: true
    });
    useEventListener(window.document, "mouseleave", handler, {
      passive: true
    });
    useEventListener(window.document, "mouseenter", handler, {
      passive: true
    });
  }
  return isLeft;
}
function useScreenOrientation() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window31 = options.window,
    window = _options$window31 === void 0 ? defaultWindow : _options$window31;
  const isSupported = useSupported(() => window && "screen" in window && "orientation" in window.screen);
  const screenOrientation = isSupported.value ? window.screen.orientation : {};
  const orientation = ref(screenOrientation.type);
  const angle = ref(screenOrientation.angle || 0);
  if (isSupported.value) {
    useEventListener(window, "orientationchange", () => {
      orientation.value = screenOrientation.type;
      angle.value = screenOrientation.angle;
    });
  }
  const lockOrientation = type => {
    if (isSupported.value && typeof screenOrientation.lock === "function") return screenOrientation.lock(type);
    return Promise.reject(new Error("Not supported"));
  };
  const unlockOrientation = () => {
    if (isSupported.value && typeof screenOrientation.unlock === "function") screenOrientation.unlock();
  };
  return {
    isSupported,
    orientation,
    angle,
    lockOrientation,
    unlockOrientation
  };
}
function useParallax(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$deviceOrient = options.deviceOrientationTiltAdjust,
    deviceOrientationTiltAdjust = _options$deviceOrient === void 0 ? i => i : _options$deviceOrient,
    _options$deviceOrient2 = options.deviceOrientationRollAdjust,
    deviceOrientationRollAdjust = _options$deviceOrient2 === void 0 ? i => i : _options$deviceOrient2,
    _options$mouseTiltAdj = options.mouseTiltAdjust,
    mouseTiltAdjust = _options$mouseTiltAdj === void 0 ? i => i : _options$mouseTiltAdj,
    _options$mouseRollAdj = options.mouseRollAdjust,
    mouseRollAdjust = _options$mouseRollAdj === void 0 ? i => i : _options$mouseRollAdj,
    _options$window32 = options.window,
    window = _options$window32 === void 0 ? defaultWindow : _options$window32;
  const orientation = reactive(useDeviceOrientation({
    window
  }));
  const screenOrientation = reactive(useScreenOrientation({
    window
  }));
  const _useMouseInElement = useMouseInElement(target, {
      handleOutside: false,
      window
    }),
    x = _useMouseInElement.elementX,
    y = _useMouseInElement.elementY,
    width = _useMouseInElement.elementWidth,
    height = _useMouseInElement.elementHeight;
  const source = computed(() => {
    if (orientation.isSupported && (orientation.alpha != null && orientation.alpha !== 0 || orientation.gamma != null && orientation.gamma !== 0)) {
      return "deviceOrientation";
    }
    return "mouse";
  });
  const roll = computed(() => {
    if (source.value === "deviceOrientation") {
      let value;
      switch (screenOrientation.orientation) {
        case "landscape-primary":
          value = orientation.gamma / 90;
          break;
        case "landscape-secondary":
          value = -orientation.gamma / 90;
          break;
        case "portrait-primary":
          value = -orientation.beta / 90;
          break;
        case "portrait-secondary":
          value = orientation.beta / 90;
          break;
        default:
          value = -orientation.beta / 90;
      }
      return deviceOrientationRollAdjust(value);
    } else {
      const value = -(y.value - height.value / 2) / height.value;
      return mouseRollAdjust(value);
    }
  });
  const tilt = computed(() => {
    if (source.value === "deviceOrientation") {
      let value;
      switch (screenOrientation.orientation) {
        case "landscape-primary":
          value = orientation.beta / 90;
          break;
        case "landscape-secondary":
          value = -orientation.beta / 90;
          break;
        case "portrait-primary":
          value = orientation.gamma / 90;
          break;
        case "portrait-secondary":
          value = -orientation.gamma / 90;
          break;
        default:
          value = orientation.gamma / 90;
      }
      return deviceOrientationTiltAdjust(value);
    } else {
      const value = (x.value - width.value / 2) / width.value;
      return mouseTiltAdjust(value);
    }
  });
  return {
    roll,
    tilt,
    source
  };
}
function useParentElement() {
  let element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : useCurrentElement();
  const parentElement = shallowRef();
  const update = () => {
    const el = unrefElement(element);
    if (el) parentElement.value = el.parentElement;
  };
  tryOnMounted(update);
  watch(() => toValue(element), update);
  return parentElement;
}
function usePerformanceObserver(options, callback) {
  const _options$window33 = options.window,
    window = _options$window33 === void 0 ? defaultWindow : _options$window33,
    _options$immediate8 = options.immediate,
    immediate = _options$immediate8 === void 0 ? true : _options$immediate8,
    performanceOptions = _objectWithoutProperties(options, _excluded3);
  const isSupported = useSupported(() => window && "PerformanceObserver" in window);
  let observer;
  const stop = () => {
    observer == null ? void 0 : observer.disconnect();
  };
  const start = () => {
    if (isSupported.value) {
      stop();
      observer = new PerformanceObserver(callback);
      observer.observe(performanceOptions);
    }
  };
  tryOnScopeDispose(stop);
  if (immediate) start();
  return {
    isSupported,
    start,
    stop
  };
}
const defaultState = {
  x: 0,
  y: 0,
  pointerId: 0,
  pressure: 0,
  tiltX: 0,
  tiltY: 0,
  width: 0,
  height: 0,
  twist: 0,
  pointerType: null
};
const keys = /* @__PURE__ */Object.keys(defaultState);
function usePointer() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$target3 = options.target,
    target = _options$target3 === void 0 ? defaultWindow : _options$target3;
  const isInside = ref(false);
  const state = ref(options.initialValue || {});
  Object.assign(state.value, defaultState, state.value);
  const handler = event => {
    isInside.value = true;
    if (options.pointerTypes && !options.pointerTypes.includes(event.pointerType)) return;
    state.value = objectPick(event, keys, false);
  };
  if (target) {
    const listenerOptions = {
      passive: true
    };
    useEventListener(target, ["pointerdown", "pointermove", "pointerup"], handler, listenerOptions);
    useEventListener(target, "pointerleave", () => isInside.value = false, listenerOptions);
  }
  return _objectSpread(_objectSpread({}, toRefs(state)), {}, {
    isInside
  });
}
function usePointerLock(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$document8 = options.document,
    document = _options$document8 === void 0 ? defaultDocument : _options$document8;
  const isSupported = useSupported(() => document && "pointerLockElement" in document);
  const element = ref();
  const triggerElement = ref();
  let targetElement;
  if (isSupported.value) {
    useEventListener(document, "pointerlockchange", () => {
      var _a;
      const currentElement = (_a = document.pointerLockElement) != null ? _a : element.value;
      if (targetElement && currentElement === targetElement) {
        element.value = document.pointerLockElement;
        if (!element.value) targetElement = triggerElement.value = null;
      }
    });
    useEventListener(document, "pointerlockerror", () => {
      var _a;
      const currentElement = (_a = document.pointerLockElement) != null ? _a : element.value;
      if (targetElement && currentElement === targetElement) {
        const action = document.pointerLockElement ? "release" : "acquire";
        throw new Error("Failed to ".concat(action, " pointer lock."));
      }
    });
  }
  async function lock(e) {
    var _a;
    if (!isSupported.value) throw new Error("Pointer Lock API is not supported by your browser.");
    triggerElement.value = e instanceof Event ? e.currentTarget : null;
    targetElement = e instanceof Event ? (_a = unrefElement(target)) != null ? _a : triggerElement.value : unrefElement(e);
    if (!targetElement) throw new Error("Target element undefined.");
    targetElement.requestPointerLock();
    return await until(element).toBe(targetElement);
  }
  async function unlock() {
    if (!element.value) return false;
    document.exitPointerLock();
    await until(element).toBeNull();
    return true;
  }
  return {
    isSupported,
    element,
    triggerElement,
    lock,
    unlock
  };
}
function usePointerSwipe(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const targetRef = toRef(target);
  const _options$threshold3 = options.threshold,
    threshold = _options$threshold3 === void 0 ? 50 : _options$threshold3,
    onSwipe = options.onSwipe,
    onSwipeEnd = options.onSwipeEnd,
    onSwipeStart = options.onSwipeStart,
    _options$disableTextS = options.disableTextSelect,
    disableTextSelect = _options$disableTextS === void 0 ? false : _options$disableTextS;
  const posStart = reactive({
    x: 0,
    y: 0
  });
  const updatePosStart = (x, y) => {
    posStart.x = x;
    posStart.y = y;
  };
  const posEnd = reactive({
    x: 0,
    y: 0
  });
  const updatePosEnd = (x, y) => {
    posEnd.x = x;
    posEnd.y = y;
  };
  const distanceX = computed(() => posStart.x - posEnd.x);
  const distanceY = computed(() => posStart.y - posEnd.y);
  const max = Math.max,
    abs = Math.abs;
  const isThresholdExceeded = computed(() => max(abs(distanceX.value), abs(distanceY.value)) >= threshold);
  const isSwiping = ref(false);
  const isPointerDown = ref(false);
  const direction = computed(() => {
    if (!isThresholdExceeded.value) return "none";
    if (abs(distanceX.value) > abs(distanceY.value)) {
      return distanceX.value > 0 ? "left" : "right";
    } else {
      return distanceY.value > 0 ? "up" : "down";
    }
  });
  const eventIsAllowed = e => {
    var _a, _b, _c;
    const isReleasingButton = e.buttons === 0;
    const isPrimaryButton = e.buttons === 1;
    return (_c = (_b = (_a = options.pointerTypes) == null ? void 0 : _a.includes(e.pointerType)) != null ? _b : isReleasingButton || isPrimaryButton) != null ? _c : true;
  };
  const stops = [useEventListener(target, "pointerdown", e => {
    if (!eventIsAllowed(e)) return;
    isPointerDown.value = true;
    const eventTarget = e.target;
    eventTarget == null ? void 0 : eventTarget.setPointerCapture(e.pointerId);
    const x = e.clientX,
      y = e.clientY;
    updatePosStart(x, y);
    updatePosEnd(x, y);
    onSwipeStart == null ? void 0 : onSwipeStart(e);
  }), useEventListener(target, "pointermove", e => {
    if (!eventIsAllowed(e)) return;
    if (!isPointerDown.value) return;
    const x = e.clientX,
      y = e.clientY;
    updatePosEnd(x, y);
    if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
    if (isSwiping.value) onSwipe == null ? void 0 : onSwipe(e);
  }), useEventListener(target, "pointerup", e => {
    if (!eventIsAllowed(e)) return;
    if (isSwiping.value) onSwipeEnd == null ? void 0 : onSwipeEnd(e, direction.value);
    isPointerDown.value = false;
    isSwiping.value = false;
  })];
  tryOnMounted(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null ? void 0 : _b.setProperty("touch-action", "none");
    if (disableTextSelect) {
      (_d = (_c = targetRef.value) == null ? void 0 : _c.style) == null ? void 0 : _d.setProperty("-webkit-user-select", "none");
      (_f = (_e = targetRef.value) == null ? void 0 : _e.style) == null ? void 0 : _f.setProperty("-ms-user-select", "none");
      (_h = (_g = targetRef.value) == null ? void 0 : _g.style) == null ? void 0 : _h.setProperty("user-select", "none");
    }
  });
  const stop = () => stops.forEach(s => s());
  return {
    isSwiping: readonly(isSwiping),
    direction: readonly(direction),
    posStart: readonly(posStart),
    posEnd: readonly(posEnd),
    distanceX,
    distanceY,
    stop
  };
}
function usePreferredColorScheme(options) {
  const isLight = useMediaQuery("(prefers-color-scheme: light)", options);
  const isDark = useMediaQuery("(prefers-color-scheme: dark)", options);
  return computed(() => {
    if (isDark.value) return "dark";
    if (isLight.value) return "light";
    return "no-preference";
  });
}
function usePreferredContrast(options) {
  const isMore = useMediaQuery("(prefers-contrast: more)", options);
  const isLess = useMediaQuery("(prefers-contrast: less)", options);
  const isCustom = useMediaQuery("(prefers-contrast: custom)", options);
  return computed(() => {
    if (isMore.value) return "more";
    if (isLess.value) return "less";
    if (isCustom.value) return "custom";
    return "no-preference";
  });
}
function usePreferredLanguages() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window34 = options.window,
    window = _options$window34 === void 0 ? defaultWindow : _options$window34;
  if (!window) return ref(["en"]);
  const navigator = window.navigator;
  const value = ref(navigator.languages);
  useEventListener(window, "languagechange", () => {
    value.value = navigator.languages;
  });
  return value;
}
function usePreferredReducedMotion(options) {
  const isReduced = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return computed(() => {
    if (isReduced.value) return "reduce";
    return "no-preference";
  });
}
function usePrevious(value, initialValue) {
  const previous = shallowRef(initialValue);
  watch(toRef(value), (_, oldValue) => {
    previous.value = oldValue;
  }, {
    flush: "sync"
  });
  return readonly(previous);
}
const topVarName = "--vueuse-safe-area-top";
const rightVarName = "--vueuse-safe-area-right";
const bottomVarName = "--vueuse-safe-area-bottom";
const leftVarName = "--vueuse-safe-area-left";
function useScreenSafeArea() {
  const top = ref("");
  const right = ref("");
  const bottom = ref("");
  const left = ref("");
  if (isClient) {
    const topCssVar = useCssVar(topVarName);
    const rightCssVar = useCssVar(rightVarName);
    const bottomCssVar = useCssVar(bottomVarName);
    const leftCssVar = useCssVar(leftVarName);
    topCssVar.value = "env(safe-area-inset-top, 0px)";
    rightCssVar.value = "env(safe-area-inset-right, 0px)";
    bottomCssVar.value = "env(safe-area-inset-bottom, 0px)";
    leftCssVar.value = "env(safe-area-inset-left, 0px)";
    update();
    useEventListener("resize", useDebounceFn(update));
  }
  function update() {
    top.value = getValue(topVarName);
    right.value = getValue(rightVarName);
    bottom.value = getValue(bottomVarName);
    left.value = getValue(leftVarName);
  }
  return {
    top,
    right,
    bottom,
    left,
    update
  };
}
function getValue(position) {
  return getComputedStyle(document.documentElement).getPropertyValue(position);
}
function useScriptTag(src) {
  let onLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _options$immediate9 = options.immediate,
    immediate = _options$immediate9 === void 0 ? true : _options$immediate9,
    _options$manual = options.manual,
    manual = _options$manual === void 0 ? false : _options$manual,
    _options$type2 = options.type,
    type = _options$type2 === void 0 ? "text/javascript" : _options$type2,
    _options$async = options.async,
    async = _options$async === void 0 ? true : _options$async,
    crossOrigin = options.crossOrigin,
    referrerPolicy = options.referrerPolicy,
    noModule = options.noModule,
    defer = options.defer,
    _options$document9 = options.document,
    document = _options$document9 === void 0 ? defaultDocument : _options$document9,
    _options$attrs = options.attrs,
    attrs = _options$attrs === void 0 ? {} : _options$attrs;
  const scriptTag = ref(null);
  let _promise = null;
  const loadScript = waitForScriptLoad => new Promise((resolve, reject) => {
    const resolveWithElement = el2 => {
      scriptTag.value = el2;
      resolve(el2);
      return el2;
    };
    if (!document) {
      resolve(false);
      return;
    }
    let shouldAppend = false;
    let el = document.querySelector("script[src=\"".concat(toValue(src), "\"]"));
    if (!el) {
      el = document.createElement("script");
      el.type = type;
      el.async = async;
      el.src = toValue(src);
      if (defer) el.defer = defer;
      if (crossOrigin) el.crossOrigin = crossOrigin;
      if (noModule) el.noModule = noModule;
      if (referrerPolicy) el.referrerPolicy = referrerPolicy;
      Object.entries(attrs).forEach(_ref33 => {
        let _ref34 = _slicedToArray(_ref33, 2),
          name = _ref34[0],
          value = _ref34[1];
        return el == null ? void 0 : el.setAttribute(name, value);
      });
      shouldAppend = true;
    } else if (el.hasAttribute("data-loaded")) {
      resolveWithElement(el);
    }
    el.addEventListener("error", event => reject(event));
    el.addEventListener("abort", event => reject(event));
    el.addEventListener("load", () => {
      el.setAttribute("data-loaded", "true");
      onLoaded(el);
      resolveWithElement(el);
    });
    if (shouldAppend) el = document.head.appendChild(el);
    if (!waitForScriptLoad) resolveWithElement(el);
  });
  const load = function load() {
    let waitForScriptLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!_promise) _promise = loadScript(waitForScriptLoad);
    return _promise;
  };
  const unload = () => {
    if (!document) return;
    _promise = null;
    if (scriptTag.value) scriptTag.value = null;
    const el = document.querySelector("script[src=\"".concat(toValue(src), "\"]"));
    if (el) document.head.removeChild(el);
  };
  if (immediate && !manual) tryOnMounted(load);
  if (!manual) tryOnUnmounted(unload);
  return {
    scriptTag,
    load,
    unload
  };
}
function checkOverflowScroll(ele) {
  const style = window.getComputedStyle(ele);
  if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientWidth < ele.scrollWidth || style.overflowY === "auto" && ele.clientHeight < ele.scrollHeight) {
    return true;
  } else {
    const parent = ele.parentNode;
    if (!parent || parent.tagName === "BODY") return false;
    return checkOverflowScroll(parent);
  }
}
function preventDefault(rawEvent) {
  const e = rawEvent || window.event;
  const _target = e.target;
  if (checkOverflowScroll(_target)) return false;
  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
}
const elInitialOverflow = /* @__PURE__ */new WeakMap();
function useScrollLock(element) {
  let initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const isLocked = ref(initialState);
  let stopTouchMoveListener = null;
  let initialOverflow = "";
  watch(toRef(element), el => {
    const target = resolveElement(toValue(el));
    if (target) {
      const ele = target;
      if (!elInitialOverflow.get(ele)) elInitialOverflow.set(ele, ele.style.overflow);
      if (ele.style.overflow !== "hidden") initialOverflow = ele.style.overflow;
      if (ele.style.overflow === "hidden") return isLocked.value = true;
      if (isLocked.value) return ele.style.overflow = "hidden";
    }
  }, {
    immediate: true
  });
  const lock = () => {
    const el = resolveElement(toValue(element));
    if (!el || isLocked.value) return;
    if (isIOS) {
      stopTouchMoveListener = useEventListener(el, "touchmove", e => {
        preventDefault(e);
      }, {
        passive: false
      });
    }
    el.style.overflow = "hidden";
    isLocked.value = true;
  };
  const unlock = () => {
    const el = resolveElement(toValue(element));
    if (!el || !isLocked.value) return;
    isIOS && (stopTouchMoveListener == null ? void 0 : stopTouchMoveListener());
    el.style.overflow = initialOverflow;
    elInitialOverflow.delete(el);
    isLocked.value = false;
  };
  tryOnScopeDispose(unlock);
  return computed({
    get() {
      return isLocked.value;
    },
    set(v) {
      if (v) lock();else unlock();
    }
  });
}
function useSessionStorage(key, initialValue) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _options$window35 = options.window,
    window = _options$window35 === void 0 ? defaultWindow : _options$window35;
  return useStorage(key, initialValue, window == null ? void 0 : window.sessionStorage, options);
}
function useShare() {
  let shareOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$navigator9 = options.navigator,
    navigator = _options$navigator9 === void 0 ? defaultNavigator : _options$navigator9;
  const _navigator = navigator;
  const isSupported = useSupported(() => _navigator && "canShare" in _navigator);
  const share = async function share() {
    let overrideOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (isSupported.value) {
      const data = _objectSpread(_objectSpread({}, toValue(shareOptions)), toValue(overrideOptions));
      let granted = true;
      if (data.files && _navigator.canShare) granted = _navigator.canShare({
        files: data.files
      });
      if (granted) return _navigator.share(data);
    }
  };
  return {
    isSupported,
    share
  };
}
const defaultSortFn = (source, compareFn) => source.sort(compareFn);
const defaultCompare = (a, b) => a - b;
function useSorted() {
  var _a, _b, _c, _d;
  for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }
  const source = args[0];
  let compareFn = defaultCompare;
  let options = {};
  if (args.length === 2) {
    if (typeof args[1] === "object") {
      options = args[1];
      compareFn = (_a = options.compareFn) != null ? _a : defaultCompare;
    } else {
      compareFn = (_b = args[1]) != null ? _b : defaultCompare;
    }
  } else if (args.length > 2) {
    compareFn = (_c = args[1]) != null ? _c : defaultCompare;
    options = (_d = args[2]) != null ? _d : {};
  }
  const _options6 = options,
    _options6$dirty = _options6.dirty,
    dirty = _options6$dirty === void 0 ? false : _options6$dirty,
    _options6$sortFn = _options6.sortFn,
    sortFn = _options6$sortFn === void 0 ? defaultSortFn : _options6$sortFn;
  if (!dirty) return computed(() => sortFn([...toValue(source)], compareFn));
  watchEffect(() => {
    const result = sortFn(toValue(source), compareFn);
    if (isRef(source)) source.value = result;else source.splice(0, source.length, ...result);
  });
  return source;
}
function useSpeechRecognition() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$interimResul = options.interimResults,
    interimResults = _options$interimResul === void 0 ? true : _options$interimResul,
    _options$continuous = options.continuous,
    continuous = _options$continuous === void 0 ? true : _options$continuous,
    _options$window36 = options.window,
    window = _options$window36 === void 0 ? defaultWindow : _options$window36;
  const lang = toRef(options.lang || "en-US");
  const isListening = ref(false);
  const isFinal = ref(false);
  const result = ref("");
  const error = shallowRef(void 0);
  const toggle = function toggle() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !isListening.value;
    isListening.value = value;
  };
  const start = () => {
    isListening.value = true;
  };
  const stop = () => {
    isListening.value = false;
  };
  const SpeechRecognition = window && (window.SpeechRecognition || window.webkitSpeechRecognition);
  const isSupported = useSupported(() => SpeechRecognition);
  let recognition;
  if (isSupported.value) {
    recognition = new SpeechRecognition();
    recognition.continuous = continuous;
    recognition.interimResults = interimResults;
    recognition.lang = toValue(lang);
    recognition.onstart = () => {
      isFinal.value = false;
    };
    watch(lang, lang2 => {
      if (recognition && !isListening.value) recognition.lang = lang2;
    });
    recognition.onresult = event => {
      const currentResult = event.results[event.resultIndex];
      const transcript = currentResult[0].transcript;
      isFinal.value = currentResult.isFinal;
      result.value = transcript;
      error.value = void 0;
    };
    recognition.onerror = event => {
      error.value = event;
    };
    recognition.onend = () => {
      isListening.value = false;
      recognition.lang = toValue(lang);
    };
    watch(isListening, () => {
      if (isListening.value) recognition.start();else recognition.stop();
    });
  }
  tryOnScopeDispose(() => {
    isListening.value = false;
  });
  return {
    isSupported,
    isListening,
    isFinal,
    recognition,
    result,
    error,
    toggle,
    start,
    stop
  };
}
function useSpeechSynthesis(text) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$pitch = options.pitch,
    pitch = _options$pitch === void 0 ? 1 : _options$pitch,
    _options$rate = options.rate,
    rate = _options$rate === void 0 ? 1 : _options$rate,
    _options$volume = options.volume,
    volume = _options$volume === void 0 ? 1 : _options$volume,
    _options$window37 = options.window,
    window = _options$window37 === void 0 ? defaultWindow : _options$window37;
  const synth = window && window.speechSynthesis;
  const isSupported = useSupported(() => synth);
  const isPlaying = ref(false);
  const status = ref("init");
  const spokenText = toRef(text || "");
  const lang = toRef(options.lang || "en-US");
  const error = shallowRef(void 0);
  const toggle = function toggle() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !isPlaying.value;
    isPlaying.value = value;
  };
  const bindEventsForUtterance = utterance2 => {
    utterance2.lang = toValue(lang);
    utterance2.voice = toValue(options.voice) || null;
    utterance2.pitch = toValue(pitch);
    utterance2.rate = toValue(rate);
    utterance2.volume = volume;
    utterance2.onstart = () => {
      isPlaying.value = true;
      status.value = "play";
    };
    utterance2.onpause = () => {
      isPlaying.value = false;
      status.value = "pause";
    };
    utterance2.onresume = () => {
      isPlaying.value = true;
      status.value = "play";
    };
    utterance2.onend = () => {
      isPlaying.value = false;
      status.value = "end";
    };
    utterance2.onerror = event => {
      error.value = event;
    };
  };
  const utterance = computed(() => {
    isPlaying.value = false;
    status.value = "init";
    const newUtterance = new SpeechSynthesisUtterance(spokenText.value);
    bindEventsForUtterance(newUtterance);
    return newUtterance;
  });
  const speak = () => {
    synth.cancel();
    utterance && synth.speak(utterance.value);
  };
  const stop = () => {
    synth.cancel();
    isPlaying.value = false;
  };
  if (isSupported.value) {
    bindEventsForUtterance(utterance.value);
    watch(lang, lang2 => {
      if (utterance.value && !isPlaying.value) utterance.value.lang = lang2;
    });
    if (options.voice) {
      watch(options.voice, () => {
        synth.cancel();
      });
    }
    watch(isPlaying, () => {
      if (isPlaying.value) synth.resume();else synth.pause();
    });
  }
  tryOnScopeDispose(() => {
    isPlaying.value = false;
  });
  return {
    isSupported,
    isPlaying,
    status,
    utterance,
    error,
    stop,
    toggle,
    speak
  };
}
function useStepper(steps, initialStep) {
  const stepsRef = ref(steps);
  const stepNames = computed(() => Array.isArray(stepsRef.value) ? stepsRef.value : Object.keys(stepsRef.value));
  const index = ref(stepNames.value.indexOf(initialStep != null ? initialStep : stepNames.value[0]));
  const current = computed(() => at(index.value));
  const isFirst = computed(() => index.value === 0);
  const isLast = computed(() => index.value === stepNames.value.length - 1);
  const next = computed(() => stepNames.value[index.value + 1]);
  const previous = computed(() => stepNames.value[index.value - 1]);
  function at(index2) {
    if (Array.isArray(stepsRef.value)) return stepsRef.value[index2];
    return stepsRef.value[stepNames.value[index2]];
  }
  function get(step) {
    if (!stepNames.value.includes(step)) return;
    return at(stepNames.value.indexOf(step));
  }
  function goTo(step) {
    if (stepNames.value.includes(step)) index.value = stepNames.value.indexOf(step);
  }
  function goToNext() {
    if (isLast.value) return;
    index.value++;
  }
  function goToPrevious() {
    if (isFirst.value) return;
    index.value--;
  }
  function goBackTo(step) {
    if (isAfter(step)) goTo(step);
  }
  function isNext(step) {
    return stepNames.value.indexOf(step) === index.value + 1;
  }
  function isPrevious(step) {
    return stepNames.value.indexOf(step) === index.value - 1;
  }
  function isCurrent(step) {
    return stepNames.value.indexOf(step) === index.value;
  }
  function isBefore(step) {
    return index.value < stepNames.value.indexOf(step);
  }
  function isAfter(step) {
    return index.value > stepNames.value.indexOf(step);
  }
  return {
    steps: stepsRef,
    stepNames,
    index,
    current,
    next,
    previous,
    isFirst,
    isLast,
    at,
    get,
    goTo,
    goToNext,
    goToPrevious,
    goBackTo,
    isNext,
    isPrevious,
    isCurrent,
    isBefore,
    isAfter
  };
}
function useStorageAsync(key, initialValue, storage) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a;
  const _options$flush3 = options.flush,
    flush = _options$flush3 === void 0 ? "pre" : _options$flush3,
    _options$deep5 = options.deep,
    deep = _options$deep5 === void 0 ? true : _options$deep5,
    _options$listenToStor3 = options.listenToStorageChanges,
    listenToStorageChanges = _options$listenToStor3 === void 0 ? true : _options$listenToStor3,
    _options$writeDefault2 = options.writeDefaults,
    writeDefaults = _options$writeDefault2 === void 0 ? true : _options$writeDefault2,
    _options$mergeDefault2 = options.mergeDefaults,
    mergeDefaults = _options$mergeDefault2 === void 0 ? false : _options$mergeDefault2,
    shallow = options.shallow,
    _options$window38 = options.window,
    window = _options$window38 === void 0 ? defaultWindow : _options$window38,
    eventFilter = options.eventFilter,
    _options$onError3 = options.onError,
    onError = _options$onError3 === void 0 ? e => {
      console.error(e);
    } : _options$onError3;
  const rawInit = toValue(initialValue);
  const type = guessSerializerType(rawInit);
  const data = (shallow ? shallowRef : ref)(initialValue);
  const serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];
  if (!storage) {
    try {
      storage = getSSRHandler("getDefaultStorageAsync", () => {
        var _a2;
        return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
      })();
    } catch (e) {
      onError(e);
    }
  }
  async function read(event) {
    if (!storage || event && event.key !== key) return;
    try {
      const rawValue = event ? event.newValue : await storage.getItem(key);
      if (rawValue == null) {
        data.value = rawInit;
        if (writeDefaults && rawInit !== null) await storage.setItem(key, await serializer.write(rawInit));
      } else if (mergeDefaults) {
        const value = await serializer.read(rawValue);
        if (typeof mergeDefaults === "function") data.value = mergeDefaults(value, rawInit);else if (type === "object" && !Array.isArray(value)) data.value = _objectSpread(_objectSpread({}, rawInit), value);else data.value = value;
      } else {
        data.value = await serializer.read(rawValue);
      }
    } catch (e) {
      onError(e);
    }
  }
  read();
  if (window && listenToStorageChanges) useEventListener(window, "storage", e => Promise.resolve().then(() => read(e)));
  if (storage) {
    watchWithFilter(data, async () => {
      try {
        if (data.value == null) await storage.removeItem(key);else await storage.setItem(key, await serializer.write(data.value));
      } catch (e) {
        onError(e);
      }
    }, {
      flush,
      deep,
      eventFilter
    });
  }
  return data;
}
let _id = 0;
function useStyleTag(css) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const isLoaded = ref(false);
  const _options$document10 = options.document,
    document = _options$document10 === void 0 ? defaultDocument : _options$document10,
    _options$immediate10 = options.immediate,
    immediate = _options$immediate10 === void 0 ? true : _options$immediate10,
    _options$manual2 = options.manual,
    manual = _options$manual2 === void 0 ? false : _options$manual2,
    _options$id = options.id,
    id = _options$id === void 0 ? "vueuse_styletag_".concat(++_id) : _options$id;
  const cssRef = ref(css);
  let stop = () => {};
  const load = () => {
    if (!document) return;
    const el = document.getElementById(id) || document.createElement("style");
    if (!el.isConnected) {
      el.id = id;
      if (options.media) el.media = options.media;
      document.head.appendChild(el);
    }
    if (isLoaded.value) return;
    stop = watch(cssRef, value => {
      el.textContent = value;
    }, {
      immediate: true
    });
    isLoaded.value = true;
  };
  const unload = () => {
    if (!document || !isLoaded.value) return;
    stop();
    document.head.removeChild(document.getElementById(id));
    isLoaded.value = false;
  };
  if (immediate && !manual) tryOnMounted(load);
  if (!manual) tryOnScopeDispose(unload);
  return {
    id,
    css: cssRef,
    unload,
    load,
    isLoaded: readonly(isLoaded)
  };
}
function useSwipe(target) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$threshold4 = options.threshold,
    threshold = _options$threshold4 === void 0 ? 50 : _options$threshold4,
    onSwipe = options.onSwipe,
    onSwipeEnd = options.onSwipeEnd,
    onSwipeStart = options.onSwipeStart,
    _options$passive2 = options.passive,
    passive = _options$passive2 === void 0 ? true : _options$passive2,
    _options$window39 = options.window,
    window = _options$window39 === void 0 ? defaultWindow : _options$window39;
  const coordsStart = reactive({
    x: 0,
    y: 0
  });
  const coordsEnd = reactive({
    x: 0,
    y: 0
  });
  const diffX = computed(() => coordsStart.x - coordsEnd.x);
  const diffY = computed(() => coordsStart.y - coordsEnd.y);
  const max = Math.max,
    abs = Math.abs;
  const isThresholdExceeded = computed(() => max(abs(diffX.value), abs(diffY.value)) >= threshold);
  const isSwiping = ref(false);
  const direction = computed(() => {
    if (!isThresholdExceeded.value) return "none";
    if (abs(diffX.value) > abs(diffY.value)) {
      return diffX.value > 0 ? "left" : "right";
    } else {
      return diffY.value > 0 ? "up" : "down";
    }
  });
  const getTouchEventCoords = e => [e.touches[0].clientX, e.touches[0].clientY];
  const updateCoordsStart = (x, y) => {
    coordsStart.x = x;
    coordsStart.y = y;
  };
  const updateCoordsEnd = (x, y) => {
    coordsEnd.x = x;
    coordsEnd.y = y;
  };
  let listenerOptions;
  const isPassiveEventSupported = checkPassiveEventSupport(window == null ? void 0 : window.document);
  if (!passive) listenerOptions = isPassiveEventSupported ? {
    passive: false,
    capture: true
  } : {
    capture: true
  };else listenerOptions = isPassiveEventSupported ? {
    passive: true
  } : {
    capture: false
  };
  const onTouchEnd = e => {
    if (isSwiping.value) onSwipeEnd == null ? void 0 : onSwipeEnd(e, direction.value);
    isSwiping.value = false;
  };
  const stops = [useEventListener(target, "touchstart", e => {
    if (e.touches.length !== 1) return;
    if (listenerOptions.capture && !listenerOptions.passive) e.preventDefault();
    const _getTouchEventCoords = getTouchEventCoords(e),
      _getTouchEventCoords2 = _slicedToArray(_getTouchEventCoords, 2),
      x = _getTouchEventCoords2[0],
      y = _getTouchEventCoords2[1];
    updateCoordsStart(x, y);
    updateCoordsEnd(x, y);
    onSwipeStart == null ? void 0 : onSwipeStart(e);
  }, listenerOptions), useEventListener(target, "touchmove", e => {
    if (e.touches.length !== 1) return;
    const _getTouchEventCoords3 = getTouchEventCoords(e),
      _getTouchEventCoords4 = _slicedToArray(_getTouchEventCoords3, 2),
      x = _getTouchEventCoords4[0],
      y = _getTouchEventCoords4[1];
    updateCoordsEnd(x, y);
    if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
    if (isSwiping.value) onSwipe == null ? void 0 : onSwipe(e);
  }, listenerOptions), useEventListener(target, ["touchend", "touchcancel"], onTouchEnd, listenerOptions)];
  const stop = () => stops.forEach(s => s());
  return {
    isPassiveEventSupported,
    isSwiping,
    direction,
    coordsStart,
    coordsEnd,
    lengthX: diffX,
    lengthY: diffY,
    stop
  };
}
function checkPassiveEventSupport(document) {
  if (!document) return false;
  let supportsPassive = false;
  const optionsBlock = {
    get passive() {
      supportsPassive = true;
      return false;
    }
  };
  document.addEventListener("x", noop, optionsBlock);
  document.removeEventListener("x", noop);
  return supportsPassive;
}
function useTemplateRefsList() {
  const refs = ref([]);
  refs.value.set = el => {
    if (el) refs.value.push(el);
  };
  onBeforeUpdate(() => {
    refs.value.length = 0;
  });
  return refs;
}
function useTextDirection() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$document11 = options.document,
    document = _options$document11 === void 0 ? defaultDocument : _options$document11,
    _options$selector2 = options.selector,
    selector = _options$selector2 === void 0 ? "html" : _options$selector2,
    _options$observe2 = options.observe,
    observe = _options$observe2 === void 0 ? false : _options$observe2,
    _options$initialValue7 = options.initialValue,
    initialValue = _options$initialValue7 === void 0 ? "ltr" : _options$initialValue7;
  function getValue() {
    var _a, _b;
    return (_b = (_a = document == null ? void 0 : document.querySelector(selector)) == null ? void 0 : _a.getAttribute("dir")) != null ? _b : initialValue;
  }
  const dir = ref(getValue());
  tryOnMounted(() => dir.value = getValue());
  if (observe && document) {
    useMutationObserver(document.querySelector(selector), () => dir.value = getValue(), {
      attributes: true
    });
  }
  return computed({
    get() {
      return dir.value;
    },
    set(v) {
      var _a, _b;
      dir.value = v;
      if (!document) return;
      if (dir.value) (_a = document.querySelector(selector)) == null ? void 0 : _a.setAttribute("dir", dir.value);else (_b = document.querySelector(selector)) == null ? void 0 : _b.removeAttribute("dir");
    }
  });
}
function getRangesFromSelection(selection) {
  var _a;
  const rangeCount = (_a = selection.rangeCount) != null ? _a : 0;
  return Array.from({
    length: rangeCount
  }, (_, i) => selection.getRangeAt(i));
}
function useTextSelection() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window40 = options.window,
    window = _options$window40 === void 0 ? defaultWindow : _options$window40;
  const selection = ref(null);
  const text = computed(() => {
    var _a, _b;
    return (_b = (_a = selection.value) == null ? void 0 : _a.toString()) != null ? _b : "";
  });
  const ranges = computed(() => selection.value ? getRangesFromSelection(selection.value) : []);
  const rects = computed(() => ranges.value.map(range => range.getBoundingClientRect()));
  function onSelectionChange() {
    selection.value = null;
    if (window) selection.value = window.getSelection();
  }
  if (window) useEventListener(window.document, "selectionchange", onSelectionChange);
  return {
    text,
    rects,
    ranges,
    selection
  };
}
function useTextareaAutosize(options) {
  var _a;
  const textarea = ref(options == null ? void 0 : options.element);
  const input = ref(options == null ? void 0 : options.input);
  const styleProp = (_a = options == null ? void 0 : options.styleProp) != null ? _a : "height";
  const textareaScrollHeight = ref(1);
  function triggerResize() {
    var _a2;
    if (!textarea.value) return;
    let height = "";
    textarea.value.style[styleProp] = "1px";
    textareaScrollHeight.value = (_a2 = textarea.value) == null ? void 0 : _a2.scrollHeight;
    if (options == null ? void 0 : options.styleTarget) toValue(options.styleTarget).style[styleProp] = "".concat(textareaScrollHeight.value, "px");else height = "".concat(textareaScrollHeight.value, "px");
    textarea.value.style[styleProp] = height;
  }
  watch([input, textarea], () => nextTick(triggerResize), {
    immediate: true
  });
  watch(textareaScrollHeight, () => {
    var _a2;
    return (_a2 = options == null ? void 0 : options.onResize) == null ? void 0 : _a2.call(options);
  });
  useResizeObserver(textarea, () => triggerResize());
  if (options == null ? void 0 : options.watch) watch(options.watch, triggerResize, {
    immediate: true,
    deep: true
  });
  return {
    textarea,
    input,
    triggerResize
  };
}
function useThrottledRefHistory(source) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$throttle2 = options.throttle,
    throttle = _options$throttle2 === void 0 ? 200 : _options$throttle2,
    _options$trailing = options.trailing,
    trailing = _options$trailing === void 0 ? true : _options$trailing;
  const filter = throttleFilter(throttle, trailing);
  const history = useRefHistory(source, _objectSpread(_objectSpread({}, options), {}, {
    eventFilter: filter
  }));
  return _objectSpread({}, history);
}
const DEFAULT_UNITS = [{
  max: 6e4,
  value: 1e3,
  name: "second"
}, {
  max: 276e4,
  value: 6e4,
  name: "minute"
}, {
  max: 72e6,
  value: 36e5,
  name: "hour"
}, {
  max: 5184e5,
  value: 864e5,
  name: "day"
}, {
  max: 24192e5,
  value: 6048e5,
  name: "week"
}, {
  max: 28512e6,
  value: 2592e6,
  name: "month"
}, {
  max: Number.POSITIVE_INFINITY,
  value: 31536e6,
  name: "year"
}];
const DEFAULT_MESSAGES = {
  justNow: "just now",
  past: n => n.match(/\d/) ? "".concat(n, " ago") : n,
  future: n => n.match(/\d/) ? "in ".concat(n) : n,
  month: (n, past) => n === 1 ? past ? "last month" : "next month" : "".concat(n, " month").concat(n > 1 ? "s" : ""),
  year: (n, past) => n === 1 ? past ? "last year" : "next year" : "".concat(n, " year").concat(n > 1 ? "s" : ""),
  day: (n, past) => n === 1 ? past ? "yesterday" : "tomorrow" : "".concat(n, " day").concat(n > 1 ? "s" : ""),
  week: (n, past) => n === 1 ? past ? "last week" : "next week" : "".concat(n, " week").concat(n > 1 ? "s" : ""),
  hour: n => "".concat(n, " hour").concat(n > 1 ? "s" : ""),
  minute: n => "".concat(n, " minute").concat(n > 1 ? "s" : ""),
  second: n => "".concat(n, " second").concat(n > 1 ? "s" : ""),
  invalid: ""
};
function DEFAULT_FORMATTER(date) {
  return date.toISOString().slice(0, 10);
}
function useTimeAgo(time) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$controls3 = options.controls,
    exposeControls = _options$controls3 === void 0 ? false : _options$controls3,
    _options$updateInterv = options.updateInterval,
    updateInterval = _options$updateInterv === void 0 ? 3e4 : _options$updateInterv;
  const _useNow = useNow({
      interval: updateInterval,
      controls: true
    }),
    now = _useNow.now,
    controls = _objectWithoutProperties(_useNow, _excluded4);
  const timeAgo = computed(() => formatTimeAgo(new Date(toValue(time)), options, toValue(now)));
  if (exposeControls) {
    return _objectSpread({
      timeAgo
    }, controls);
  } else {
    return timeAgo;
  }
}
function formatTimeAgo(from) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var _a;
  const max = options.max,
    _options$messages = options.messages,
    messages = _options$messages === void 0 ? DEFAULT_MESSAGES : _options$messages,
    _options$fullDateForm = options.fullDateFormatter,
    fullDateFormatter = _options$fullDateForm === void 0 ? DEFAULT_FORMATTER : _options$fullDateForm,
    _options$units = options.units,
    units = _options$units === void 0 ? DEFAULT_UNITS : _options$units,
    _options$showSecond = options.showSecond,
    showSecond = _options$showSecond === void 0 ? false : _options$showSecond,
    _options$rounding = options.rounding,
    rounding = _options$rounding === void 0 ? "round" : _options$rounding;
  const roundFn = typeof rounding === "number" ? n => +n.toFixed(rounding) : Math[rounding];
  const diff = +now - +from;
  const absDiff = Math.abs(diff);
  function getValue(diff2, unit) {
    return roundFn(Math.abs(diff2) / unit.value);
  }
  function format(diff2, unit) {
    const val = getValue(diff2, unit);
    const past = diff2 > 0;
    const str = applyFormat(unit.name, val, past);
    return applyFormat(past ? "past" : "future", str, past);
  }
  function applyFormat(name, val, isPast) {
    const formatter = messages[name];
    if (typeof formatter === "function") return formatter(val, isPast);
    return formatter.replace("{0}", val.toString());
  }
  if (absDiff < 6e4 && !showSecond) return messages.justNow;
  if (typeof max === "number" && absDiff > max) return fullDateFormatter(new Date(from));
  if (typeof max === "string") {
    const unitMax = (_a = units.find(i => i.name === max)) == null ? void 0 : _a.max;
    if (unitMax && absDiff > unitMax) return fullDateFormatter(new Date(from));
  }
  for (const _ref35 of units.entries()) {
    var _ref36 = _slicedToArray(_ref35, 2);
    const idx = _ref36[0];
    const unit = _ref36[1];
    const val = getValue(diff, unit);
    if (val <= 0 && units[idx - 1]) return format(diff, units[idx - 1]);
    if (absDiff < unit.max) return format(diff, unit);
  }
  return messages.invalid;
}
function useTimeoutPoll(fn, interval, timeoutPollOptions) {
  const _useTimeoutFn = useTimeoutFn(loop, interval, {
      immediate: false
    }),
    start = _useTimeoutFn.start;
  const isActive = ref(false);
  async function loop() {
    if (!isActive.value) return;
    await fn();
    start();
  }
  function resume() {
    if (!isActive.value) {
      isActive.value = true;
      loop();
    }
  }
  function pause() {
    isActive.value = false;
  }
  if (timeoutPollOptions == null ? void 0 : timeoutPollOptions.immediate) resume();
  tryOnScopeDispose(pause);
  return {
    isActive,
    pause,
    resume
  };
}
function useTimestamp() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$controls4 = options.controls,
    exposeControls = _options$controls4 === void 0 ? false : _options$controls4,
    _options$offset2 = options.offset,
    offset = _options$offset2 === void 0 ? 0 : _options$offset2,
    _options$immediate11 = options.immediate,
    immediate = _options$immediate11 === void 0 ? true : _options$immediate11,
    _options$interval5 = options.interval,
    interval = _options$interval5 === void 0 ? "requestAnimationFrame" : _options$interval5,
    callback = options.callback;
  const ts = ref(timestamp() + offset);
  const update = () => ts.value = timestamp() + offset;
  const cb = callback ? () => {
    update();
    callback(ts.value);
  } : update;
  const controls = interval === "requestAnimationFrame" ? useRafFn(cb, {
    immediate
  }) : useIntervalFn(cb, interval, {
    immediate
  });
  if (exposeControls) {
    return _objectSpread({
      timestamp: ts
    }, controls);
  } else {
    return ts;
  }
}
function useTitle() {
  let newTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a, _b, _c;
  const _options$document12 = options.document,
    document = _options$document12 === void 0 ? defaultDocument : _options$document12,
    _options$restoreOnUnm = options.restoreOnUnmount,
    restoreOnUnmount = _options$restoreOnUnm === void 0 ? t => t : _options$restoreOnUnm;
  const originalTitle = (_a = document == null ? void 0 : document.title) != null ? _a : "";
  const title = toRef((_b = newTitle != null ? newTitle : document == null ? void 0 : document.title) != null ? _b : null);
  const isReadonly = newTitle && typeof newTitle === "function";
  function format(t) {
    if (!("titleTemplate" in options)) return t;
    const template = options.titleTemplate || "%s";
    return typeof template === "function" ? template(t) : toValue(template).replace(/%s/g, t);
  }
  watch(title, (t, o) => {
    if (t !== o && document) document.title = format(typeof t === "string" ? t : "");
  }, {
    immediate: true
  });
  if (options.observe && !options.titleTemplate && document && !isReadonly) {
    useMutationObserver((_c = document.head) == null ? void 0 : _c.querySelector("title"), () => {
      if (document && document.title !== title.value) title.value = format(document.title);
    }, {
      childList: true
    });
  }
  tryOnBeforeUnmount(() => {
    if (restoreOnUnmount) {
      const restoredTitle = restoreOnUnmount(originalTitle, title.value || "");
      if (restoredTitle != null && document) document.title = restoredTitle;
    }
  });
  return title;
}
const _TransitionPresets = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
const TransitionPresets = /* @__PURE__ */Object.assign({}, {
  linear: identity
}, _TransitionPresets);
function createEasingFunction(_ref37) {
  let _ref38 = _slicedToArray(_ref37, 4),
    p0 = _ref38[0],
    p1 = _ref38[1],
    p2 = _ref38[2],
    p3 = _ref38[3];
  const a = (a1, a2) => 1 - 3 * a2 + 3 * a1;
  const b = (a1, a2) => 3 * a2 - 6 * a1;
  const c = a1 => 3 * a1;
  const calcBezier = (t, a1, a2) => ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
  const getSlope = (t, a1, a2) => 3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1);
  const getTforX = x => {
    let aGuessT = x;
    for (let i = 0; i < 4; ++i) {
      const currentSlope = getSlope(aGuessT, p0, p2);
      if (currentSlope === 0) return aGuessT;
      const currentX = calcBezier(aGuessT, p0, p2) - x;
      aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
  };
  return x => p0 === p1 && p2 === p3 ? x : calcBezier(getTforX(x), p1, p3);
}
function lerp(a, b, alpha) {
  return a + alpha * (b - a);
}
function toVec(t) {
  return (typeof t === "number" ? [t] : t) || [];
}
function executeTransition(source, from, to) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a, _b;
  const fromVal = toValue(from);
  const toVal = toValue(to);
  const v1 = toVec(fromVal);
  const v2 = toVec(toVal);
  const duration = (_a = toValue(options.duration)) != null ? _a : 1e3;
  const startedAt = Date.now();
  const endAt = Date.now() + duration;
  const trans = typeof options.transition === "function" ? options.transition : (_b = toValue(options.transition)) != null ? _b : identity;
  const ease = typeof trans === "function" ? trans : createEasingFunction(trans);
  return new Promise(resolve => {
    source.value = fromVal;
    const tick = () => {
      var _a2;
      if ((_a2 = options.abort) == null ? void 0 : _a2.call(options)) {
        resolve();
        return;
      }
      const now = Date.now();
      const alpha = ease((now - startedAt) / duration);
      const arr = toVec(source.value).map((n, i) => lerp(v1[i], v2[i], alpha));
      if (Array.isArray(source.value)) source.value = arr.map((n, i) => {
        var _a3, _b2;
        return lerp((_a3 = v1[i]) != null ? _a3 : 0, (_b2 = v2[i]) != null ? _b2 : 0, alpha);
      });else if (typeof source.value === "number") source.value = arr[0];
      if (now < endAt) {
        requestAnimationFrame(tick);
      } else {
        source.value = toVal;
        resolve();
      }
    };
    tick();
  });
}
function useTransition(source) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let currentId = 0;
  const sourceVal = () => {
    const v = toValue(source);
    return typeof v === "number" ? v : v.map(toValue);
  };
  const outputRef = ref(sourceVal());
  watch(sourceVal, async to => {
    var _a, _b;
    if (toValue(options.disabled)) return;
    const id = ++currentId;
    if (options.delay) await promiseTimeout(toValue(options.delay));
    if (id !== currentId) return;
    const toVal = Array.isArray(to) ? to.map(toValue) : toValue(to);
    (_a = options.onStarted) == null ? void 0 : _a.call(options);
    await executeTransition(outputRef, outputRef.value, toVal, _objectSpread(_objectSpread({}, options), {}, {
      abort: () => {
        var _a2;
        return id !== currentId || ((_a2 = options.abort) == null ? void 0 : _a2.call(options));
      }
    }));
    (_b = options.onFinished) == null ? void 0 : _b.call(options);
  }, {
    deep: true
  });
  watch(() => toValue(options.disabled), disabled => {
    if (disabled) {
      currentId++;
      outputRef.value = sourceVal();
    }
  });
  tryOnScopeDispose(() => {
    currentId++;
  });
  return computed(() => toValue(options.disabled) ? sourceVal() : outputRef.value);
}
function useUrlSearchParams() {
  let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "history";
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$initialValue8 = options.initialValue,
    initialValue = _options$initialValue8 === void 0 ? {} : _options$initialValue8,
    _options$removeNullis = options.removeNullishValues,
    removeNullishValues = _options$removeNullis === void 0 ? true : _options$removeNullis,
    _options$removeFalsyV = options.removeFalsyValues,
    removeFalsyValues = _options$removeFalsyV === void 0 ? false : _options$removeFalsyV,
    _options$write = options.write,
    enableWrite = _options$write === void 0 ? true : _options$write,
    _options$window41 = options.window,
    window = _options$window41 === void 0 ? defaultWindow : _options$window41;
  if (!window) return reactive(initialValue);
  const state = reactive({});
  function getRawParams() {
    if (mode === "history") {
      return window.location.search || "";
    } else if (mode === "hash") {
      const hash = window.location.hash || "";
      const index = hash.indexOf("?");
      return index > 0 ? hash.slice(index) : "";
    } else {
      return (window.location.hash || "").replace(/^#/, "");
    }
  }
  function constructQuery(params) {
    const stringified = params.toString();
    if (mode === "history") return "".concat(stringified ? "?".concat(stringified) : "").concat(window.location.hash || "");
    if (mode === "hash-params") return "".concat(window.location.search || "").concat(stringified ? "#".concat(stringified) : "");
    const hash = window.location.hash || "#";
    const index = hash.indexOf("?");
    if (index > 0) return "".concat(hash.slice(0, index)).concat(stringified ? "?".concat(stringified) : "");
    return "".concat(hash).concat(stringified ? "?".concat(stringified) : "");
  }
  function read() {
    return new URLSearchParams(getRawParams());
  }
  function updateState(params) {
    const unusedKeys = new Set(Object.keys(state));
    for (const key of params.keys()) {
      const paramsForKey = params.getAll(key);
      state[key] = paramsForKey.length > 1 ? paramsForKey : params.get(key) || "";
      unusedKeys.delete(key);
    }
    Array.from(unusedKeys).forEach(key => delete state[key]);
  }
  const _pausableWatch2 = pausableWatch(state, () => {
      const params = new URLSearchParams("");
      Object.keys(state).forEach(key => {
        const mapEntry = state[key];
        if (Array.isArray(mapEntry)) mapEntry.forEach(value => params.append(key, value));else if (removeNullishValues && mapEntry == null) params.delete(key);else if (removeFalsyValues && !mapEntry) params.delete(key);else params.set(key, mapEntry);
      });
      write(params);
    }, {
      deep: true
    }),
    pause = _pausableWatch2.pause,
    resume = _pausableWatch2.resume;
  function write(params, shouldUpdate) {
    pause();
    if (shouldUpdate) updateState(params);
    window.history.replaceState(window.history.state, window.document.title, window.location.pathname + constructQuery(params));
    resume();
  }
  function onChanged() {
    if (!enableWrite) return;
    write(read(), true);
  }
  useEventListener(window, "popstate", onChanged, false);
  if (mode !== "history") useEventListener(window, "hashchange", onChanged, false);
  const initial = read();
  if (initial.keys().next().value) updateState(initial);else Object.assign(state, initialValue);
  return state;
}
function useUserMedia() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _a, _b;
  const enabled = ref((_a = options.enabled) != null ? _a : false);
  const autoSwitch = ref((_b = options.autoSwitch) != null ? _b : true);
  const constraints = ref(options.constraints);
  const _options$navigator10 = options.navigator,
    navigator = _options$navigator10 === void 0 ? defaultNavigator : _options$navigator10;
  const isSupported = useSupported(() => {
    var _a2;
    return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getUserMedia;
  });
  const stream = shallowRef();
  function getDeviceOptions(type) {
    switch (type) {
      case "video":
        {
          if (constraints.value) return constraints.value.video || false;
          break;
        }
      case "audio":
        {
          if (constraints.value) return constraints.value.audio || false;
          break;
        }
    }
  }
  async function _start() {
    if (!isSupported.value || stream.value) return;
    stream.value = await navigator.mediaDevices.getUserMedia({
      video: getDeviceOptions("video"),
      audio: getDeviceOptions("audio")
    });
    return stream.value;
  }
  function _stop() {
    var _a2;
    (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(t => t.stop());
    stream.value = void 0;
  }
  function stop() {
    _stop();
    enabled.value = false;
  }
  async function start() {
    await _start();
    if (stream.value) enabled.value = true;
    return stream.value;
  }
  async function restart() {
    _stop();
    return await start();
  }
  watch(enabled, v => {
    if (v) _start();else _stop();
  }, {
    immediate: true
  });
  watch(constraints, () => {
    if (autoSwitch.value && stream.value) restart();
  }, {
    immediate: true
  });
  tryOnScopeDispose(() => {
    stop();
  });
  return {
    isSupported,
    stream,
    start,
    stop,
    restart,
    constraints,
    enabled,
    autoSwitch
  };
}
function useVModel(props, key, emit) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _a, _b, _c, _d, _e;
  const _options$clone3 = options.clone,
    clone = _options$clone3 === void 0 ? false : _options$clone3,
    _options$passive3 = options.passive,
    passive = _options$passive3 === void 0 ? false : _options$passive3,
    eventName = options.eventName,
    _options$deep6 = options.deep,
    deep = _options$deep6 === void 0 ? false : _options$deep6,
    defaultValue = options.defaultValue,
    shouldEmit = options.shouldEmit;
  const vm = getCurrentInstance();
  const _emit = emit || (vm == null ? void 0 : vm.emit) || ((_a = vm == null ? void 0 : vm.$emit) == null ? void 0 : _a.bind(vm)) || ((_c = (_b = vm == null ? void 0 : vm.proxy) == null ? void 0 : _b.$emit) == null ? void 0 : _c.bind(vm == null ? void 0 : vm.proxy));
  let event = eventName;
  if (!key) {
    if (isVue2) {
      const modelOptions = (_e = (_d = vm == null ? void 0 : vm.proxy) == null ? void 0 : _d.$options) == null ? void 0 : _e.model;
      key = (modelOptions == null ? void 0 : modelOptions.value) || "value";
      if (!eventName) event = (modelOptions == null ? void 0 : modelOptions.event) || "input";
    } else {
      key = "modelValue";
    }
  }
  event = event || "update:".concat(key.toString());
  const cloneFn = val => !clone ? val : typeof clone === "function" ? clone(val) : cloneFnJSON(val);
  const getValue = () => isDef(props[key]) ? cloneFn(props[key]) : defaultValue;
  const triggerEmit = value => {
    if (shouldEmit) {
      if (shouldEmit(value)) _emit(event, value);
    } else {
      _emit(event, value);
    }
  };
  if (passive) {
    const initialValue = getValue();
    const proxy = ref(initialValue);
    let isUpdating = false;
    watch(() => props[key], v => {
      if (!isUpdating) {
        isUpdating = true;
        proxy.value = cloneFn(v);
        nextTick(() => isUpdating = false);
      }
    });
    watch(proxy, v => {
      if (!isUpdating && (v !== props[key] || deep)) triggerEmit(v);
    }, {
      deep
    });
    return proxy;
  } else {
    return computed({
      get() {
        return getValue();
      },
      set(value) {
        triggerEmit(value);
      }
    });
  }
}
function useVModels(props, emit) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const ret = {};
  for (const key in props) {
    ret[key] = useVModel(props, key, emit, options);
  }
  return ret;
}
function useVibrate(options) {
  const _ref39 = options || {},
    _ref39$pattern = _ref39.pattern,
    pattern = _ref39$pattern === void 0 ? [] : _ref39$pattern,
    _ref39$interval = _ref39.interval,
    interval = _ref39$interval === void 0 ? 0 : _ref39$interval,
    _ref39$navigator = _ref39.navigator,
    navigator = _ref39$navigator === void 0 ? defaultNavigator : _ref39$navigator;
  const isSupported = useSupported(() => typeof navigator !== "undefined" && "vibrate" in navigator);
  const patternRef = toRef(pattern);
  let intervalControls;
  const vibrate = function vibrate() {
    let pattern2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : patternRef.value;
    if (isSupported.value) navigator.vibrate(pattern2);
  };
  const stop = () => {
    if (isSupported.value) navigator.vibrate(0);
    intervalControls == null ? void 0 : intervalControls.pause();
  };
  if (interval > 0) {
    intervalControls = useIntervalFn(vibrate, interval, {
      immediate: false,
      immediateCallback: false
    });
  }
  return {
    isSupported,
    pattern,
    intervalControls,
    vibrate,
    stop
  };
}
function useVirtualList(list, options) {
  const _ref40 = "itemHeight" in options ? useVerticalVirtualList(options, list) : useHorizontalVirtualList(options, list),
    containerStyle = _ref40.containerStyle,
    wrapperProps = _ref40.wrapperProps,
    scrollTo = _ref40.scrollTo,
    calculateRange = _ref40.calculateRange,
    currentList = _ref40.currentList,
    containerRef = _ref40.containerRef;
  return {
    list: currentList,
    scrollTo,
    containerProps: {
      ref: containerRef,
      onScroll: () => {
        calculateRange();
      },
      style: containerStyle
    },
    wrapperProps
  };
}
function useVirtualListResources(list) {
  const containerRef = ref(null);
  const size = useElementSize(containerRef);
  const currentList = ref([]);
  const source = shallowRef(list);
  const state = ref({
    start: 0,
    end: 10
  });
  return {
    state,
    source,
    currentList,
    size,
    containerRef
  };
}
function createGetViewCapacity(state, source, itemSize) {
  return containerSize => {
    if (typeof itemSize === "number") return Math.ceil(containerSize / itemSize);
    const _state$value$start = state.value.start,
      start = _state$value$start === void 0 ? 0 : _state$value$start;
    let sum = 0;
    let capacity = 0;
    for (let i = start; i < source.value.length; i++) {
      const size = itemSize(i);
      sum += size;
      capacity = i;
      if (sum > containerSize) break;
    }
    return capacity - start;
  };
}
function createGetOffset(source, itemSize) {
  return scrollDirection => {
    if (typeof itemSize === "number") return Math.floor(scrollDirection / itemSize) + 1;
    let sum = 0;
    let offset = 0;
    for (let i = 0; i < source.value.length; i++) {
      const size = itemSize(i);
      sum += size;
      if (sum >= scrollDirection) {
        offset = i;
        break;
      }
    }
    return offset + 1;
  };
}
function createCalculateRange(type, overscan, getOffset, getViewCapacity, _ref41) {
  let containerRef = _ref41.containerRef,
    state = _ref41.state,
    currentList = _ref41.currentList,
    source = _ref41.source;
  return () => {
    const element = containerRef.value;
    if (element) {
      const offset = getOffset(type === "vertical" ? element.scrollTop : element.scrollLeft);
      const viewCapacity = getViewCapacity(type === "vertical" ? element.clientHeight : element.clientWidth);
      const from = offset - overscan;
      const to = offset + viewCapacity + overscan;
      state.value = {
        start: from < 0 ? 0 : from,
        end: to > source.value.length ? source.value.length : to
      };
      currentList.value = source.value.slice(state.value.start, state.value.end).map((ele, index) => ({
        data: ele,
        index: index + state.value.start
      }));
    }
  };
}
function createGetDistance(itemSize, source) {
  return index => {
    if (typeof itemSize === "number") {
      const size2 = index * itemSize;
      return size2;
    }
    const size = source.value.slice(0, index).reduce((sum, _, i) => sum + itemSize(i), 0);
    return size;
  };
}
function useWatchForSizes(size, list, containerRef, calculateRange) {
  watch([size.width, size.height, list, containerRef], () => {
    calculateRange();
  });
}
function createComputedTotalSize(itemSize, source) {
  return computed(() => {
    if (typeof itemSize === "number") return source.value.length * itemSize;
    return source.value.reduce((sum, _, index) => sum + itemSize(index), 0);
  });
}
const scrollToDictionaryForElementScrollKey = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function createScrollTo(type, calculateRange, getDistance, containerRef) {
  return index => {
    if (containerRef.value) {
      containerRef.value[scrollToDictionaryForElementScrollKey[type]] = getDistance(index);
      calculateRange();
    }
  };
}
function useHorizontalVirtualList(options, list) {
  const resources = useVirtualListResources(list);
  const state = resources.state,
    source = resources.source,
    currentList = resources.currentList,
    size = resources.size,
    containerRef = resources.containerRef;
  const containerStyle = {
    overflowX: "auto"
  };
  const itemWidth = options.itemWidth,
    _options$overscan = options.overscan,
    overscan = _options$overscan === void 0 ? 5 : _options$overscan;
  const getViewCapacity = createGetViewCapacity(state, source, itemWidth);
  const getOffset = createGetOffset(source, itemWidth);
  const calculateRange = createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
  const getDistanceLeft = createGetDistance(itemWidth, source);
  const offsetLeft = computed(() => getDistanceLeft(state.value.start));
  const totalWidth = createComputedTotalSize(itemWidth, source);
  useWatchForSizes(size, list, containerRef, calculateRange);
  const scrollTo = createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
  const wrapperProps = computed(() => {
    return {
      style: {
        height: "100%",
        width: "".concat(totalWidth.value - offsetLeft.value, "px"),
        marginLeft: "".concat(offsetLeft.value, "px"),
        display: "flex"
      }
    };
  });
  return {
    scrollTo,
    calculateRange,
    wrapperProps,
    containerStyle,
    currentList,
    containerRef
  };
}
function useVerticalVirtualList(options, list) {
  const resources = useVirtualListResources(list);
  const state = resources.state,
    source = resources.source,
    currentList = resources.currentList,
    size = resources.size,
    containerRef = resources.containerRef;
  const containerStyle = {
    overflowY: "auto"
  };
  const itemHeight = options.itemHeight,
    _options$overscan2 = options.overscan,
    overscan = _options$overscan2 === void 0 ? 5 : _options$overscan2;
  const getViewCapacity = createGetViewCapacity(state, source, itemHeight);
  const getOffset = createGetOffset(source, itemHeight);
  const calculateRange = createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
  const getDistanceTop = createGetDistance(itemHeight, source);
  const offsetTop = computed(() => getDistanceTop(state.value.start));
  const totalHeight = createComputedTotalSize(itemHeight, source);
  useWatchForSizes(size, list, containerRef, calculateRange);
  const scrollTo = createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
  const wrapperProps = computed(() => {
    return {
      style: {
        width: "100%",
        height: "".concat(totalHeight.value - offsetTop.value, "px"),
        marginTop: "".concat(offsetTop.value, "px")
      }
    };
  });
  return {
    calculateRange,
    scrollTo,
    containerStyle,
    wrapperProps,
    currentList,
    containerRef
  };
}
function useWakeLock() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$navigator11 = options.navigator,
    navigator = _options$navigator11 === void 0 ? defaultNavigator : _options$navigator11,
    _options$document13 = options.document,
    document = _options$document13 === void 0 ? defaultDocument : _options$document13;
  let wakeLock;
  const isSupported = useSupported(() => navigator && "wakeLock" in navigator);
  const isActive = ref(false);
  async function onVisibilityChange() {
    if (!isSupported.value || !wakeLock) return;
    if (document && document.visibilityState === "visible") wakeLock = await navigator.wakeLock.request("screen");
    isActive.value = !wakeLock.released;
  }
  if (document) useEventListener(document, "visibilitychange", onVisibilityChange, {
    passive: true
  });
  async function request(type) {
    if (!isSupported.value) return;
    wakeLock = await navigator.wakeLock.request(type);
    isActive.value = !wakeLock.released;
  }
  async function release() {
    if (!isSupported.value || !wakeLock) return;
    await wakeLock.release();
    isActive.value = !wakeLock.released;
    wakeLock = null;
  }
  return {
    isSupported,
    isActive,
    request,
    release
  };
}
function useWebNotification() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window42 = options.window,
    window = _options$window42 === void 0 ? defaultWindow : _options$window42,
    _options$requestPermi2 = options.requestPermissions,
    _requestForPermissions = _options$requestPermi2 === void 0 ? true : _options$requestPermi2;
  const defaultWebNotificationOptions = options;
  const isSupported = useSupported(() => {
    if (!window || !("Notification" in window)) return false;
    try {
      new Notification("");
    } catch (e) {
      return false;
    }
    return true;
  });
  const permissionGranted = ref(isSupported.value && "permission" in Notification && Notification.permission === "granted");
  const notification = ref(null);
  const ensurePermissions = async () => {
    if (!isSupported.value) return;
    if (!permissionGranted.value && Notification.permission !== "denied") {
      const result = await Notification.requestPermission();
      if (result === "granted") permissionGranted.value = true;
    }
    return permissionGranted.value;
  };
  const _createEventHook2 = createEventHook(),
    onClick = _createEventHook2.on,
    clickTrigger = _createEventHook2.trigger;
  const _createEventHook3 = createEventHook(),
    onShow = _createEventHook3.on,
    showTrigger = _createEventHook3.trigger;
  const _createEventHook4 = createEventHook(),
    onError = _createEventHook4.on,
    errorTrigger = _createEventHook4.trigger;
  const _createEventHook5 = createEventHook(),
    onClose = _createEventHook5.on,
    closeTrigger = _createEventHook5.trigger;
  const show = async overrides => {
    if (!isSupported.value || !permissionGranted.value) return;
    const options2 = Object.assign({}, defaultWebNotificationOptions, overrides);
    notification.value = new Notification(options2.title || "", options2);
    notification.value.onclick = clickTrigger;
    notification.value.onshow = showTrigger;
    notification.value.onerror = errorTrigger;
    notification.value.onclose = closeTrigger;
    return notification.value;
  };
  const close = () => {
    if (notification.value) notification.value.close();
    notification.value = null;
  };
  if (_requestForPermissions) tryOnMounted(ensurePermissions);
  tryOnScopeDispose(close);
  if (isSupported.value && window) {
    const document = window.document;
    useEventListener(document, "visibilitychange", e => {
      e.preventDefault();
      if (document.visibilityState === "visible") {
        close();
      }
    });
  }
  return {
    isSupported,
    notification,
    ensurePermissions,
    permissionGranted,
    show,
    close,
    onClick,
    onShow,
    onError,
    onClose
  };
}
const DEFAULT_PING_MESSAGE = "ping";
function resolveNestedOptions(options) {
  if (options === true) return {};
  return options;
}
function useWebSocket(url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const onConnected = options.onConnected,
    onDisconnected = options.onDisconnected,
    onError = options.onError,
    onMessage = options.onMessage,
    _options$immediate12 = options.immediate,
    immediate = _options$immediate12 === void 0 ? true : _options$immediate12,
    _options$autoClose = options.autoClose,
    autoClose = _options$autoClose === void 0 ? true : _options$autoClose,
    _options$protocols = options.protocols,
    protocols = _options$protocols === void 0 ? [] : _options$protocols;
  const data = ref(null);
  const status = ref("CLOSED");
  const wsRef = ref();
  const urlRef = toRef(url);
  let heartbeatPause;
  let heartbeatResume;
  let explicitlyClosed = false;
  let retried = 0;
  let bufferedData = [];
  let pongTimeoutWait;
  const _sendBuffer = () => {
    if (bufferedData.length && wsRef.value && status.value === "OPEN") {
      for (const buffer of bufferedData) wsRef.value.send(buffer);
      bufferedData = [];
    }
  };
  const resetHeartbeat = () => {
    clearTimeout(pongTimeoutWait);
    pongTimeoutWait = void 0;
  };
  const close = function close() {
    let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
    let reason = arguments.length > 1 ? arguments[1] : undefined;
    if (!isClient || !wsRef.value) return;
    explicitlyClosed = true;
    resetHeartbeat();
    heartbeatPause == null ? void 0 : heartbeatPause();
    wsRef.value.close(code, reason);
    wsRef.value = void 0;
  };
  const send = function send(data2) {
    let useBuffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!wsRef.value || status.value !== "OPEN") {
      if (useBuffer) bufferedData.push(data2);
      return false;
    }
    _sendBuffer();
    wsRef.value.send(data2);
    return true;
  };
  const _init = () => {
    if (explicitlyClosed || typeof urlRef.value === "undefined") return;
    const ws = new WebSocket(urlRef.value, protocols);
    wsRef.value = ws;
    status.value = "CONNECTING";
    ws.onopen = () => {
      status.value = "OPEN";
      onConnected == null ? void 0 : onConnected(ws);
      heartbeatResume == null ? void 0 : heartbeatResume();
      _sendBuffer();
    };
    ws.onclose = ev => {
      status.value = "CLOSED";
      onDisconnected == null ? void 0 : onDisconnected(ws, ev);
      if (!explicitlyClosed && options.autoReconnect) {
        const _resolveNestedOptions4 = resolveNestedOptions(options.autoReconnect),
          _resolveNestedOptions5 = _resolveNestedOptions4.retries,
          retries = _resolveNestedOptions5 === void 0 ? -1 : _resolveNestedOptions5,
          _resolveNestedOptions6 = _resolveNestedOptions4.delay,
          delay = _resolveNestedOptions6 === void 0 ? 1e3 : _resolveNestedOptions6,
          onFailed = _resolveNestedOptions4.onFailed;
        retried += 1;
        if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);else if (typeof retries === "function" && retries()) setTimeout(_init, delay);else onFailed == null ? void 0 : onFailed();
      }
    };
    ws.onerror = e => {
      onError == null ? void 0 : onError(ws, e);
    };
    ws.onmessage = e => {
      if (options.heartbeat) {
        resetHeartbeat();
        const _resolveNestedOptions7 = resolveNestedOptions(options.heartbeat),
          _resolveNestedOptions8 = _resolveNestedOptions7.message,
          message = _resolveNestedOptions8 === void 0 ? DEFAULT_PING_MESSAGE : _resolveNestedOptions8;
        if (e.data === message) return;
      }
      data.value = e.data;
      onMessage == null ? void 0 : onMessage(ws, e);
    };
  };
  if (options.heartbeat) {
    const _resolveNestedOptions9 = resolveNestedOptions(options.heartbeat),
      _resolveNestedOptions10 = _resolveNestedOptions9.message,
      message = _resolveNestedOptions10 === void 0 ? DEFAULT_PING_MESSAGE : _resolveNestedOptions10,
      _resolveNestedOptions11 = _resolveNestedOptions9.interval,
      interval = _resolveNestedOptions11 === void 0 ? 1e3 : _resolveNestedOptions11,
      _resolveNestedOptions12 = _resolveNestedOptions9.pongTimeout,
      pongTimeout = _resolveNestedOptions12 === void 0 ? 1e3 : _resolveNestedOptions12;
    const _useIntervalFn = useIntervalFn(() => {
        send(message, false);
        if (pongTimeoutWait != null) return;
        pongTimeoutWait = setTimeout(() => {
          close();
          explicitlyClosed = false;
        }, pongTimeout);
      }, interval, {
        immediate: false
      }),
      pause = _useIntervalFn.pause,
      resume = _useIntervalFn.resume;
    heartbeatPause = pause;
    heartbeatResume = resume;
  }
  if (autoClose) {
    if (isClient) useEventListener("beforeunload", () => close());
    tryOnScopeDispose(close);
  }
  const open = () => {
    if (!isClient && !isWorker) return;
    close();
    explicitlyClosed = false;
    retried = 0;
    _init();
  };
  if (immediate) open();
  watch(urlRef, open);
  return {
    data,
    status,
    close,
    send,
    open,
    ws: wsRef
  };
}
function useWebWorker(arg0, workerOptions, options) {
  const _ref42 = options != null ? options : {},
    _ref42$window = _ref42.window,
    window = _ref42$window === void 0 ? defaultWindow : _ref42$window;
  const data = ref(null);
  const worker = shallowRef();
  const post = function post() {
    if (!worker.value) return;
    worker.value.postMessage(...arguments);
  };
  const terminate = function terminate2() {
    if (!worker.value) return;
    worker.value.terminate();
  };
  if (window) {
    if (typeof arg0 === "string") worker.value = new Worker(arg0, workerOptions);else if (typeof arg0 === "function") worker.value = arg0();else worker.value = arg0;
    worker.value.onmessage = e => {
      data.value = e.data;
    };
    tryOnScopeDispose(() => {
      if (worker.value) worker.value.terminate();
    });
  }
  return {
    data,
    post,
    terminate,
    worker
  };
}
function jobRunner(userFunc) {
  return e => {
    const userFuncArgs = e.data[0];
    return Promise.resolve(userFunc.apply(void 0, userFuncArgs)).then(result => {
      postMessage(["SUCCESS", result]);
    }).catch(error => {
      postMessage(["ERROR", error]);
    });
  };
}
function depsParser(deps, localDeps) {
  if (deps.length === 0 && localDeps.length === 0) return "";
  const depsString = deps.map(dep => "'".concat(dep, "'")).toString();
  const depsFunctionString = localDeps.filter(dep => typeof dep === "function").map(fn => {
    const str = fn.toString();
    if (str.trim().startsWith("function")) {
      return str;
    } else {
      const name = fn.name;
      return "const ".concat(name, " = ").concat(str);
    }
  }).join(";");
  const importString = "importScripts(".concat(depsString, ");");
  return "".concat(depsString.trim() === "" ? "" : importString, " ").concat(depsFunctionString);
}
function createWorkerBlobUrl(fn, deps, localDeps) {
  const blobCode = "".concat(depsParser(deps, localDeps), "; onmessage=(").concat(jobRunner, ")(").concat(fn, ")");
  const blob = new Blob([blobCode], {
    type: "text/javascript"
  });
  const url = URL.createObjectURL(blob);
  return url;
}
function useWebWorkerFn(fn) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const _options$dependencies = options.dependencies,
    dependencies = _options$dependencies === void 0 ? [] : _options$dependencies,
    _options$localDepende = options.localDependencies,
    localDependencies = _options$localDepende === void 0 ? [] : _options$localDepende,
    timeout = options.timeout,
    _options$window43 = options.window,
    window = _options$window43 === void 0 ? defaultWindow : _options$window43;
  const worker = ref();
  const workerStatus = ref("PENDING");
  const promise = ref({});
  const timeoutId = ref();
  const workerTerminate = function workerTerminate() {
    let status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "PENDING";
    if (worker.value && worker.value._url && window) {
      worker.value.terminate();
      URL.revokeObjectURL(worker.value._url);
      promise.value = {};
      worker.value = void 0;
      window.clearTimeout(timeoutId.value);
      workerStatus.value = status;
    }
  };
  workerTerminate();
  tryOnScopeDispose(workerTerminate);
  const generateWorker = () => {
    const blobUrl = createWorkerBlobUrl(fn, dependencies, localDependencies);
    const newWorker = new Worker(blobUrl);
    newWorker._url = blobUrl;
    newWorker.onmessage = e => {
      const _promise$value = promise.value,
        _promise$value$resolv = _promise$value.resolve,
        resolve = _promise$value$resolv === void 0 ? () => {} : _promise$value$resolv,
        _promise$value$reject = _promise$value.reject,
        reject = _promise$value$reject === void 0 ? () => {} : _promise$value$reject;
      const _e$data = _slicedToArray(e.data, 2),
        status = _e$data[0],
        result = _e$data[1];
      switch (status) {
        case "SUCCESS":
          resolve(result);
          workerTerminate(status);
          break;
        default:
          reject(result);
          workerTerminate("ERROR");
          break;
      }
    };
    newWorker.onerror = e => {
      const _promise$value$reject2 = promise.value.reject,
        reject = _promise$value$reject2 === void 0 ? () => {} : _promise$value$reject2;
      e.preventDefault();
      reject(e);
      workerTerminate("ERROR");
    };
    if (timeout) {
      timeoutId.value = setTimeout(() => workerTerminate("TIMEOUT_EXPIRED"), timeout);
    }
    return newWorker;
  };
  const callWorker = function callWorker() {
    for (var _len12 = arguments.length, fnArgs = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      fnArgs[_key12] = arguments[_key12];
    }
    return new Promise((resolve, reject) => {
      promise.value = {
        resolve,
        reject
      };
      worker.value && worker.value.postMessage([[...fnArgs]]);
      workerStatus.value = "RUNNING";
    });
  };
  const workerFn = function workerFn() {
    if (workerStatus.value === "RUNNING") {
      console.error("[useWebWorkerFn] You can only run one instance of the worker at a time.");
      return Promise.reject();
    }
    worker.value = generateWorker();
    return callWorker(...arguments);
  };
  return {
    workerFn,
    workerStatus,
    workerTerminate
  };
}
function useWindowFocus() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window44 = options.window,
    window = _options$window44 === void 0 ? defaultWindow : _options$window44;
  if (!window) return ref(false);
  const focused = ref(window.document.hasFocus());
  useEventListener(window, "blur", () => {
    focused.value = false;
  });
  useEventListener(window, "focus", () => {
    focused.value = true;
  });
  return focused;
}
function useWindowScroll() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window45 = options.window,
    window = _options$window45 === void 0 ? defaultWindow : _options$window45,
    _options$behavior2 = options.behavior,
    behavior = _options$behavior2 === void 0 ? "auto" : _options$behavior2;
  if (!window) {
    return {
      x: ref(0),
      y: ref(0)
    };
  }
  const internalX = ref(window.scrollX);
  const internalY = ref(window.scrollY);
  const x = computed({
    get() {
      return internalX.value;
    },
    set(x2) {
      scrollTo({
        left: x2,
        behavior
      });
    }
  });
  const y = computed({
    get() {
      return internalY.value;
    },
    set(y2) {
      scrollTo({
        top: y2,
        behavior
      });
    }
  });
  useEventListener(window, "scroll", () => {
    internalX.value = window.scrollX;
    internalY.value = window.scrollY;
  }, {
    capture: false,
    passive: true
  });
  return {
    x,
    y
  };
}
function useWindowSize() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _options$window46 = options.window,
    window = _options$window46 === void 0 ? defaultWindow : _options$window46,
    _options$initialWidth = options.initialWidth,
    initialWidth = _options$initialWidth === void 0 ? Number.POSITIVE_INFINITY : _options$initialWidth,
    _options$initialHeigh = options.initialHeight,
    initialHeight = _options$initialHeigh === void 0 ? Number.POSITIVE_INFINITY : _options$initialHeigh,
    _options$listenOrient = options.listenOrientation,
    listenOrientation = _options$listenOrient === void 0 ? true : _options$listenOrient,
    _options$includeScrol = options.includeScrollbar,
    includeScrollbar = _options$includeScrol === void 0 ? true : _options$includeScrol;
  const width = ref(initialWidth);
  const height = ref(initialHeight);
  const update = () => {
    if (window) {
      if (includeScrollbar) {
        width.value = window.innerWidth;
        height.value = window.innerHeight;
      } else {
        width.value = window.document.documentElement.clientWidth;
        height.value = window.document.documentElement.clientHeight;
      }
    }
  };
  update();
  tryOnMounted(update);
  useEventListener("resize", update, {
    passive: true
  });
  if (listenOrientation) {
    const matches = useMediaQuery("(orientation: portrait)");
    watch(matches, () => update());
  }
  return {
    width,
    height
  };
}
export { DefaultMagicKeysAliasMap, StorageSerializers, TransitionPresets, computedAsync as asyncComputed, breakpointsAntDesign, breakpointsBootstrapV5, breakpointsMasterCss, breakpointsPrimeFlex, breakpointsQuasar, breakpointsSematic, breakpointsTailwind, breakpointsVuetify, breakpointsVuetifyV2, breakpointsVuetifyV3, cloneFnJSON, computedAsync, computedInject, createFetch, createReusableTemplate, createTemplatePromise, createUnrefFn, customStorageEventName, defaultDocument, defaultLocation, defaultNavigator, defaultWindow, executeTransition, formatTimeAgo, getSSRHandler, mapGamepadToXbox360Controller, onClickOutside, onKeyDown, onKeyPressed, onKeyStroke, onKeyUp, onLongPress, onStartTyping, setSSRHandler, templateRef, unrefElement, useActiveElement, useAnimate, useAsyncQueue, useAsyncState, useBase64, useBattery, useBluetooth, useBreakpoints, useBroadcastChannel, useBrowserLocation, useCached, useClipboard, useClipboardItems, useCloned, useColorMode, useConfirmDialog, useCssVar, useCurrentElement, useCycleList, useDark, useDebouncedRefHistory, useDeviceMotion, useDeviceOrientation, useDevicePixelRatio, useDevicesList, useDisplayMedia, useDocumentVisibility, useDraggable, useDropZone, useElementBounding, useElementByPoint, useElementHover, useElementSize, useElementVisibility, useEventBus, useEventListener, useEventSource, useEyeDropper, useFavicon, useFetch, useFileDialog, useFileSystemAccess, useFocus, useFocusWithin, useFps, useFullscreen, useGamepad, useGeolocation, useIdle, useImage, useInfiniteScroll, useIntersectionObserver, useKeyModifier, useLocalStorage, useMagicKeys, useManualRefHistory, useMediaControls, useMediaQuery, useMemoize, useMemory, useMounted, useMouse, useMouseInElement, useMousePressed, useMutationObserver, useNavigatorLanguage, useNetwork, useNow, useObjectUrl, useOffsetPagination, useOnline, usePageLeave, useParallax, useParentElement, usePerformanceObserver, usePermission, usePointer, usePointerLock, usePointerSwipe, usePreferredColorScheme, usePreferredContrast, usePreferredDark, usePreferredLanguages, usePreferredReducedMotion, usePrevious, useRafFn, useRefHistory, useResizeObserver, useScreenOrientation, useScreenSafeArea, useScriptTag, useScroll, useScrollLock, useSessionStorage, useShare, useSorted, useSpeechRecognition, useSpeechSynthesis, useStepper, useStorage, useStorageAsync, useStyleTag, useSupported, useSwipe, useTemplateRefsList, useTextDirection, useTextSelection, useTextareaAutosize, useThrottledRefHistory, useTimeAgo, useTimeoutPoll, useTimestamp, useTitle, useTransition, useUrlSearchParams, useUserMedia, useVModel, useVModels, useVibrate, useVirtualList, useWakeLock, useWebNotification, useWebSocket, useWebWorker, useWebWorkerFn, useWindowFocus, useWindowScroll, useWindowSize };